// // import React, { useState, useEffect } from "react";
// // import { useLocation } from "react-router-dom";
// // import {
// //   Container,
// //   Typography,
// //   Box,
// //   Button,
// //   CircularProgress,
// //   Snackbar,
// //   Card,
// //   CardContent,
// //   Grid,
// //   Chip,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// // } from "@mui/material";
// // import { motion } from "framer-motion";
// // import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
// // import axios from "axios";

// // const CareerInsights = () => {
// //   const { state } = useLocation();
// //   const { learnerId, learner } = state || {};
// //   const [insightsData, setInsightsData] = useState(null);
// //   const [resultsData, setResultsData] = useState(null);
// //   const [interestsData, setInterestsData] = useState(null);
// //   const [detailedAnalysis, setDetailedAnalysis] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [snackbar, setSnackbar] = useState({
// //     open: false,
// //     message: "",
// //     severity: "success",
// //   });
// //   const [showAdviceModal, setShowAdviceModal] = useState(false);
// //   const [selectedCareer, setSelectedCareer] = useState(null);

// //   const cbcSubjectMappings = {
// //     "Number Work": "Mathematics",
// //     "Language/Total": "English Language",
// //     "Reading/Jumla": "English Language",
// //     "Kiswahili/Jumla": "Kiswahili Lugha",
// //     Creative: "Creative Arts",
// //     "Science and Environment": "Science & Technology",
// //     "Social Studies and Religious Education": "Social Studies",
// //     English: "English Language",
// //     Kiswahili: "Kiswahili Lugha",
// //     Mathematics: "Mathematics",
// //     Science: "Science & Technology",
// //     "Environmental Activities": "Science & Technology",
// //     "English Language": "English Language",
// //     "English Composition": "English Language",
// //     "Kiswahili Lugha": "Kiswahili Lugha",
// //     "Kiswahili Insha": "Kiswahili Lugha",
// //     "Science & Technology": "Science & Technology",
// //     Agriculture: "Agriculture",
// //     "Social Studies": "Social Studies",
// //     "Religious Education": "Religious Education",
// //     "Creative Arts": "Creative Arts",
// //     "Pre-Technical": "Pre-Technical",
// //     "Pre-Technical Studies": "Pre-Technical",
// //   };

// //   const interestCategories = {
// //     artistic: [
// //       "drawing",
// //       "painting",
// //       "music",
// //       "dancing",
// //       "singing",
// //       "acting",
// //       "writing",
// //       "poetry",
// //       "design",
// //       "creative",
// //       "art",
// //       "draw",
// //       "paint",
// //       "dance",
// //       "sing",
// //       "act",
// //       "write",
// //     ],
// //     scientific: [
// //       "science",
// //       "experiments",
// //       "math",
// //       "technology",
// //       "computers",
// //       "coding",
// //       "robotics",
// //       "invention",
// //       "research",
// //       "physics",
// //       "chemistry",
// //       "biology",
// //       "experiment",
// //       "computer",
// //       "code",
// //     ],
// //     social: [
// //       "helping",
// //       "teaching",
// //       "community",
// //       "teamwork",
// //       "volunteering",
// //       "counseling",
// //       "mentoring",
// //       "leadership",
// //       "help",
// //       "teach",
// //       "volunteer",
// //       "counsel",
// //       "mentor",
// //       "lead",
// //     ],
// //     enterprising: [
// //       "business",
// //       "selling",
// //       "entrepreneur",
// //       "managing",
// //       "organizing",
// //       "negotiating",
// //       "marketing",
// //       "sell",
// //       "manage",
// //       "organize",
// //       "negotiate",
// //       "market",
// //     ],
// //     conventional: [
// //       "organizing",
// //       "planning",
// //       "details",
// //       "rules",
// //       "accounting",
// //       "administrative",
// //       "systematic",
// //       "plan",
// //       "detail",
// //       "account",
// //       "admin",
// //     ],
// //     realistic: [
// //       "building",
// //       "fixing",
// //       "sports",
// //       "outdoors",
// //       "mechanical",
// //       "construction",
// //       "farming",
// //       "technical",
// //       "build",
// //       "fix",
// //       "sport",
// //       "outdoor",
// //       "mechanic",
// //       "construct",
// //       "farm",
// //       "football",
// //       "racing",
// //       "athletics",
// //     ],
// //   };

// //   const comprehensiveCareerMappings = {
// //     excellent: {
// //       Mathematics: [
// //         {
// //           career: "Actuary",
// //           confidence: 95,
// //           interestMatch: ["scientific", "conventional"],
// //           skills: ["Statistics", "Risk Analysis", "Mathematics"],
// //         },
// //         {
// //           career: "Data Scientist",
// //           confidence: 92,
// //           interestMatch: ["scientific", "analytical"],
// //           skills: ["Programming", "Machine Learning", "Statistics"],
// //         },
// //         {
// //           career: "Quantitative Analyst",
// //           confidence: 90,
// //           interestMatch: ["scientific", "enterprising"],
// //           skills: ["Financial Modeling", "Mathematics", "Programming"],
// //         },
// //         {
// //           career: "Cryptographer",
// //           confidence: 88,
// //           interestMatch: ["scientific", "analytical"],
// //           skills: ["Encryption", "Mathematics", "Security"],
// //         },
// //         {
// //           career: "Astrophysicist",
// //           confidence: 85,
// //           interestMatch: ["scientific", "research"],
// //           skills: ["Physics", "Mathematics", "Research"],
// //         },
// //       ],
// //       "English Language": [
// //         {
// //           career: "International Lawyer",
// //           confidence: 93,
// //           interestMatch: ["social", "enterprising"],
// //           skills: ["Legal Research", "Argumentation", "Communication"],
// //         },
// //         {
// //           career: "Diplomat",
// //           confidence: 90,
// //           interestMatch: ["social", "enterprising"],
// //           skills: ["Diplomacy", "Languages", "Negotiation"],
// //         },
// //         {
// //           career: "Content Strategist",
// //           confidence: 88,
// //           interestMatch: ["artistic", "enterprising"],
// //           skills: ["Content Creation", "SEO", "Strategy"],
// //         },
// //         {
// //           career: "Technical Writer",
// //           confidence: 85,
// //           interestMatch: ["artistic", "scientific"],
// //           skills: ["Writing", "Technical Knowledge", "Clarity"],
// //         },
// //         {
// //           career: "Public Relations Director",
// //           confidence: 82,
// //           interestMatch: ["social", "enterprising"],
// //           skills: ["Communication", "Strategy", "Media Relations"],
// //         },
// //       ],
// //       "Science & Technology": [
// //         {
// //           career: "Biomedical Engineer",
// //           confidence: 94,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Biology", "Engineering", "Design"],
// //         },
// //         {
// //           career: "AI Research Scientist",
// //           confidence: 92,
// //           interestMatch: ["scientific", "analytical"],
// //           skills: ["Machine Learning", "Programming", "Research"],
// //         },
// //         {
// //           career: "Renewable Energy Engineer",
// //           confidence: 89,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Engineering", "Sustainability", "Physics"],
// //         },
// //         {
// //           career: "Pharmaceutical Researcher",
// //           confidence: 87,
// //           interestMatch: ["scientific", "detailed"],
// //           skills: ["Chemistry", "Research", "Analysis"],
// //         },
// //         {
// //           career: "Environmental Scientist",
// //           confidence: 85,
// //           interestMatch: ["scientific", "social"],
// //           skills: ["Ecology", "Research", "Conservation"],
// //         },
// //       ],
// //       "Kiswahili Lugha": [
// //         {
// //           career: "Swahili Linguist",
// //           confidence: 89,
// //           interestMatch: ["artistic", "social"],
// //           skills: ["Linguistics", "Research", "Translation"],
// //         },
// //         {
// //           career: "International Translator",
// //           confidence: 86,
// //           interestMatch: ["artistic", "social"],
// //           skills: ["Languages", "Cultural Knowledge", "Translation"],
// //         },
// //         {
// //           career: "Cultural Affairs Officer",
// //           confidence: 83,
// //           interestMatch: ["social", "artistic"],
// //           skills: ["Cultural Knowledge", "Communication", "Event Planning"],
// //         },
// //         {
// //           career: "Foreign Correspondent",
// //           confidence: 80,
// //           interestMatch: ["artistic", "enterprising"],
// //           skills: ["Journalism", "Languages", "Reporting"],
// //         },
// //         {
// //           career: "Heritage Manager",
// //           confidence: 78,
// //           interestMatch: ["artistic", "social"],
// //           skills: ["Cultural Preservation", "Management", "Research"],
// //         },
// //       ],
// //       Agriculture: [
// //         {
// //           career: "Agricultural Economist",
// //           confidence: 87,
// //           interestMatch: ["scientific", "enterprising"],
// //           skills: ["Economics", "Agriculture", "Analysis"],
// //         },
// //         {
// //           career: "Food Scientist",
// //           confidence: 84,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Chemistry", "Quality Control", "Research"],
// //         },
// //         {
// //           career: "Agribusiness Manager",
// //           confidence: 82,
// //           interestMatch: ["enterprising", "scientific"],
// //           skills: ["Business", "Agriculture", "Management"],
// //         },
// //         {
// //           career: "Soil Scientist",
// //           confidence: 79,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Chemistry", "Research", "Analysis"],
// //         },
// //         {
// //           career: "Agricultural Engineer",
// //           confidence: 76,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Engineering", "Agriculture", "Design"],
// //         },
// //       ],
// //       "Social Studies": [
// //         {
// //           career: "Urban Planner",
// //           confidence: 85,
// //           interestMatch: ["social", "conventional"],
// //           skills: ["Planning", "Geography", "Community Engagement"],
// //         },
// //         {
// //           career: "Public Policy Analyst",
// //           confidence: 82,
// //           interestMatch: ["social", "analytical"],
// //           skills: ["Research", "Analysis", "Policy Development"],
// //         },
// //         {
// //           career: "International Development Specialist",
// //           confidence: 80,
// //           interestMatch: ["social", "enterprising"],
// //           skills: ["Development", "Project Management", "Community Work"],
// //         },
// //         {
// //           career: "Political Scientist",
// //           confidence: 78,
// //           interestMatch: ["social", "analytical"],
// //           skills: ["Research", "Analysis", "Political Systems"],
// //         },
// //         {
// //           career: "Human Rights Officer",
// //           confidence: 75,
// //           interestMatch: ["social", "artistic"],
// //           skills: ["Advocacy", "Research", "Communication"],
// //         },
// //       ],
// //       "Creative Arts": [
// //         {
// //           career: "Architect",
// //           confidence: 88,
// //           interestMatch: ["artistic", "realistic"],
// //           skills: ["Design", "Mathematics", "Spatial Awareness"],
// //         },
// //         {
// //           career: "Graphic Designer",
// //           confidence: 85,
// //           interestMatch: ["artistic", "technical"],
// //           skills: ["Design", "Software", "Creativity"],
// //         },
// //         {
// //           career: "Animation Director",
// //           confidence: 82,
// //           interestMatch: ["artistic", "technical"],
// //           skills: ["Animation", "Storytelling", "Design"],
// //         },
// //         {
// //           career: "Art Director",
// //           confidence: 80,
// //           interestMatch: ["artistic", "enterprising"],
// //           skills: ["Design", "Management", "Creativity"],
// //         },
// //         {
// //           career: "Museum Curator",
// //           confidence: 77,
// //           interestMatch: ["artistic", "social"],
// //           skills: ["Art History", "Exhibition Design", "Research"],
// //         },
// //       ],
// //       "Pre-Technical": [
// //         {
// //           career: "Civil Engineer",
// //           confidence: 92,
// //           interestMatch: ["realistic", "scientific"],
// //           skills: ["Mathematics", "Physics", "Design"],
// //         },
// //         {
// //           career: "Electrical Engineer",
// //           confidence: 89,
// //           interestMatch: ["realistic", "scientific"],
// //           skills: ["Electronics", "Mathematics", "Design"],
// //         },
// //         {
// //           career: "Mechanical Engineer",
// //           confidence: 87,
// //           interestMatch: ["realistic", "scientific"],
// //           skills: ["Mechanics", "Physics", "Design"],
// //         },
// //         {
// //           career: "Aerospace Engineer",
// //           confidence: 84,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Physics", "Mathematics", "Aerodynamics"],
// //         },
// //         {
// //           career: "Industrial Designer",
// //           confidence: 81,
// //           interestMatch: ["artistic", "realistic"],
// //           skills: ["Design", "Engineering", "Creativity"],
// //         },
// //       ],
// //     },
// //     good: {
// //       Mathematics: [
// //         {
// //           career: "Accounting Technician",
// //           confidence: 82,
// //           interestMatch: ["conventional", "detailed"],
// //           skills: ["Accounting", "Mathematics", "Excel"],
// //         },
// //         {
// //           career: "Insurance Underwriter",
// //           confidence: 79,
// //           interestMatch: ["conventional", "analytical"],
// //           skills: ["Risk Assessment", "Mathematics", "Analysis"],
// //         },
// //         {
// //           career: "Banking Officer",
// //           confidence: 76,
// //           interestMatch: ["conventional", "social"],
// //           skills: ["Banking", "Customer Service", "Finance"],
// //         },
// //         {
// //           career: "Data Analyst",
// //           confidence: 74,
// //           interestMatch: ["scientific", "conventional"],
// //           skills: ["Statistics", "Excel", "Analysis"],
// //         },
// //         {
// //           career: "Budget Analyst",
// //           confidence: 71,
// //           interestMatch: ["conventional", "analytical"],
// //           skills: ["Budgeting", "Analysis", "Mathematics"],
// //         },
// //       ],
// //       "English Language": [
// //         {
// //           career: "Journalist",
// //           confidence: 81,
// //           interestMatch: ["artistic", "social"],
// //           skills: ["Writing", "Research", "Communication"],
// //         },
// //         {
// //           career: "Public Relations Officer",
// //           confidence: 78,
// //           interestMatch: ["social", "enterprising"],
// //           skills: ["Communication", "Media Relations", "Writing"],
// //         },
// //         {
// //           career: "Administrative Officer",
// //           confidence: 75,
// //           interestMatch: ["conventional", "social"],
// //           skills: ["Organization", "Communication", "Record Keeping"],
// //         },
// //         {
// //           career: "Copywriter",
// //           confidence: 72,
// //           interestMatch: ["artistic", "enterprising"],
// //           skills: ["Writing", "Creativity", "Marketing"],
// //         },
// //         {
// //           career: "Editor",
// //           confidence: 69,
// //           interestMatch: ["artistic", "conventional"],
// //           skills: ["Editing", "Writing", "Attention to Detail"],
// //         },
// //       ],
// //       "Science & Technology": [
// //         {
// //           career: "Laboratory Technician",
// //           confidence: 80,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Science", "Technical Skills", "Attention to Detail"],
// //         },
// //         {
// //           career: "IT Support Specialist",
// //           confidence: 77,
// //           interestMatch: ["technical", "social"],
// //           skills: [
// //             "Technical Knowledge",
// //             "Problem-solving",
// //             "Customer Service",
// //           ],
// //         },
// //         {
// //           career: "Pharmacy Technician",
// //           confidence: 74,
// //           interestMatch: ["scientific", "conventional"],
// //           skills: ["Pharmacy", "Attention to Detail", "Customer Service"],
// //         },
// //         {
// //           career: "Quality Control Inspector",
// //           confidence: 71,
// //           interestMatch: ["conventional", "realistic"],
// //           skills: [
// //             "Quality Control",
// //             "Attention to Detail",
// //             "Technical Knowledge",
// //           ],
// //         },
// //         {
// //           career: "Environmental Technician",
// //           confidence: 68,
// //           interestMatch: ["scientific", "realistic"],
// //           skills: ["Environmental Science", "Field Work", "Analysis"],
// //         },
// //       ],
// //     },
// //     average: {
// //       Mathematics: [
// //         {
// //           career: "Bookkeeper",
// //           confidence: 68,
// //           interestMatch: ["conventional", "detailed"],
// //           skills: ["Bookkeeping", "Basic Math", "Organization"],
// //         },
// //         {
// //           career: "Sales Clerk",
// //           confidence: 65,
// //           interestMatch: ["social", "enterprising"],
// //           skills: ["Sales", "Customer Service", "Basic Math"],
// //         },
// //         {
// //           career: "Data Entry Clerk",
// //           confidence: 62,
// //           interestMatch: ["conventional", "detailed"],
// //           skills: ["Typing", "Attention to Detail", "Computer Skills"],
// //         },
// //         {
// //           career: "Retail Manager",
// //           confidence: 59,
// //           interestMatch: ["enterprising", "social"],
// //           skills: ["Management", "Customer Service", "Basic Math"],
// //         },
// //         {
// //           career: "Payroll Clerk",
// //           confidence: 56,
// //           interestMatch: ["conventional", "detailed"],
// //           skills: ["Payroll", "Mathematics", "Attention to Detail"],
// //         },
// //       ],
// //       "English Language": [
// //         {
// //           career: "Customer Service Representative",
// //           confidence: 70,
// //           interestMatch: ["social", "communicative"],
// //           skills: ["Communication", "Problem-solving", "Patience"],
// //         },
// //         {
// //           career: "Receptionist",
// //           confidence: 67,
// //           interestMatch: ["social", "conventional"],
// //           skills: ["Communication", "Organization", "Customer Service"],
// //         },
// //         {
// //           career: "Office Administrator",
// //           confidence: 64,
// //           interestMatch: ["conventional", "social"],
// //           skills: ["Administration", "Organization", "Communication"],
// //         },
// //         {
// //           career: "Call Center Agent",
// //           confidence: 61,
// //           interestMatch: ["social", "communicative"],
// //           skills: ["Communication", "Customer Service", "Patience"],
// //         },
// //         {
// //           career: "Hotel Front Desk Clerk",
// //           confidence: 58,
// //           interestMatch: ["social", "conventional"],
// //           skills: ["Customer Service", "Communication", "Organization"],
// //         },
// //       ],
// //     },
// //     belowAverage: {
// //       General: [
// //         {
// //           career: "Shop Attendant",
// //           confidence: 58,
// //           interestMatch: ["social", "realistic"],
// //           skills: ["Customer Service", "Sales", "Basic Math"],
// //         },
// //         {
// //           career: "Security Guard",
// //           confidence: 55,
// //           interestMatch: ["realistic", "observant"],
// //           skills: ["Security", "Alertness", "Communication"],
// //         },
// //         {
// //           career: "Cleaner",
// //           confidence: 52,
// //           interestMatch: ["realistic", "detailed"],
// //           skills: ["Cleaning", "Attention to Detail", "Reliability"],
// //         },
// //         {
// //           career: "Warehouse Worker",
// //           confidence: 50,
// //           interestMatch: ["realistic", "physical"],
// //           skills: ["Inventory", "Physical Work", "Organization"],
// //         },
// //         {
// //           career: "Delivery Driver",
// //           confidence: 48,
// //           interestMatch: ["realistic", "independent"],
// //           skills: ["Driving", "Navigation", "Time Management"],
// //         },
// //       ],
// //     },
// //     needsImprovement: {
// //       General: [
// //         {
// //           career: "General Worker",
// //           confidence: 45,
// //           interestMatch: ["realistic", "physical"],
// //           skills: ["Physical Work", "Following Instructions", "Teamwork"],
// //         },
// //         {
// //           career: "Agricultural Laborer",
// //           confidence: 42,
// //           interestMatch: ["realistic", "outdoor"],
// //           skills: ["Farming", "Physical Work", "Basic Skills"],
// //         },
// //         {
// //           career: "Construction Helper",
// //           confidence: 40,
// //           interestMatch: ["realistic", "physical"],
// //           skills: ["Construction", "Physical Strength", "Teamwork"],
// //         },
// //         {
// //           career: "Parking Attendant",
// //           confidence: 38,
// //           interestMatch: ["conventional", "social"],
// //           skills: ["Customer Service", "Cash Handling", "Attention"],
// //         },
// //         {
// //           career: "Housekeeper",
// //           confidence: 35,
// //           interestMatch: ["realistic", "detailed"],
// //           skills: ["Cleaning", "Organization", "Attention to Detail"],
// //         },
// //       ],
// //     },
// //   };

// //   const interestBasedCareers = {
// //     artistic: [
// //       {
// //         career: "Graphic Designer",
// //         confidence: 85,
// //         skills: ["Creativity", "Software Skills", "Visual Communication"],
// //         education: "Diploma/Degree in Graphic Design",
// //       },
// //       {
// //         career: "Musician",
// //         confidence: 82,
// //         skills: ["Musical Talent", "Practice", "Performance"],
// //         education: "Music School/Self-taught",
// //       },
// //       {
// //         career: "Interior Designer",
// //         confidence: 79,
// //         skills: ["Creativity", "Spatial Awareness", "Client Management"],
// //         education: "Diploma in Interior Design",
// //       },
// //       {
// //         career: "Photographer",
// //         confidence: 76,
// //         skills: ["Creativity", "Technical Skills", "Composition"],
// //         education: "Photography Courses",
// //       },
// //       {
// //         career: "Fashion Designer",
// //         confidence: 73,
// //         skills: ["Creativity", "Design", "Trend Awareness"],
// //         education: "Fashion Design School",
// //       },
// //       {
// //         career: "Video Editor",
// //         confidence: 70,
// //         skills: ["Creativity", "Software Skills", "Storytelling"],
// //         education: "Media Production Courses",
// //       },
// //       {
// //         career: "Art Teacher",
// //         confidence: 68,
// //         skills: ["Teaching", "Art Skills", "Communication"],
// //         education: "Teaching Certification + Art",
// //       },
// //       {
// //         career: "Copywriter",
// //         confidence: 65,
// //         skills: ["Writing", "Creativity", "Marketing"],
// //         education: "Communications/Journalism",
// //       },
// //     ],
// //     scientific: [
// //       {
// //         career: "Research Assistant",
// //         confidence: 82,
// //         skills: ["Analysis", "Research Methods", "Technical Writing"],
// //         education: "Science Degree",
// //       },
// //       {
// //         career: "Lab Technician",
// //         confidence: 79,
// //         skills: [
// //           "Attention to Detail",
// //           "Technical Skills",
// //           "Safety Procedures",
// //         ],
// //         education: "Diploma in Laboratory Technology",
// //       },
// //       {
// //         career: "Science Teacher",
// //         confidence: 76,
// //         skills: ["Teaching", "Science Knowledge", "Communication"],
// //         education: "Teaching Certification + Science",
// //       },
// //       {
// //         career: "Quality Control Analyst",
// //         confidence: 73,
// //         skills: ["Analysis", "Attention to Detail", "Technical Knowledge"],
// //         education: "Science Diploma",
// //       },
// //       {
// //         career: "Environmental Technician",
// //         confidence: 70,
// //         skills: ["Field Work", "Analysis", "Technical Skills"],
// //         education: "Environmental Science Diploma",
// //       },
// //       {
// //         career: "Pharmacy Assistant",
// //         confidence: 67,
// //         skills: [
// //           "Attention to Detail",
// //           "Medical Knowledge",
// //           "Customer Service",
// //         ],
// //         education: "Pharmacy Certificate",
// //       },
// //       {
// //         career: "Computer Technician",
// //         confidence: 64,
// //         skills: ["Technical Skills", "Problem-solving", "Hardware Knowledge"],
// //         education: "IT Certificate",
// //       },
// //     ],
// //     social: [
// //       {
// //         career: "Teacher",
// //         confidence: 84,
// //         skills: ["Communication", "Patience", "Subject Knowledge"],
// //         education: "Teaching Certification",
// //       },
// //       {
// //         career: "Social Worker",
// //         confidence: 81,
// //         skills: ["Empathy", "Communication", "Problem Solving"],
// //         education: "Social Work Degree/Diploma",
// //       },
// //       {
// //         career: "Counselor",
// //         confidence: 78,
// //         skills: ["Listening", "Empathy", "Communication"],
// //         education: "Counseling Certification",
// //       },
// //       {
// //         career: "Nurse",
// //         confidence: 75,
// //         skills: ["Medical Knowledge", "Empathy", "Attention to Detail"],
// //         education: "Nursing Diploma/Degree",
// //       },
// //       {
// //         career: "Community Development Worker",
// //         confidence: 72,
// //         skills: ["Community Engagement", "Communication", "Project Management"],
// //         education: "Development Studies",
// //       },
// //       {
// //         career: "Customer Service Manager",
// //         confidence: 69,
// //         skills: ["Communication", "Leadership", "Problem-solving"],
// //         education: "Business Diploma",
// //       },
// //       {
// //         career: "Event Planner",
// //         confidence: 66,
// //         skills: ["Organization", "Communication", "Creativity"],
// //         education: "Event Management Courses",
// //       },
// //     ],
// //     enterprising: [
// //       {
// //         career: "Sales Representative",
// //         confidence: 83,
// //         skills: ["Communication", "Persistence", "Product Knowledge"],
// //         education: "Sales Training",
// //       },
// //       {
// //         career: "Business Owner",
// //         confidence: 80,
// //         skills: ["Leadership", "Risk Management", "Financial Literacy"],
// //         education: "Business Courses/Experience",
// //       },
// //       {
// //         career: "Marketing Coordinator",
// //         confidence: 77,
// //         skills: ["Creativity", "Communication", "Strategy"],
// //         education: "Marketing Diploma",
// //       },
// //       {
// //         career: "Real Estate Agent",
// //         confidence: 74,
// //         skills: ["Sales", "Negotiation", "Market Knowledge"],
// //         education: "Real Estate Certification",
// //       },
// //       {
// //         career: "Insurance Agent",
// //         confidence: 71,
// //         skills: ["Sales", "Communication", "Product Knowledge"],
// //         education: "Insurance Certification",
// //       },
// //       {
// //         career: "Store Manager",
// //         confidence: 68,
// //         skills: ["Leadership", "Business", "Customer Service"],
// //         education: "Business Management",
// //       },
// //       {
// //         career: "Tour Guide",
// //         confidence: 65,
// //         skills: ["Communication", "Cultural Knowledge", "Public Speaking"],
// //         education: "Tourism Courses",
// //       },
// //     ],
// //     conventional: [
// //       {
// //         career: "Administrative Assistant",
// //         confidence: 80,
// //         skills: ["Organization", "Computer Skills", "Communication"],
// //         education: "Office Administration",
// //       },
// //       {
// //         career: "Accountant",
// //         confidence: 77,
// //         skills: ["Numeracy", "Attention to Detail", "Analytical Thinking"],
// //         education: "Accounting Diploma",
// //       },
// //       {
// //         career: "Data Entry Specialist",
// //         confidence: 74,
// //         skills: ["Typing", "Attention to Detail", "Computer Skills"],
// //         education: "Computer Courses",
// //       },
// //       {
// //         career: "Bank Teller",
// //         confidence: 71,
// //         skills: ["Numeracy", "Customer Service", "Attention to Detail"],
// //         education: "Banking Certificate",
// //       },
// //       {
// //         career: "Library Assistant",
// //         confidence: 68,
// //         skills: ["Organization", "Customer Service", "Research Skills"],
// //         education: "Library Science Basics",
// //       },
// //       {
// //         career: "Office Clerk",
// //         confidence: 65,
// //         skills: ["Organization", "Computer Skills", "Communication"],
// //         education: "Office Skills Training",
// //       },
// //       {
// //         career: "Records Manager",
// //         confidence: 62,
// //         skills: ["Organization", "Attention to Detail", "System Management"],
// //         education: "Records Management",
// //       },
// //     ],
// //     realistic: [
// //       {
// //         career: "Mechanic",
// //         confidence: 82,
// //         skills: ["Technical Skills", "Problem Solving", "Manual Dexterity"],
// //         education: "Mechanical Training",
// //       },
// //       {
// //         career: "Electrician",
// //         confidence: 79,
// //         skills: ["Technical Knowledge", "Safety Awareness", "Problem Solving"],
// //         education: "Electrical Certification",
// //       },
// //       {
// //         career: "Plumber",
// //         confidence: 76,
// //         skills: ["Technical Skills", "Problem Solving", "Physical Work"],
// //         education: "Plumbing Apprenticeship",
// //       },
// //       {
// //         career: "Carpenter",
// //         confidence: 73,
// //         skills: ["Woodworking", "Precision", "Creativity"],
// //         education: "Carpentry Training",
// //       },
// //       {
// //         career: "Farm Manager",
// //         confidence: 70,
// //         skills: ["Agriculture", "Management", "Technical Knowledge"],
// //         education: "Agriculture Training",
// //       },
// //       {
// //         career: "Auto Technician",
// //         confidence: 67,
// //         skills: ["Mechanical Skills", "Problem Solving", "Attention to Detail"],
// //         education: "Auto Mechanics Training",
// //       },
// //       {
// //         career: "Construction Supervisor",
// //         confidence: 64,
// //         skills: ["Leadership", "Technical Knowledge", "Project Management"],
// //         education: "Construction Management",
// //       },
// //       {
// //         career: "Professional Athlete",
// //         confidence: 85,
// //         skills: ["Athletic Performance", "Discipline", "Teamwork"],
// //         education: "Sports Training",
// //       },
// //       {
// //         career: "Sports Coach",
// //         confidence: 78,
// //         skills: ["Leadership", "Sports Knowledge", "Communication"],
// //         education: "Coaching Certification",
// //       },
// //       {
// //         career: "Physical Trainer",
// //         confidence: 75,
// //         skills: ["Fitness Knowledge", "Motivation", "Anatomy"],
// //         education: "Fitness Certification",
// //       },
// //     ],
// //   };

// //   const fetchInsights = async () => {
// //     try {
// //       setLoading(true);
// //       setError(null);

// //       const [insightsResponse, resultsResponse] = await Promise.all([
// //         axios.get(
// //           `https://kidsm.vercel.app/api/schools/learner/${learnerId}/career-insights`
// //         ),
// //         axios.get(
// //           `https://kidsm.vercel.app/api/schools/learner/${learnerId}/results`
// //         ),
// //       ]);

// //       // Fetch interests data if available
// //       let interests = null;
// //       try {
// //         const interestsResponse = await axios.get(
// //           `https://kidsm.vercel.app/api/schools/learner/${learnerId}/interests`
// //         );
// //         console.log("Interests response:", interestsResponse.data);
// //         interests = interestsResponse.data;
// //       } catch (error) {
// //         console.log("No interests data available:", error.message);
// //       }

// //       setInsightsData(insightsResponse.data);
// //       setResultsData(resultsResponse.data.results);
// //       setInterestsData(interests);

// //       analyzeAllData(
// //         resultsResponse.data.results,
// //         insightsResponse.data,
// //         learner,
// //         interests
// //       );
// //     } catch (error) {
// //       console.error("Fetch error:", error);
// //       setError("Failed to load career insights");

// //       if (error.response?.status === 404) {
// //         await generateInsights();
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const generateInsights = async () => {
// //     try {
// //       setLoading(true);
// //       await axios.post(
// //         `https://kidsm.vercel.app/api/schools/update-career-insights`,
// //         { learnerId }
// //       );
// //       await fetchInsights();
// //     } catch (error) {
// //       console.error("Generation error:", error);
// //       setError(
// //         "Failed to generate insights. Please ensure the student has sufficient data."
// //       );
// //       setSnackbar({
// //         open: true,
// //         message: "Failed to generate insights",
// //         severity: "error",
// //       });
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const analyzeAllData = (results, insights, learner, interests) => {
// //     if (!results || Object.keys(results).length === 0) {
// //       setDetailedAnalysis({
// //         performanceLevel: "insufficientData",
// //         overallAverage: 0,
// //         careerRecommendations: { academic: [], interests: [], combined: [] },
// //         message:
// //           "Insufficient data for analysis. Please ensure the student has exam results.",
// //       });
// //       return;
// //     }

// //     const subjectAverages = calculateAllSubjectAverages(
// //       results,
// //       learner?.class
// //     );
// //     const overallAverage = calculateOverallAverage(subjectAverages);
// //     const performanceLevel = getPerformanceLevel(overallAverage);
// //     const detectedInterests = analyzeInterests(interests);

// //     const analysis = {
// //       performanceLevel,
// //       overallAverage,
// //       subjectAverages,
// //       currentClass: learner?.class,
// //       interests: detectedInterests,
// //       topSubjects: subjectAverages.filter((s) => s.average >= 70).slice(0, 3),
// //       weakestSubjects: subjectAverages
// //         .filter((s) => s.average < 50)
// //         .slice(0, 3),
// //       careerRecommendations: generateCareerRecommendations(
// //         subjectAverages,
// //         performanceLevel,
// //         detectedInterests
// //       ),
// //       improvementAreas: identifyImprovementAreas(subjectAverages),
// //       strengths: identifyStrengths(subjectAverages),
// //       confidenceScore: calculateConfidenceScore(
// //         subjectAverages,
// //         detectedInterests
// //       ),
// //       learningAdvice: generateLearningAdvice(
// //         performanceLevel,
// //         subjectAverages,
// //         learner?.class
// //       ),
// //       pathwayRecommendation: getPathwayRecommendation(performanceLevel),
// //     };

// //     setDetailedAnalysis(analysis);
// //   };

// //   const analyzeInterests = (interestsData) => {
// //     if (!interestsData) {
// //       console.log("No interests data provided");
// //       return null;
// //     }

// //     console.log("Raw interests data:", interestsData);

// //     let homeInterests = [];
// //     let schoolInterests = [];

// //     if (interestsData.interests) {
// //       homeInterests = interestsData.interests.home || [];
// //       schoolInterests = interestsData.interests.school || [];
// //     } else {
// //       homeInterests = interestsData.home || [];
// //       schoolInterests = interestsData.school || [];
// //     }

// //     const interests = {
// //       home: homeInterests,
// //       school: schoolInterests,
// //       detectedCategories: [],
// //       primaryInterest: null,
// //       secondaryInterest: null,
// //     };

// //     const allInterestText = [];

// //     homeInterests.forEach((interest) => {
// //       if (interest.activities && Array.isArray(interest.activities)) {
// //         allInterestText.push(...interest.activities);
// //       }
// //       if (interest.category) {
// //         allInterestText.push(interest.category);
// //       }
// //       if (interest.notes) {
// //         allInterestText.push(interest.notes);
// //       }
// //     });

// //     schoolInterests.forEach((interest) => {
// //       if (interest.activities && Array.isArray(interest.activities)) {
// //         allInterestText.push(...interest.activities);
// //       }
// //       if (interest.category) {
// //         allInterestText.push(interest.category);
// //       }
// //       if (interest.notes) {
// //         allInterestText.push(interest.notes);
// //       }
// //     });

// //     console.log("All interest text:", allInterestText);

// //     const categoryCounts = {};

// //     allInterestText.forEach((interestText) => {
// //       const text = interestText.toString().toLowerCase();

// //       Object.entries(interestCategories).forEach(([category, keywords]) => {
// //         keywords.forEach((keyword) => {
// //           if (text.includes(keyword)) {
// //             categoryCounts[category] = (categoryCounts[category] || 0) + 1;
// //           }
// //         });
// //       });
// //     });

// //     console.log("Category counts:", categoryCounts);

// //     interests.detectedCategories = Object.entries(categoryCounts)
// //       .sort(([, a], [, b]) => b - a)
// //       .map(([category]) => category);

// //     if (interests.detectedCategories.length > 0) {
// //       interests.primaryInterest = interests.detectedCategories[0];
// //       interests.secondaryInterest = interests.detectedCategories[1] || null;
// //     }

// //     console.log("Final analyzed interests:", interests);
// //     return interests;
// //   };

// //   const calculateAllSubjectAverages = (results, currentClass) => {
// //     const subjectTotals = {};
// //     const subjectCounts = {};

// //     Object.values(results).forEach((termData) => {
// //       Object.values(termData).forEach((examData) => {
// //         examData.forEach(({ subject, marks }) => {
// //           const normalizedSubject = cbcSubjectMappings[subject] || subject;

// //           if (!subjectTotals[normalizedSubject]) {
// //             subjectTotals[normalizedSubject] = 0;
// //             subjectCounts[normalizedSubject] = 0;
// //           }

// //           subjectTotals[normalizedSubject] += Number(marks);
// //           subjectCounts[normalizedSubject] += 1;
// //         });
// //       });
// //     });

// //     const averages = Object.entries(subjectTotals)
// //       .map(([subject, total]) => ({
// //         subject,
// //         average: total / subjectCounts[subject],
// //         count: subjectCounts[subject],
// //         recent: true,
// //       }))
// //       .sort((a, b) => b.average - a.average);

// //     return averages;
// //   };

// //   const calculateOverallAverage = (subjectAverages) => {
// //     if (subjectAverages.length === 0) return 0;
// //     const total = subjectAverages.reduce(
// //       (sum, subject) => sum + subject.average,
// //       0
// //     );
// //     return total / subjectAverages.length;
// //   };

// //   const getPerformanceLevel = (average) => {
// //     if (average >= 85) return "excellent";
// //     if (average >= 70) return "good";
// //     if (average >= 55) return "average";
// //     if (average >= 40) return "belowAverage";
// //     return "needsImprovement";
// //   };

// //   const generateCareerRecommendations = (
// //     subjectAverages,
// //     performanceLevel,
// //     interests
// //   ) => {
// //     const academicRecommendations = [];
// //     const interestRecommendations = [];
// //     const combinedRecommendations = [];
// //     const seenAcademic = new Set();
// //     const seenInterest = new Set();
// //     const seenCombined = new Set();

// //     // Academic-only recommendations
// //     subjectAverages
// //       .filter((s) => s.recent && s.average >= 50)
// //       .forEach((subject) => {
// //         const subjectCareers =
// //           comprehensiveCareerMappings[performanceLevel]?.[subject.subject] ||
// //           comprehensiveCareerMappings[performanceLevel]?.General ||
// //           [];
// //         subjectCareers.forEach((career) => {
// //           if (!seenAcademic.has(career.career)) {
// //             seenAcademic.add(career.career);
// //             const academicConfidence = calculateAcademicConfidence(
// //               career,
// //               subject,
// //               performanceLevel
// //             );
// //             const finalConfidence = academicConfidence;
// //             const reasons = [
// //               `Strong performance in ${
// //                 subject.subject
// //               } (${subject.average.toFixed(1)}%)`,
// //             ];
// //             if (career.skills) {
// //               reasons.push(
// //                 `Requires skills in ${career.skills.slice(0, 2).join(" and ")}`
// //               );
// //             }
// //             academicRecommendations.push({
// //               ...career,
// //               confidenceScore: finalConfidence,
// //               reasons:
// //                 reasons.length > 0
// //                   ? reasons
// //                   : ["Based on academic performance"],
// //               source: "Academic Performance Analysis",
// //               matchType: "Academic",
// //               academicScore: academicConfidence,
// //               interestScore: 0,
// //             });
// //           }
// //         });
// //       });

// //     // Add general if few
// //     if (academicRecommendations.length < 5) {
// //       const generalCareers =
// //         comprehensiveCareerMappings[performanceLevel]?.General || [];
// //       generalCareers.forEach((career) => {
// //         if (!seenAcademic.has(career.career)) {
// //           seenAcademic.add(career.career);
// //           const finalConfidence = career.confidence;
// //           academicRecommendations.push({
// //             ...career,
// //             confidenceScore: finalConfidence,
// //             reasons: ["Based on overall academic performance level"],
// //             source: "General Academic Guidance",
// //             matchType: "Academic General",
// //             academicScore: finalConfidence,
// //             interestScore: 0,
// //           });
// //         }
// //       });
// //     }

// //     // Interests-only recommendations
// //     if (interests && interests.detectedCategories.length > 0) {
// //       console.log(
// //         "Generating interest-based careers for categories:",
// //         interests.detectedCategories
// //       );

// //       interests.detectedCategories.forEach((category) => {
// //         const interestCareers = interestBasedCareers[category] || [];
// //         console.log(
// //           `Found ${interestCareers.length} careers for category ${category}`
// //         );

// //         interestCareers.forEach((career) => {
// //           if (!seenInterest.has(career.career)) {
// //             seenInterest.add(career.career);
// //             const interestConfidence = calculatePureInterestConfidence(
// //               career,
// //               interests,
// //               category
// //             );
// //             const finalConfidence = interestConfidence;
// //             const reasons = generateInterestBasedReasons(
// //               career,
// //               interests,
// //               category,
// //               0
// //             );
// //             interestRecommendations.push({
// //               ...career,
// //               confidenceScore: finalConfidence,
// //               reasons,
// //               source: "Interest Analysis",
// //               matchType: "Interest",
// //               academicScore: 0,
// //               interestScore: interestConfidence,
// //             });
// //           }
// //         });
// //       });
// //     } else {
// //       console.log("No interests detected for interest-based recommendations");
// //     }

// //     // Add general interest careers if few
// //     if (
// //       interestRecommendations.length < 3 &&
// //       interests &&
// //       interests.detectedCategories.length > 0
// //     ) {
// //       const primaryCategory = interests.detectedCategories[0];
// //       const generalInterestCareers =
// //         interestBasedCareers[primaryCategory] || [];
// //       generalInterestCareers.forEach((career) => {
// //         if (
// //           !seenInterest.has(career.career) &&
// //           interestRecommendations.length < 5
// //         ) {
// //           seenInterest.add(career.career);
// //           const interestConfidence = Math.max(60, career.confidence);
// //           interestRecommendations.push({
// //             ...career,
// //             confidenceScore: interestConfidence,
// //             reasons: [`Based on ${primaryCategory} interests`],
// //             source: "General Interest Guidance",
// //             matchType: "Interest General",
// //             academicScore: 0,
// //             interestScore: interestConfidence,
// //           });
// //         }
// //       });
// //     }

// //     // Combined recommendations (academic + interests)
// //     subjectAverages
// //       .filter((s) => s.recent && s.average >= 50)
// //       .forEach((subject) => {
// //         const subjectCareers =
// //           comprehensiveCareerMappings[performanceLevel]?.[subject.subject] ||
// //           comprehensiveCareerMappings[performanceLevel]?.General ||
// //           [];
// //         subjectCareers.forEach((career) => {
// //           if (!seenCombined.has(career.career)) {
// //             seenCombined.add(career.career);
// //             const academicConfidence = calculateAcademicConfidence(
// //               career,
// //               subject,
// //               performanceLevel
// //             );
// //             const interestConfidence = calculateInterestConfidence(
// //               career,
// //               interests
// //             );
// //             const finalConfidence = Math.round(
// //               academicConfidence * 0.6 + interestConfidence * 0.4
// //             );
// //             const reasons = generateCareerReasons(
// //               career,
// //               subject,
// //               interests,
// //               academicConfidence,
// //               interestConfidence
// //             );
// //             combinedRecommendations.push({
// //               ...career,
// //               confidenceScore: finalConfidence,
// //               reasons,
// //               source: "Academic Performance + Interests Analysis",
// //               matchType: "Combined Analysis",
// //               academicScore: academicConfidence,
// //               interestScore: interestConfidence,
// //             });
// //           }
// //         });
// //       });

// //     // Add interest-focused combined recommendations
// //     if (interests && interests.detectedCategories.length > 0) {
// //       interests.detectedCategories.forEach((category) => {
// //         const interestCareers = interestBasedCareers[category] || [];
// //         interestCareers.forEach((career) => {
// //           if (!seenCombined.has(career.career)) {
// //             seenCombined.add(career.career);
// //             const interestConfidence = calculatePureInterestConfidence(
// //               career,
// //               interests,
// //               category
// //             );
// //             const academicConfidence = findBestAcademicMatch(
// //               career,
// //               subjectAverages,
// //               performanceLevel
// //             );
// //             const finalConfidence = Math.round(
// //               academicConfidence * 0.3 + interestConfidence * 0.7
// //             );
// //             const reasons = generateInterestBasedReasons(
// //               career,
// //               interests,
// //               category,
// //               academicConfidence
// //             );
// //             combinedRecommendations.push({
// //               ...career,
// //               confidenceScore: finalConfidence,
// //               reasons,
// //               source: "Primary Interest Analysis",
// //               matchType: "Combined Analysis",
// //               academicScore: academicConfidence,
// //               interestScore: interestConfidence,
// //             });
// //           }
// //         });
// //       });
// //     }

// //     // Add general combined recommendations
// //     if (combinedRecommendations.length < 5) {
// //       const generalCareers =
// //         comprehensiveCareerMappings[performanceLevel]?.General || [];
// //       generalCareers.forEach((career) => {
// //         if (!seenCombined.has(career.career)) {
// //           seenCombined.add(career.career);
// //           const interestConfidence = calculateInterestConfidence(
// //             career,
// //             interests
// //           );
// //           const finalConfidence = Math.round(
// //             career.confidence * 0.8 + interestConfidence * 0.2
// //           );
// //           combinedRecommendations.push({
// //             ...career,
// //             confidenceScore: finalConfidence,
// //             reasons: [
// //               "Based on overall academic performance level and general interests",
// //             ],
// //             source: "General Career Guidance",
// //             matchType: "Combined General",
// //             academicScore: career.confidence,
// //             interestScore: interestConfidence,
// //           });
// //         }
// //       });
// //     }

// //     console.log("Career recommendations generated:", {
// //       academic: academicRecommendations.length,
// //       interests: interestRecommendations.length,
// //       combined: combinedRecommendations.length,
// //     });

// //     return {
// //       academic: academicRecommendations
// //         .sort((a, b) => b.confidenceScore - a.confidenceScore)
// //         .slice(0, 10),
// //       interests: interestRecommendations
// //         .sort((a, b) => b.confidenceScore - a.confidenceScore)
// //         .slice(0, 10),
// //       combined: combinedRecommendations
// //         .sort((a, b) => b.confidenceScore - a.confidenceScore)
// //         .slice(0, 15),
// //     };
// //   };

// //   const calculateAcademicConfidence = (career, subject, performanceLevel) => {
// //     let confidence = career.confidence;

// //     // Boost based on subject performance
// //     if (subject.average >= 80) confidence += 20;
// //     else if (subject.average >= 70) confidence += 15;
// //     else if (subject.average >= 60) confidence += 10;
// //     else if (subject.average >= 50) confidence += 5;

// //     // Adjust based on performance level
// //     if (performanceLevel === "excellent") confidence += 15;
// //     else if (performanceLevel === "good") confidence += 10;
// //     else if (performanceLevel === "average") confidence += 5;

// //     return Math.max(30, Math.min(95, confidence));
// //   };

// //   const calculateInterestConfidence = (career, interests) => {
// //     if (!interests || !interests.detectedCategories.length) return 50;

// //     let confidence = 50;
// //     const careerInterests = career.interestMatch || [];

// //     // Check interest matches
// //     careerInterests.forEach((careerInterest) => {
// //       if (interests.detectedCategories.includes(careerInterest)) {
// //         if (careerInterest === interests.primaryInterest) confidence += 30;
// //         else if (careerInterest === interests.secondaryInterest)
// //           confidence += 15;
// //         else confidence += 10;
// //       }
// //     });

// //     return Math.max(20, Math.min(90, confidence));
// //   };

// //   const calculatePureInterestConfidence = (career, interests, category) => {
// //     if (!interests) return career.confidence;

// //     let confidence = career.confidence;

// //     if (category === interests.primaryInterest) confidence += 25;
// //     else if (category === interests.secondaryInterest) confidence += 15;
// //     else confidence += 5;

// //     return Math.max(40, Math.min(95, confidence));
// //   };

// //   const findBestAcademicMatch = (career, subjectAverages, performanceLevel) => {
// //     // Find the best matching subject for this career
// //     const relevantSubjects = subjectAverages.filter(
// //       (s) =>
// //         s.average >= 50 &&
// //         career.skills &&
// //         career.skills.some((skill) =>
// //           skill.toLowerCase().includes(s.subject.toLowerCase().split(" ")[0])
// //         )
// //     );

// //     if (relevantSubjects.length > 0) {
// //       const bestSubject = relevantSubjects[0];
// //       return Math.min(
// //         90,
// //         bestSubject.average + (performanceLevel === "excellent" ? 10 : 0)
// //       );
// //     }

// //     // Default academic confidence based on performance level
// //     const baseScores = {
// //       excellent: 75,
// //       good: 60,
// //       average: 45,
// //       belowAverage: 30,
// //       needsImprovement: 20,
// //     };

// //     return baseScores[performanceLevel] || 50;
// //   };

// //   const generateCareerReasons = (
// //     career,
// //     subject,
// //     interests,
// //     academicScore,
// //     interestScore
// //   ) => {
// //     const reasons = [];

// //     // Academic reasons
// //     if (academicScore >= 70) {
// //       reasons.push(
// //         `Excellent performance in ${subject.subject} (${subject.average.toFixed(
// //           1
// //         )}%)`
// //       );
// //     } else if (academicScore >= 50) {
// //       reasons.push(
// //         `Good performance in ${subject.subject} (${subject.average.toFixed(
// //           1
// //         )}%)`
// //       );
// //     }

// //     // Interest reasons
// //     if (interests && interests.detectedCategories.length > 0) {
// //       const matchingInterests = career.interestMatch?.filter((interest) =>
// //         interests.detectedCategories.includes(interest)
// //       );

// //       if (matchingInterests && matchingInterests.length > 0) {
// //         if (matchingInterests.includes(interests.primaryInterest)) {
// //           reasons.push(
// //             `Matches primary interest in ${interests.primaryInterest} activities`
// //           );
// //         } else {
// //           reasons.push(
// //             `Aligns with interests in ${matchingInterests.join(" and ")}`
// //           );
// //         }
// //       }
// //     }

// //     // Skill-based reasons
// //     if (career.skills) {
// //       reasons.push(
// //         `Requires skills in ${career.skills.slice(0, 2).join(" and ")}`
// //       );
// //     }

// //     return reasons.length > 0
// //       ? reasons
// //       : ["Good overall fit based on academic profile"];
// //   };

// //   const generateInterestBasedReasons = (
// //     career,
// //     interests,
// //     category,
// //     academicScore
// //   ) => {
// //     const reasons = [];

// //     reasons.push(`Strong alignment with ${category} interests`);

// //     if (category === interests.primaryInterest) {
// //       reasons.push("Matches primary area of interest");
// //     }

// //     if (academicScore >= 50) {
// //       reasons.push("Supported by adequate academic performance");
// //     }

// //     if (career.skills) {
// //       reasons.push(
// //         `Opportunity to develop ${career.skills
// //           .slice(0, 2)
// //           .join(" and ")} skills`
// //       );
// //     }

// //     return reasons;
// //   };

// //   const identifyImprovementAreas = (subjectAverages) => {
// //     return subjectAverages
// //       .filter((subject) => subject.average < 50)
// //       .map((subject) => ({
// //         subject: subject.subject,
// //         currentScore: subject.average,
// //         targetScore: 60,
// //         improvementNeeded: (60 - subject.average).toFixed(1),
// //       }));
// //   };

// //   const identifyStrengths = (subjectAverages) => {
// //     return subjectAverages
// //       .filter((subject) => subject.average >= 70)
// //       .map((subject) => ({
// //         subject: subject.subject,
// //         score: subject.average,
// //         level: subject.average >= 85 ? "Exceptional" : "Strong",
// //       }));
// //   };

// //   const calculateConfidenceScore = (subjectAverages, interests) => {
// //     if (subjectAverages.length === 0) return 0;

// //     let score = 50;

// //     // Data completeness
// //     if (subjectAverages.length >= 5) score += 20;
// //     else if (subjectAverages.length >= 3) score += 10;

// //     // Academic performance
// //     const average = calculateOverallAverage(subjectAverages);
// //     if (average >= 60) score += 20;
// //     else if (average >= 40) score += 10;

// //     // Interests data
// //     if (interests && interests.detectedCategories.length > 0) score += 15;

// //     return Math.min(95, score);
// //   };

// //   const generateLearningAdvice = (
// //     performanceLevel,
// //     subjectAverages,
// //     currentClass
// //   ) => {
// //     const advice = {
// //       excellent: [
// //         "Continue excelling in your strong subjects",
// //         "Consider participating in academic competitions",
// //         "Explore advanced topics in your areas of interest",
// //       ],
// //       good: [
// //         "Focus on maintaining your current performance",
// //         "Identify specific areas for minor improvements",
// //         "Develop deeper understanding in your strong subjects",
// //       ],
// //       average: [
// //         "Create a structured study schedule",
// //         "Seek help in weaker subjects from teachers",
// //         "Focus on understanding fundamental concepts",
// //       ],
// //       belowAverage: [
// //         "Develop basic literacy and numeracy skills",
// //         "Work closely with teachers to identify gaps",
// //         "Focus on one subject at a time for improvement",
// //       ],
// //       needsImprovement: [
// //         "Start with foundational skills building",
// //         "Consider one-on-one tutoring support",
// //         "Set small, achievable learning goals",
// //       ],
// //     };

// //     return advice[performanceLevel] || advice.average;
// //   };

// //   const getPathwayRecommendation = (performanceLevel) => {
// //     const pathways = {
// //       excellent: {
// //         pathway: "University Degree Pathway",
// //         description: "Direct entry to university for bachelor degree programs",
// //         requirements:
// //           "Mean grade of C+ and above with relevant subject combinations",
// //       },
// //       good: {
// //         pathway: "Diploma/College Pathway",
// //         description: "Technical training through diploma programs",
// //         requirements: "Mean grade of C- to C+ for diploma courses",
// //       },
// //       average: {
// //         pathway: "Certificate/Vocational Training",
// //         description: "Skills-based training through certificate programs",
// //         requirements: "Mean grade of D to D+ for certificate courses",
// //       },
// //       belowAverage: {
// //         pathway: "Vocational Skills Training",
// //         description: "Basic skills training through youth polytechnics",
// //         requirements: "Focus on foundational skills improvement",
// //       },
// //       needsImprovement: {
// //         pathway: "Basic Skills Development",
// //         description: "Remedial education and basic skills training",
// //         requirements: "Literacy and numeracy skills development",
// //       },
// //     };

// //     return pathways[performanceLevel] || pathways.average;
// //   };

// //   const prepareCareerChartData = (careers, type = "combined") => {
// //     let colors;
// //     if (type === "academic") {
// //       colors = [
// //         "#4CAF50",
// //         "#66BB6A",
// //         "#81C784",
// //         "#A5D6A7",
// //         "#C8E6C9",
// //         "#E8F5E9",
// //       ];
// //     } else if (type === "interests") {
// //       colors = [
// //         "#2196F3",
// //         "#42A5F5",
// //         "#64B5F6",
// //         "#90CAF9",
// //         "#BBDEFB",
// //         "#E3F2FD",
// //       ];
// //     } else {
// //       colors = [
// //         "#FF6384",
// //         "#36A2EB",
// //         "#FFCE56",
// //         "#4BC0C0",
// //         "#9966FF",
// //         "#FF9F40",
// //       ];
// //     }
// //     return careers.slice(0, 6).map((career, index) => ({
// //       name:
// //         career.career.length > 12
// //           ? career.career.substring(0, 12) + "..."
// //           : career.career,
// //       value: career.confidenceScore,
// //       color: colors[index % colors.length],
// //     }));
// //   };

// //   const prepareSubjectPieData = () => {
// //     const colors = [
// //       "#4CAF50",
// //       "#2196F3",
// //       "#FF9800",
// //       "#E91E63",
// //       "#9C27B0",
// //       "#00BCD4",
// //       "#8BC34A",
// //       "#FFC107",
// //     ];

// //     return detailedAnalysis.subjectAverages.slice(0, 6).map((item, index) => ({
// //       name: item.subject,
// //       value: Math.round(item.average),
// //       color: colors[index % colors.length],
// //     }));
// //   };

// //   const getConfidenceColor = (score) => {
// //     if (score >= 80) return "#4CAF50";
// //     if (score >= 60) return "#FF9800";
// //     return "#F44336";
// //   };

// //   const handleCareerPress = (career) => {
// //     setSelectedCareer(career);
// //     setShowAdviceModal(true);
// //   };

// //   const handleRefresh = async () => {
// //     await generateInsights();
// //   };

// //   useEffect(() => {
// //     if (learnerId) {
// //       fetchInsights();
// //     }
// //   }, [learnerId]);

// //   if (!learnerId) {
// //     return (
// //       <Container
// //         maxWidth="md"
// //         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
// //       >
// //         <Typography variant="h6" sx={{ textAlign: "center", color: "#e74c3c" }}>
// //           Error: No learner ID provided
// //         </Typography>
// //       </Container>
// //     );
// //   }

// //   if (loading) {
// //     return (
// //       <Container
// //         maxWidth="md"
// //         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
// //       >
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             minHeight: "100vh",
// //           }}
// //         >
// //           <CircularProgress color="primary" />
// //           <Typography sx={{ mt: 2, color: "#666" }}>
// //             Analyzing academic performance and interests...
// //           </Typography>
// //         </Box>
// //       </Container>
// //     );
// //   }

// //   if (
// //     error ||
// //     !detailedAnalysis ||
// //     detailedAnalysis.performanceLevel === "insufficientData"
// //   ) {
// //     return (
// //       <Container
// //         maxWidth="md"
// //         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
// //       >
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             minHeight: "100vh",
// //           }}
// //         >
// //           <Typography
// //             sx={{
// //               fontSize: "1rem",
// //               color: "#e74c3c",
// //               mb: 2,
// //               textAlign: "center",
// //             }}
// //           >
// //             {error ||
// //               detailedAnalysis?.message ||
// //               "No sufficient data available for career insights."}
// //           </Typography>
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 2,
// //             }}
// //           >
// //             Please ensure the student has completed exams and results are
// //             recorded.
// //           </Typography>
// //           <Button
// //             variant="contained"
// //             onClick={fetchInsights}
// //             sx={{ bgcolor: "#6200ee", borderRadius: 2, textTransform: "none" }}
// //           >
// //             Check Again
// //           </Button>
// //         </Box>
// //       </Container>
// //     );
// //   }

// //   // Only render the main content if detailedAnalysis exists and has careerRecommendations
// //   if (!detailedAnalysis.careerRecommendations) {
// //     return (
// //       <Container
// //         maxWidth="md"
// //         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
// //       >
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             minHeight: "100vh",
// //           }}
// //         >
// //           <Typography
// //             sx={{
// //               fontSize: "1rem",
// //               color: "#e74c3c",
// //               mb: 2,
// //               textAlign: "center",
// //             }}
// //           >
// //             Unable to generate career recommendations
// //           </Typography>
// //           <Button
// //             variant="contained"
// //             onClick={fetchInsights}
// //             sx={{ bgcolor: "#6200ee", borderRadius: 2, textTransform: "none" }}
// //           >
// //             Try Again
// //           </Button>
// //         </Box>
// //       </Container>
// //     );
// //   }

// //   const academicChartData = prepareCareerChartData(
// //     detailedAnalysis.careerRecommendations.academic,
// //     "academic"
// //   );
// //   const interestsChartData = prepareCareerChartData(
// //     detailedAnalysis.careerRecommendations.interests,
// //     "interests"
// //   );
// //   const combinedChartData = prepareCareerChartData(
// //     detailedAnalysis.careerRecommendations.combined,
// //     "combined"
// //   );
// //   const subjectPieData = prepareSubjectPieData();

// //   return (
// //     <Container
// //       maxWidth="md"
// //       sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
// //     >
// //       <motion.div
// //         initial={{ opacity: 0, y: 20 }}
// //         animate={{ opacity: 1, y: 0 }}
// //         transition={{ duration: 0.5 }}
// //       >
// //         <Typography
// //           variant="h4"
// //           sx={{ fontWeight: "bold", color: "#333", mb: 2, textAlign: "center" }}
// //         >
// //           AI-Powered Career Insights
// //         </Typography>

// //         <Typography
// //           sx={{ fontSize: "1rem", color: "#666", mb: 4, textAlign: "center" }}
// //         >
// //           For {learner?.fullName || "Student"} (Admission:{" "}
// //           {learner?.admissionNumber}) - {learner?.class}
// //         </Typography>

// //         {detailedAnalysis.interests &&
// //           detailedAnalysis.interests.detectedCategories.length > 0 && (
// //             <Card
// //               sx={{
// //                 bgcolor: "#FFF3E0",
// //                 borderRadius: 2,
// //                 p: 2,
// //                 mb: 4,
// //                 borderLeft: "4px solid #FF9800",
// //               }}
// //             >
// //               <Typography
// //                 sx={{
// //                   fontSize: "1rem",
// //                   fontWeight: "bold",
// //                   color: "#E65100",
// //                   mb: 1,
// //                 }}
// //               >
// //                 🎯 Detected Interests
// //               </Typography>
// //               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
// //                 {detailedAnalysis.interests.detectedCategories.map(
// //                   (category, index) => (
// //                     <Chip
// //                       key={index}
// //                       label={category}
// //                       sx={{
// //                         bgcolor: "#FFE0B2",
// //                         color: "#E65100",
// //                         fontWeight: 500,
// //                         textTransform: "capitalize",
// //                       }}
// //                       variant="filled"
// //                     />
// //                   )
// //                 )}
// //               </Box>
// //               {(detailedAnalysis.interests.home.length > 0 ||
// //                 detailedAnalysis.interests.school.length > 0) && (
// //                 <Typography
// //                   sx={{
// //                     fontSize: "0.75rem",
// //                     color: "#E65100",
// //                     mt: 1,
// //                     fontStyle: "italic",
// //                   }}
// //                 >
// //                   Based on {detailedAnalysis.interests.home.length} home
// //                   interests and {detailedAnalysis.interests.school.length}{" "}
// //                   school interests
// //                 </Typography>
// //               )}
// //             </Card>
// //           )}

// //         <Card
// //           sx={{
// //             bgcolor: "white",
// //             borderRadius: 2,
// //             p: 2,
// //             mb: 4,
// //             boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //           }}
// //         >
// //           <Typography
// //             sx={{
// //               fontSize: "1.125rem",
// //               fontWeight: "bold",
// //               color: "#6200ee",
// //               mb: 2,
// //               textAlign: "center",
// //             }}
// //           >
// //             Analysis Summary
// //           </Typography>
// //           <Grid container spacing={2}>
// //             <Grid item xs={4}>
// //               <Typography
// //                 sx={{ fontSize: "0.75rem", color: "#666", textAlign: "center" }}
// //               >
// //                 Overall Mean
// //               </Typography>
// //               <Typography
// //                 sx={{
// //                   fontSize: "1rem",
// //                   fontWeight: "bold",
// //                   color:
// //                     detailedAnalysis.overallAverage >= 60
// //                       ? "#4CAF50"
// //                       : "#F44336",
// //                   textAlign: "center",
// //                 }}
// //               >
// //                 {detailedAnalysis.overallAverage.toFixed(1)}%
// //               </Typography>
// //             </Grid>
// //             <Grid item xs={4}>
// //               <Typography
// //                 sx={{ fontSize: "0.75rem", color: "#666", textAlign: "center" }}
// //               >
// //                 Performance Level
// //               </Typography>
// //               <Typography
// //                 sx={{
// //                   fontSize: "1rem",
// //                   fontWeight: "bold",
// //                   textAlign: "center",
// //                   textTransform: "capitalize",
// //                 }}
// //               >
// //                 {detailedAnalysis.performanceLevel}
// //               </Typography>
// //             </Grid>
// //             <Grid item xs={4}>
// //               <Typography
// //                 sx={{ fontSize: "0.75rem", color: "#666", textAlign: "center" }}
// //               >
// //                 Analysis Confidence
// //               </Typography>
// //               <Typography
// //                 sx={{
// //                   fontSize: "1rem",
// //                   fontWeight: "bold",
// //                   textAlign: "center",
// //                 }}
// //               >
// //                 {detailedAnalysis.confidenceScore}%
// //               </Typography>
// //             </Grid>
// //           </Grid>
// //         </Card>

// //         {subjectPieData.length > 0 && (
// //           <>
// //             <Typography
// //               variant="h6"
// //               sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //             >
// //               📊 Academic Performance Analysis
// //             </Typography>
// //             <Card
// //               sx={{
// //                 bgcolor: "#fff",
// //                 borderRadius: 2,
// //                 p: 2,
// //                 mb: 4,
// //                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                 display: "flex",
// //                 justifyContent: "center",
// //               }}
// //             >
// //               <PieChart width={300} height={250}>
// //                 <Pie
// //                   data={subjectPieData}
// //                   cx="50%"
// //                   cy="50%"
// //                   outerRadius={80}
// //                   dataKey="value"
// //                   label
// //                 >
// //                   {subjectPieData.map((entry, index) => (
// //                     <Cell key={`cell-${index}`} fill={entry.color} />
// //                   ))}
// //                 </Pie>
// //                 <Tooltip />
// //                 <Legend />
// //               </PieChart>
// //               <Typography
// //                 sx={{
// //                   fontSize: "0.75rem",
// //                   color: "#666",
// //                   textAlign: "center",
// //                   mt: 1,
// //                   fontStyle: "italic",
// //                 }}
// //               >
// //                 Subject performance averages across all exams and terms
// //               </Typography>
// //             </Card>
// //           </>
// //         )}

// //         <Card
// //           sx={{
// //             bgcolor: "#E3F2FD",
// //             borderRadius: 2,
// //             p: 2,
// //             mb: 4,
// //             borderLeft: "4px solid #2196F3",
// //           }}
// //         >
// //           <Typography
// //             sx={{
// //               fontSize: "1rem",
// //               fontWeight: "bold",
// //               color: "#1976D2",
// //               mb: 0.5,
// //             }}
// //           >
// //             🎓 Recommended Educational Pathway
// //           </Typography>
// //           <Typography
// //             sx={{
// //               fontSize: "1.125rem",
// //               fontWeight: "bold",
// //               color: "#0D47A1",
// //               mb: 0.5,
// //             }}
// //           >
// //             {detailedAnalysis.pathwayRecommendation.pathway}
// //           </Typography>
// //           <Typography sx={{ fontSize: "0.875rem", color: "#333", mb: 0.5 }}>
// //             {detailedAnalysis.pathwayRecommendation.description}
// //           </Typography>
// //           <Typography
// //             sx={{ fontSize: "0.75rem", color: "#666", fontStyle: "italic" }}
// //           >
// //             Requirements: {detailedAnalysis.pathwayRecommendation.requirements}
// //           </Typography>
// //         </Card>

// //         <Typography
// //           variant="h6"
// //           sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //         >
// //           🎯 Career Recommendations Based on Academic Performance (
// //           {detailedAnalysis.careerRecommendations.academic.length} options)
// //         </Typography>
// //         {academicChartData.length > 0 ? (
// //           <>
// //             <Card
// //               sx={{
// //                 bgcolor: "#fff",
// //                 borderRadius: 2,
// //                 p: 2,
// //                 mb: 4,
// //                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                 display: "flex",
// //                 justifyContent: "center",
// //               }}
// //             >
// //               <PieChart width={300} height={250}>
// //                 <Pie
// //                   data={academicChartData}
// //                   cx="50%"
// //                   cy="50%"
// //                   outerRadius={80}
// //                   dataKey="value"
// //                   label
// //                 >
// //                   {academicChartData.map((entry, index) => (
// //                     <Cell key={`cell-${index}`} fill={entry.color} />
// //                   ))}
// //                 </Pie>
// //                 <Tooltip />
// //                 <Legend />
// //               </PieChart>
// //             </Card>
// //             {detailedAnalysis.careerRecommendations.academic.map(
// //               (career, index) => (
// //                 <Card
// //                   key={`academic-${index}`}
// //                   onClick={() => handleCareerPress(career)}
// //                   sx={{
// //                     bgcolor: "white",
// //                     borderRadius: 2,
// //                     mb: 2,
// //                     p: 2,
// //                     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                     cursor: "pointer",
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       alignItems: "center",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography
// //                       sx={{
// //                         fontSize: "1rem",
// //                         fontWeight: "bold",
// //                         color: "#333",
// //                       }}
// //                     >
// //                       {career.career}
// //                     </Typography>
// //                     <Chip
// //                       label={`${career.confidenceScore}% match`}
// //                       sx={{
// //                         bgcolor: getConfidenceColor(career.confidenceScore),
// //                         color: "white",
// //                         fontWeight: 600,
// //                       }}
// //                     />
// //                   </Box>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography
// //                       sx={{
// //                         fontSize: "0.75rem",
// //                         color: "#2196F3",
// //                         fontWeight: 500,
// //                       }}
// //                     >
// //                       {career.matchType}
// //                     </Typography>
// //                     <Typography
// //                       sx={{
// //                         fontSize: "0.6875rem",
// //                         color: "#666",
// //                         fontStyle: "italic",
// //                       }}
// //                     >
// //                       Source: {career.source}
// //                     </Typography>
// //                   </Box>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                       Academic: {career.academicScore}%
// //                     </Typography>
// //                     <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                       Interest: {career.interestScore}%
// //                     </Typography>
// //                   </Box>

// //                   <Box sx={{ mb: 1 }}>
// //                     {career.reasons.map((reason, rIndex) => (
// //                       <Typography
// //                         key={rIndex}
// //                         sx={{
// //                           fontSize: "0.6875rem",
// //                           color: "#4CAF50",
// //                           lineHeight: 1.2,
// //                         }}
// //                       >
// //                         • {reason}
// //                       </Typography>
// //                     ))}
// //                   </Box>

// //                   {career.skills && (
// //                     <Box sx={{ display: "flex", alignItems: "center" }}>
// //                       <Typography
// //                         sx={{
// //                           fontSize: "0.6875rem",
// //                           color: "#666",
// //                           fontWeight: 500,
// //                           mr: 0.5,
// //                         }}
// //                       >
// //                         Key Skills:{" "}
// //                       </Typography>
// //                       <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                         {career.skills.slice(0, 3).join(", ")}
// //                       </Typography>
// //                     </Box>
// //                   )}
// //                 </Card>
// //               )
// //             )}
// //           </>
// //         ) : (
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 4,
// //             }}
// //           >
// //             No academic-based career recommendations available
// //           </Typography>
// //         )}

// //         <Typography
// //           variant="h6"
// //           sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //         >
// //           ❤️ Career Recommendations Based on Interests (
// //           {detailedAnalysis.careerRecommendations.interests.length} options)
// //         </Typography>
// //         {interestsChartData.length > 0 ? (
// //           <>
// //             <Card
// //               sx={{
// //                 bgcolor: "#fff",
// //                 borderRadius: 2,
// //                 p: 2,
// //                 mb: 4,
// //                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                 display: "flex",
// //                 justifyContent: "center",
// //               }}
// //             >
// //               <PieChart width={300} height={250}>
// //                 <Pie
// //                   data={interestsChartData}
// //                   cx="50%"
// //                   cy="50%"
// //                   outerRadius={80}
// //                   dataKey="value"
// //                   label
// //                 >
// //                   {interestsChartData.map((entry, index) => (
// //                     <Cell key={`cell-${index}`} fill={entry.color} />
// //                   ))}
// //                 </Pie>
// //                 <Tooltip />
// //                 <Legend />
// //               </PieChart>
// //             </Card>
// //             {detailedAnalysis.careerRecommendations.interests.map(
// //               (career, index) => (
// //                 <Card
// //                   key={`interests-${index}`}
// //                   onClick={() => handleCareerPress(career)}
// //                   sx={{
// //                     bgcolor: "white",
// //                     borderRadius: 2,
// //                     mb: 2,
// //                     p: 2,
// //                     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                     cursor: "pointer",
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       alignItems: "center",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography
// //                       sx={{
// //                         fontSize: "1rem",
// //                         fontWeight: "bold",
// //                         color: "#333",
// //                       }}
// //                     >
// //                       {career.career}
// //                     </Typography>
// //                     <Chip
// //                       label={`${career.confidenceScore}% match`}
// //                       sx={{
// //                         bgcolor: getConfidenceColor(career.confidenceScore),
// //                         color: "white",
// //                         fontWeight: 600,
// //                       }}
// //                     />
// //                   </Box>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography
// //                       sx={{
// //                         fontSize: "0.75rem",
// //                         color: "#2196F3",
// //                         fontWeight: 500,
// //                       }}
// //                     >
// //                       {career.matchType}
// //                     </Typography>
// //                     <Typography
// //                       sx={{
// //                         fontSize: "0.6875rem",
// //                         color: "#666",
// //                         fontStyle: "italic",
// //                       }}
// //                     >
// //                       Source: {career.source}
// //                     </Typography>
// //                   </Box>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                       Academic: {career.academicScore}%
// //                     </Typography>
// //                     <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                       Interest: {career.interestScore}%
// //                     </Typography>
// //                   </Box>

// //                   <Box sx={{ mb: 1 }}>
// //                     {career.reasons.map((reason, rIndex) => (
// //                       <Typography
// //                         key={rIndex}
// //                         sx={{
// //                           fontSize: "0.6875rem",
// //                           color: "#4CAF50",
// //                           lineHeight: 1.2,
// //                         }}
// //                       >
// //                         • {reason}
// //                       </Typography>
// //                     ))}
// //                   </Box>

// //                   {career.skills && (
// //                     <Box sx={{ display: "flex", alignItems: "center" }}>
// //                       <Typography
// //                         sx={{
// //                           fontSize: "0.6875rem",
// //                           color: "#666",
// //                           fontWeight: 500,
// //                           mr: 0.5,
// //                         }}
// //                       >
// //                         Key Skills:{" "}
// //                       </Typography>
// //                       <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                         {career.skills.slice(0, 3).join(", ")}
// //                       </Typography>
// //                     </Box>
// //                   )}
// //                 </Card>
// //               )
// //             )}
// //           </>
// //         ) : (
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 4,
// //             }}
// //           >
// //             No interest-based career recommendations available
// //           </Typography>
// //         )}

// //         <Typography
// //           variant="h6"
// //           sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //         >
// //           🚀 Combined Career Projections (
// //           {detailedAnalysis.careerRecommendations.combined.length} options)
// //         </Typography>
// //         <Typography
// //           sx={{
// //             fontSize: "0.75rem",
// //             color: "#666",
// //             textAlign: "center",
// //             mb: 1,
// //             fontStyle: "italic",
// //           }}
// //         >
// //           These projections combine your academic performance and interests for
// //           a balanced career outlook.
// //         </Typography>
// //         {combinedChartData.length > 0 ? (
// //           <>
// //             <Card
// //               sx={{
// //                 bgcolor: "#fff",
// //                 borderRadius: 2,
// //                 p: 2,
// //                 mb: 4,
// //                 boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                 display: "flex",
// //                 justifyContent: "center",
// //               }}
// //             >
// //               <PieChart width={300} height={250}>
// //                 <Pie
// //                   data={combinedChartData}
// //                   cx="50%"
// //                   cy="50%"
// //                   outerRadius={80}
// //                   dataKey="value"
// //                   label
// //                 >
// //                   {combinedChartData.map((entry, index) => (
// //                     <Cell key={`cell-${index}`} fill={entry.color} />
// //                   ))}
// //                 </Pie>
// //                 <Tooltip />
// //                 <Legend />
// //               </PieChart>
// //             </Card>
// //             {detailedAnalysis.careerRecommendations.combined.map(
// //               (career, index) => (
// //                 <Card
// //                   key={`combined-${index}`}
// //                   onClick={() => handleCareerPress(career)}
// //                   sx={{
// //                     bgcolor: "white",
// //                     borderRadius: 2,
// //                     mb: 2,
// //                     p: 2,
// //                     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
// //                     cursor: "pointer",
// //                   }}
// //                 >
// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       alignItems: "center",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography
// //                       sx={{
// //                         fontSize: "1rem",
// //                         fontWeight: "bold",
// //                         color: "#333",
// //                       }}
// //                     >
// //                       {career.career}
// //                     </Typography>
// //                     <Chip
// //                       label={`${career.confidenceScore}% match`}
// //                       sx={{
// //                         bgcolor: getConfidenceColor(career.confidenceScore),
// //                         color: "white",
// //                         fontWeight: 600,
// //                       }}
// //                     />
// //                   </Box>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography
// //                       sx={{
// //                         fontSize: "0.75rem",
// //                         color: "#2196F3",
// //                         fontWeight: 500,
// //                       }}
// //                     >
// //                       {career.matchType}
// //                     </Typography>
// //                     <Typography
// //                       sx={{
// //                         fontSize: "0.6875rem",
// //                         color: "#666",
// //                         fontStyle: "italic",
// //                       }}
// //                     >
// //                       Source: {career.source}
// //                     </Typography>
// //                   </Box>

// //                   <Box
// //                     sx={{
// //                       display: "flex",
// //                       justifyContent: "space-between",
// //                       mb: 1,
// //                     }}
// //                   >
// //                     <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                       Academic: {career.academicScore}%
// //                     </Typography>
// //                     <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                       Interest: {career.interestScore}%
// //                     </Typography>
// //                   </Box>

// //                   <Box sx={{ mb: 1 }}>
// //                     {career.reasons.map((reason, rIndex) => (
// //                       <Typography
// //                         key={rIndex}
// //                         sx={{
// //                           fontSize: "0.6875rem",
// //                           color: "#4CAF50",
// //                           lineHeight: 1.2,
// //                         }}
// //                       >
// //                         • {reason}
// //                       </Typography>
// //                     ))}
// //                   </Box>

// //                   {career.skills && (
// //                     <Box sx={{ display: "flex", alignItems: "center" }}>
// //                       <Typography
// //                         sx={{
// //                           fontSize: "0.6875rem",
// //                           color: "#666",
// //                           fontWeight: 500,
// //                           mr: 0.5,
// //                         }}
// //                       >
// //                         Key Skills:{" "}
// //                       </Typography>
// //                       <Typography sx={{ fontSize: "0.6875rem", color: "#666" }}>
// //                         {career.skills.slice(0, 3).join(", ")}
// //                       </Typography>
// //                     </Box>
// //                   )}
// //                 </Card>
// //               )
// //             )}
// //           </>
// //         ) : (
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 4,
// //             }}
// //           >
// //             No combined career projections available
// //           </Typography>
// //         )}

// //         <Typography
// //           variant="h6"
// //           sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //         >
// //           💪 Academic Strengths
// //         </Typography>
// //         {detailedAnalysis.strengths?.length > 0 ? (
// //           detailedAnalysis.strengths.map((strength, index) => (
// //             <Card
// //               key={`strength-${index}`}
// //               sx={{ bgcolor: "#e8f5e9", borderRadius: 2, mb: 1, p: 2 }}
// //             >
// //               <Typography
// //                 sx={{
// //                   fontSize: "0.875rem",
// //                   color: "#2E7D32",
// //                   fontWeight: "500",
// //                 }}
// //               >
// //                 ✓ {strength.level} in {strength.subject} (
// //                 {strength.score.toFixed(1)}%)
// //               </Typography>
// //             </Card>
// //           ))
// //         ) : (
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 4,
// //             }}
// //           >
// //             No strengths identified yet
// //           </Typography>
// //         )}

// //         <Typography
// //           variant="h6"
// //           sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //         >
// //           📈 Areas for Improvement
// //         </Typography>
// //         {detailedAnalysis.improvementAreas?.length > 0 ? (
// //           detailedAnalysis.improvementAreas.map((area, index) => (
// //             <Card
// //               key={`area-${index}`}
// //               sx={{ bgcolor: "#fff3e0", borderRadius: 2, mb: 1, p: 2 }}
// //             >
// //               <Typography sx={{ fontSize: "0.875rem", color: "#E65100" }}>
// //                 • {area.subject} (Current: {area.currentScore.toFixed(1)}%,
// //                 Target: {area.targetScore}%)
// //               </Typography>
// //             </Card>
// //           ))
// //         ) : (
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 4,
// //             }}
// //           >
// //             No improvement areas identified yet
// //           </Typography>
// //         )}

// //         <Typography
// //           variant="h6"
// //           sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //         >
// //           🎯 Learning Advice
// //         </Typography>
// //         {detailedAnalysis.learningAdvice?.length > 0 ? (
// //           <Card sx={{ bgcolor: "white", borderRadius: 2, p: 2, mb: 4 }}>
// //             {detailedAnalysis.learningAdvice.map((advice, index) => (
// //               <Typography
// //                 key={index}
// //                 sx={{ fontSize: "0.875rem", color: "#4CAF50", lineHeight: 1.5 }}
// //               >
// //                 • {advice}
// //               </Typography>
// //             ))}
// //           </Card>
// //         ) : (
// //           <Typography
// //             sx={{
// //               fontSize: "0.875rem",
// //               color: "#666",
// //               textAlign: "center",
// //               mb: 4,
// //             }}
// //           >
// //             No specific advice available yet
// //           </Typography>
// //         )}

// //         {detailedAnalysis.subjectAverages.length > 0 && (
// //           <>
// //             <Typography
// //               variant="h6"
// //               sx={{ fontWeight: "bold", color: "#6200ee", mb: 2 }}
// //             >
// //               📚 Subject Performance Summary
// //             </Typography>
// //             <Card sx={{ bgcolor: "white", borderRadius: 2, p: 2, mb: 4 }}>
// //               {detailedAnalysis.subjectAverages.map((item, index) => (
// //                 <Box
// //                   key={index}
// //                   sx={{
// //                     display: "flex",
// //                     justifyContent: "space-between",
// //                     alignItems: "center",
// //                     py: 1,
// //                     borderBottom:
// //                       index < detailedAnalysis.subjectAverages.length - 1
// //                         ? "1px solid #f0f0f0"
// //                         : "none",
// //                   }}
// //                 >
// //                   <Typography
// //                     sx={{
// //                       fontSize: "0.875rem",
// //                       fontWeight: "500",
// //                       color: "#333",
// //                     }}
// //                   >
// //                     {item.subject}
// //                   </Typography>
// //                   <Typography
// //                     sx={{
// //                       fontSize: "0.875rem",
// //                       fontWeight: "bold",
// //                       color:
// //                         item.average >= 80
// //                           ? "#4CAF50"
// //                           : item.average >= 60
// //                           ? "#FF9800"
// //                           : "#F44336",
// //                     }}
// //                   >
// //                     {item.average.toFixed(1)}%
// //                   </Typography>
// //                 </Box>
// //               ))}
// //             </Card>
// //           </>
// //         )}

// //         <Button
// //           fullWidth
// //           variant="contained"
// //           onClick={handleRefresh}
// //           sx={{
// //             bgcolor: "#6200ee",
// //             borderRadius: 2,
// //             py: 1.5,
// //             textTransform: "none",
// //             fontWeight: "bold",
// //             mt: 4,
// //             "&:hover": { bgcolor: "#3700b3" },
// //           }}
// //         >
// //           Generate New Insights
// //         </Button>
// //       </motion.div>

// //       <Dialog
// //         open={showAdviceModal}
// //         onClose={() => setShowAdviceModal(false)}
// //         maxWidth="sm"
// //         fullWidth
// //       >
// //         <DialogTitle
// //           sx={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
// //         >
// //           {selectedCareer?.career}
// //         </DialogTitle>
// //         <DialogContent>
// //           <Box sx={{ mb: 2 }}>
// //             <Typography
// //               sx={{
// //                 fontSize: "1rem",
// //                 fontWeight: "bold",
// //                 color: "#333",
// //                 mb: 1,
// //               }}
// //             >
// //               Match Details
// //             </Typography>
// //             <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
// //               Overall Match: {selectedCareer?.confidenceScore}%
// //             </Typography>
// //             <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
// //               Academic Fit: {selectedCareer?.academicScore}%
// //             </Typography>
// //             <Typography sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}>
// //               Interest Fit: {selectedCareer?.interestScore}%
// //             </Typography>
// //             <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
// //               Type: {selectedCareer?.matchType}
// //             </Typography>
// //           </Box>
// //           <Box sx={{ mb: 2 }}>
// //             <Typography
// //               sx={{
// //                 fontSize: "1rem",
// //                 fontWeight: "bold",
// //                 color: "#333",
// //                 mb: 1,
// //               }}
// //             >
// //               Supporting Reasons
// //             </Typography>
// //             {selectedCareer?.reasons.map((reason, index) => (
// //               <Typography
// //                 key={index}
// //                 sx={{ fontSize: "0.875rem", color: "#666", mb: 0.5 }}
// //               >
// //                 • {reason}
// //               </Typography>
// //             ))}
// //           </Box>
// //           <Box>
// //             <Typography
// //               sx={{
// //                 fontSize: "1rem",
// //                 fontWeight: "bold",
// //                 color: "#333",
// //                 mb: 1,
// //               }}
// //             >
// //               Required Skills
// //             </Typography>
// //             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
// //               {selectedCareer?.skills.map((skill, index) => (
// //                 <Chip
// //                   key={index}
// //                   label={skill}
// //                   sx={{ bgcolor: "#E3F2FD", color: "#1976D2" }}
// //                 />
// //               ))}
// //             </Box>
// //           </Box>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button
// //             onClick={() => setShowAdviceModal(false)}
// //             sx={{ color: "#6200ee" }}
// //           >
// //             Close
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <Snackbar
// //         open={snackbar.open}
// //         autoHideDuration={6000}
// //         onClose={() => setSnackbar({ ...snackbar, open: false })}
// //         message={snackbar.message}
// //         sx={{
// //           bgcolor: snackbar.severity === "success" ? "#4CAF50" : "#e74c3c",
// //         }}
// //       />
// //     </Container>
// //   );
// // };

// // export default CareerInsights;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import {
//   Container,
//   Typography,
//   Box,
//   Button,
//   CircularProgress,
//   Snackbar,
//   Card,
//   CardContent,
//   Grid,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Tabs,
//   Tab,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Slider,
//   Rating,
//   Avatar,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Divider,
//   Paper,
// } from "@mui/material";
// import { motion } from "framer-motion";
// import {
//   PieChart,
//   Pie,
//   Cell,
//   Legend,
//   Tooltip,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   RadarChart,
//   PolarGrid,
//   PolarAngleAxis,
//   PolarRadiusAxis,
//   Radar,
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   AreaChart,
//   Area,
// } from "recharts";
// import axios from "axios";
// import {
//   School,
//   Computer,
//   Science,
//   MedicalServices,
//   Business,
//   // Design,
//   Engineering,
//   Agriculture,
//   Sports,
//   // Music,
//   Restaurant,
//   Build,
//   Calculate,
//   Palette,
//   Psychology,
//   Public,
//   AccountBalance,
//   LocalHospital,
//   Code,
//   Cloud,
//   Security,
//   DataArray,
//   ElectricBolt,
//   Architecture,
//   DirectionsCar,
//   Flight,
//   LocalShipping,
//   Factory,
//   Biotech,
//   PsychologyAlt,
//   Group,
//   Translate,
//   MenuBook,
//   TheaterComedy,
//   CameraAlt,
//   TrendingUp,
//   Work,
//   AccessTime,
//   AttachMoney,
// } from "@mui/icons-material";
// import DesignServicesIcon from "@mui/icons-material/DesignServices";
// import MusicNoteIcon from "@mui/icons-material/MusicNote";
// const EnhancedCareerInsights = () => {
//   const { state } = useLocation();
//   const { learnerId, learner } = state || {};
//   const [insightsData, setInsightsData] = useState(null);
//   const [resultsData, setResultsData] = useState(null);
//   const [interestsData, setInterestsData] = useState(null);
//   const [detailedAnalysis, setDetailedAnalysis] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [showAdviceModal, setShowAdviceModal] = useState(false);
//   const [selectedCareer, setSelectedCareer] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);
//   const [filters, setFilters] = useState({
//     educationLevel: "all",
//     interestArea: "all",
//     confidenceThreshold: 60,
//   });

//   // Enhanced subject mappings with more granular categories
//   const enhancedSubjectMappings = {
//     Mathematics: {
//       category: "STEM",
//       weight: 1.2,
//       skills: ["analytical", "logical", "quantitative", "problem_solving"],
//     },
//     "English Language": {
//       category: "Languages",
//       weight: 1.1,
//       skills: ["communication", "critical_thinking", "analysis", "linguistic"],
//     },
//     "Kiswahili Lugha": {
//       category: "Languages",
//       weight: 1.0,
//       skills: ["communication", "cultural", "linguistic", "interpersonal"],
//     },
//     "Science & Technology": {
//       category: "STEM",
//       weight: 1.3,
//       skills: ["scientific", "technical", "research", "analytical"],
//     },
//     Agriculture: {
//       category: "Applied Sciences",
//       weight: 1.1,
//       skills: ["practical", "environmental", "management", "technical"],
//     },
//     "Home Science": {
//       category: "Applied Sciences",
//       weight: 1.0,
//       skills: ["practical", "creative", "management", "organizational"],
//     },
//     "Social Studies": {
//       category: "Humanities",
//       weight: 1.0,
//       skills: ["analytical", "social", "research", "communication"],
//     },
//     "Religious Education": {
//       category: "Humanities",
//       weight: 0.9,
//       skills: ["ethical", "cultural", "analytical", "interpersonal"],
//     },
//     History: {
//       category: "Humanities",
//       weight: 1.0,
//       skills: ["research", "analytical", "communication", "critical_thinking"],
//     },
//     Geography: {
//       category: "Sciences",
//       weight: 1.1,
//       skills: ["spatial", "analytical", "environmental", "research"],
//     },
//     "Creative Arts": {
//       category: "Creative",
//       weight: 1.0,
//       skills: ["creative", "artistic", "innovative", "visual"],
//     },
//     Music: {
//       category: "Creative",
//       weight: 1.0,
//       skills: ["creative", "performance", "technical", "expressive"],
//     },
//     "Physical Education": {
//       category: "Physical",
//       weight: 0.9,
//       skills: ["physical", "teamwork", "strategic", "leadership"],
//     },
//     "Pre-Technical": {
//       category: "Technical",
//       weight: 1.2,
//       skills: ["technical", "practical", "problem_solving", "mechanical"],
//     },
//     "Business Studies": {
//       category: "Business",
//       weight: 1.1,
//       skills: ["analytical", "commercial", "management", "financial"],
//     },
//     "Computer Studies": {
//       category: "STEM",
//       weight: 1.3,
//       skills: ["technical", "analytical", "innovative", "problem_solving"],
//     },
//   };

//   // Enhanced interest detection with more categories
//   const enhancedInterestCategories = {
//     stem_technology: {
//       keywords: [
//         "coding",
//         "programming",
//         "computers",
//         "robotics",
//         "engineering",
//         "science",
//         "math",
//         "technology",
//         "experiments",
//         "physics",
//         "chemistry",
//         "biology",
//         "electronics",
//         "ai",
//         "artificial intelligence",
//         "machine learning",
//         "data",
//         "analytics",
//         "software",
//         "hardware",
//         "computing",
//       ],
//       skills: [
//         "analytical",
//         "technical",
//         "problem_solving",
//         "mathematical",
//         "logical",
//       ],
//       careers: ["Technology", "Engineering", "Research", "Data Science"],
//       icon: <Computer />,
//     },
//     creative_arts: {
//       keywords: [
//         "drawing",
//         "painting",
//         "music",
//         "dancing",
//         "singing",
//         "acting",
//         "writing",
//         "poetry",
//         "design",
//         "creative",
//         "art",
//         "photography",
//         "film",
//         "theater",
//         "crafts",
//         "sculpture",
//         "fashion",
//         "draw",
//         "paint",
//         "dance",
//         "sing",
//         "act",
//         "write",
//         "compose",
//       ],
//       skills: ["creative", "artistic", "innovative", "expressive", "visual"],
//       careers: ["Arts", "Design", "Media", "Entertainment"],
//       icon: <Palette />,
//     },
//     social_helping: {
//       keywords: [
//         "helping",
//         "teaching",
//         "community",
//         "teamwork",
//         "volunteering",
//         "counseling",
//         "mentoring",
//         "leadership",
//         "caring",
//         "nursing",
//         "doctors",
//         "elderly",
//         "children",
//         "social work",
//         "charity",
//         "help",
//         "teach",
//         "care",
//         "support",
//       ],
//       skills: [
//         "empathy",
//         "communication",
//         "interpersonal",
//         "supportive",
//         "leadership",
//       ],
//       careers: [
//         "Education",
//         "Healthcare",
//         "Social Work",
//         "Community Development",
//       ],
//       icon: <Group />,
//     },
//     business_entrepreneurship: {
//       keywords: [
//         "business",
//         "selling",
//         "entrepreneur",
//         "managing",
//         "organizing",
//         "negotiating",
//         "marketing",
//         "money",
//         "finance",
//         "investing",
//         "startup",
//         "commerce",
//         "trade",
//         "sell",
//         "manage",
//         "organize",
//         "negotiate",
//         "market",
//       ],
//       skills: [
//         "commercial",
//         "leadership",
//         "strategic",
//         "financial",
//         "management",
//       ],
//       careers: ["Business", "Finance", "Management", "Entrepreneurship"],
//       icon: <Business />,
//     },
//     outdoor_physical: {
//       keywords: [
//         "sports",
//         "outdoors",
//         "farming",
//         "construction",
//         "mechanical",
//         "building",
//         "fixing",
//         "gardening",
//         "animals",
//         "nature",
//         "environment",
//         "fitness",
//         "exercise",
//         "adventure",
//         "exploring",
//         "sport",
//         "build",
//         "fix",
//         "farm",
//         "athletics",
//       ],
//       skills: [
//         "physical",
//         "practical",
//         "technical",
//         "environmental",
//         "mechanical",
//       ],
//       careers: ["Agriculture", "Sports", "Construction", "Environmental"],
//       icon: <Agriculture />,
//     },
//     administrative_organizational: {
//       keywords: [
//         "organizing",
//         "planning",
//         "details",
//         "rules",
//         "accounting",
//         "administrative",
//         "systematic",
//         "office",
//         "records",
//         "filing",
//         "scheduling",
//         "plan",
//         "detail",
//         "account",
//         "admin",
//       ],
//       skills: [
//         "organized",
//         "detail_oriented",
//         "systematic",
//         "efficient",
//         "administrative",
//       ],
//       careers: ["Administration", "Accounting", "Management", "Logistics"],
//       icon: <AccountBalance />,
//     },
//     linguistic_communication: {
//       keywords: [
//         "writing",
//         "reading",
//         "languages",
//         "debate",
//         "public speaking",
//         "storytelling",
//         "journalism",
//         "translation",
//         "literature",
//         "poetry",
//         "blogging",
//         "write",
//         "read",
//         "speak",
//         "translate",
//       ],
//       skills: [
//         "communication",
//         "linguistic",
//         "analytical",
//         "creative",
//         "interpersonal",
//       ],
//       careers: ["Media", "Writing", "Translation", "Education"],
//       icon: <Translate />,
//     },
//   };

//   // Massive career database with 500+ options
//   const comprehensiveCareerDatabase = {
//     // STEM Careers (150+ options)
//     stem_technology: [
//       // Technology & IT
//       {
//         career: "Software Developer",
//         confidence: 85,
//         skills: [
//           "Programming",
//           "Problem Solving",
//           "Algorithms",
//           "Software Design",
//         ],
//         education: "Degree in Computer Science/Software Engineering",
//         pathway: "University",
//         demand: "Very High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Strathmore University",
//           "KCA University",
//           "Technical University of Kenya",
//         ],
//         description:
//           "Design, develop, and maintain software applications and systems",
//         growth: "25% (2023-2028)",
//         subjects: ["Mathematics", "Computer Studies", "Physics"],
//         icon: <Code />,
//       },
//       {
//         career: "Data Scientist",
//         confidence: 88,
//         skills: ["Statistics", "Machine Learning", "Python", "Data Analysis"],
//         education: "Degree in Data Science/Statistics/Computer Science",
//         pathway: "University",
//         demand: "Very High",
//         salary: "Very High",
//         kenyan_institutions: [
//           "Strathmore University",
//           "University of Nairobi",
//           "JKUAT",
//           "Mount Kenya University",
//         ],
//         description:
//           "Extract insights from complex data using statistical and machine learning techniques",
//         growth: "30% (2023-2028)",
//         subjects: ["Mathematics", "Computer Studies", "Science & Technology"],
//         icon: <DataArray />,
//       },
//       {
//         career: "Cybersecurity Analyst",
//         confidence: 82,
//         skills: [
//           "Security",
//           "Networking",
//           "Risk Assessment",
//           "Ethical Hacking",
//         ],
//         education: "Degree in Cybersecurity/Computer Science",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "Dedan Kimathi University",
//           "JKUAT",
//           "Mount Kenya University",
//           "KCA University",
//         ],
//         description:
//           "Protect computer systems and networks from cyber threats and attacks",
//         growth: "28% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Science & Technology"],
//         icon: <Security />,
//       },
//       {
//         career: "Cloud Engineer",
//         confidence: 80,
//         skills: ["Cloud Computing", "Networking", "Linux", "Infrastructure"],
//         education: "Degree in Computer Science/Cloud Computing",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "JKUAT",
//           "University of Nairobi",
//           "Strathmore University",
//         ],
//         description: "Design and maintain cloud infrastructure and services",
//         growth: "26% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Physics"],
//         icon: <Cloud />,
//       },
//       {
//         career: "AI/Machine Learning Engineer",
//         confidence: 86,
//         skills: [
//           "Machine Learning",
//           "Python",
//           "Neural Networks",
//           "Data Modeling",
//         ],
//         education: "Degree in AI/Computer Science/Mathematics",
//         pathway: "University",
//         demand: "Very High",
//         salary: "Very High",
//         kenyan_institutions: [
//           "Strathmore University",
//           "University of Nairobi",
//           "JKUAT",
//         ],
//         description:
//           "Develop artificial intelligence systems and machine learning models",
//         growth: "32% (2023-2028)",
//         subjects: ["Mathematics", "Computer Studies", "Science & Technology"],
//         icon: <Psychology />,
//       },
//       {
//         career: "Web Developer",
//         confidence: 78,
//         skills: ["HTML/CSS", "JavaScript", "React", "Node.js"],
//         education: "Degree/Diploma in Web Development",
//         pathway: "University/College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Nairobi Technical Training Institute",
//           "KCA University",
//           "Zetech University",
//         ],
//         description: "Create and maintain websites and web applications",
//         growth: "18% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Creative Arts"],
//         icon: <Computer />,
//       },
//       {
//         career: "Mobile App Developer",
//         confidence: 79,
//         skills: [
//           "Android/iOS Development",
//           "Java/Kotlin/Swift",
//           "UI/UX Design",
//         ],
//         education: "Degree/Diploma in Mobile Development",
//         pathway: "University/College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "JKUAT",
//           "KCA University",
//           "MultiMedia University",
//         ],
//         description: "Develop applications for mobile devices and platforms",
//         growth: "22% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Creative Arts"],
//         icon: <Code />,
//       },
//       {
//         career: "IT Support Specialist",
//         confidence: 72,
//         skills: [
//           "Technical Support",
//           "Troubleshooting",
//           "Networking",
//           "Hardware",
//         ],
//         education: "Diploma in IT/Computer Studies",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Institute of Business Studies",
//           "Nairobi Technical Institute",
//           "Various Technical Colleges",
//         ],
//         description:
//           "Provide technical assistance and support for computer systems",
//         growth: "12% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Pre-Technical"],
//         icon: <Computer />,
//       },
//       {
//         career: "Database Administrator",
//         confidence: 76,
//         skills: ["SQL", "Database Management", "Security", "Backup/Recovery"],
//         education: "Degree/Diploma in Database Management",
//         pathway: "University/College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Strathmore University",
//         ],
//         description:
//           "Manage and maintain database systems and ensure data integrity",
//         growth: "15% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Business Studies"],
//         icon: <DataArray />,
//       },
//       {
//         career: "Network Administrator",
//         confidence: 74,
//         skills: ["Networking", "Cisco", "Security", "Infrastructure"],
//         education: "Diploma in Network Administration",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Nairobi Technical Training Institute",
//           "Kenya Technical Trainers College",
//         ],
//         description:
//           "Manage and maintain computer networks and communication systems",
//         growth: "14% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Physics"],
//         icon: <Cloud />,
//       },

//       // Engineering Fields
//       {
//         career: "Civil Engineer",
//         confidence: 84,
//         skills: [
//           "Structural Design",
//           "Project Management",
//           "Mathematics",
//           "CAD",
//         ],
//         education: "Degree in Civil Engineering",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Technical University of Kenya",
//           "Moi University",
//         ],
//         description:
//           "Design and supervise construction of infrastructure projects",
//         growth: "16% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Pre-Technical"],
//         icon: <Architecture />,
//       },
//       {
//         career: "Electrical Engineer",
//         confidence: 83,
//         skills: ["Electronics", "Circuit Design", "Physics", "Power Systems"],
//         education: "Degree in Electrical Engineering",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Moi University",
//           "Dedan Kimathi University",
//         ],
//         description: "Design and develop electrical systems and equipment",
//         growth: "15% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Science & Technology"],
//         icon: <ElectricBolt />,
//       },
//       {
//         career: "Mechanical Engineer",
//         confidence: 82,
//         skills: ["Mechanics", "Thermodynamics", "CAD", "Manufacturing"],
//         education: "Degree in Mechanical Engineering",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Technical University of Kenya",
//         ],
//         description: "Design and develop mechanical systems and machinery",
//         growth: "14% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Pre-Technical"],
//         icon: <Engineering />,
//       },
//       {
//         career: "Chemical Engineer",
//         confidence: 81,
//         skills: ["Chemistry", "Process Design", "Safety", "Quality Control"],
//         education: "Degree in Chemical Engineering",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Moi University",
//         ],
//         description: "Design and optimize chemical manufacturing processes",
//         growth: "12% (2023-2028)",
//         subjects: ["Mathematics", "Chemistry", "Physics"],
//         icon: <Science />,
//       },
//       {
//         career: "Aerospace Engineer",
//         confidence: 79,
//         skills: [
//           "Aerodynamics",
//           "Aircraft Design",
//           "Physics",
//           "Materials Science",
//         ],
//         education: "Degree in Aerospace Engineering",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Very High",
//         kenyan_institutions: ["University of Nairobi", "JKUAT"],
//         description:
//           "Design and develop aircraft, spacecraft, and related systems",
//         growth: "18% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Science & Technology"],
//         icon: <Flight />,
//       },
//       {
//         career: "Biomedical Engineer",
//         confidence: 80,
//         skills: ["Medical Devices", "Biology", "Electronics", "Design"],
//         education: "Degree in Biomedical Engineering",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: ["JKUAT", "University of Nairobi"],
//         description: "Design and develop medical equipment and devices",
//         growth: "20% (2023-2028)",
//         subjects: ["Mathematics", "Biology", "Physics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Environmental Engineer",
//         confidence: 77,
//         skills: [
//           "Environmental Science",
//           "Sustainability",
//           "Water Treatment",
//           "Regulations",
//         ],
//         education: "Degree in Environmental Engineering",
//         pathway: "University",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "JKUAT",
//           "University of Nairobi",
//           "Moi University",
//         ],
//         description:
//           "Develop solutions to environmental problems and ensure sustainability",
//         growth: "16% (2023-2028)",
//         subjects: ["Mathematics", "Geography", "Science & Technology"],
//         icon: <Agriculture />,
//       },
//       {
//         career: "Telecommunications Engineer",
//         confidence: 78,
//         skills: [
//           "Networking",
//           "Wireless Systems",
//           "Signal Processing",
//           "Fiber Optics",
//         ],
//         education: "Degree in Telecommunications",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Multimedia University",
//         ],
//         description: "Design and maintain communication systems and networks",
//         growth: "15% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Computer Studies"],
//         icon: <ElectricBolt />,
//       },
//       {
//         career: "Automotive Engineer",
//         confidence: 75,
//         skills: ["Vehicle Design", "Mechanics", "Electronics", "Manufacturing"],
//         education: "Degree in Automotive Engineering",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["Technical University of Kenya", "JKUAT"],
//         description: "Design and develop vehicles and automotive systems",
//         growth: "13% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Pre-Technical"],
//         icon: <DirectionsCar />,
//       },
//       {
//         career: "Marine Engineer",
//         confidence: 73,
//         skills: [
//           "Ship Design",
//           "Naval Architecture",
//           "Marine Systems",
//           "Maintenance",
//         ],
//         education: "Degree in Marine Engineering",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: ["University of Nairobi", "JKUAT"],
//         description: "Design and maintain ships, boats, and marine equipment",
//         growth: "14% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Geography"],
//         icon: <LocalShipping />,
//       },

//       // Research and Science
//       {
//         career: "Research Scientist",
//         confidence: 85,
//         skills: [
//           "Research Methods",
//           "Data Analysis",
//           "Laboratory Skills",
//           "Scientific Writing",
//         ],
//         education: "Masters/PhD in Science Field",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//           "JKUAT",
//         ],
//         description:
//           "Conduct scientific research and experiments to advance knowledge",
//         growth: "12% (2023-2028)",
//         subjects: ["Science & Technology", "Mathematics", "English Language"],
//         icon: <Science />,
//       },
//       {
//         career: "Physicist",
//         confidence: 83,
//         skills: [
//           "Theoretical Physics",
//           "Mathematical Modeling",
//           "Research",
//           "Analysis",
//         ],
//         education: "Degree in Physics",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Study matter, energy, and the fundamental laws of the universe",
//         growth: "11% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Science & Technology"],
//         icon: <Science />,
//       },
//       {
//         career: "Chemist",
//         confidence: 79,
//         skills: [
//           "Chemical Analysis",
//           "Laboratory Techniques",
//           "Research",
//           "Quality Control",
//         ],
//         education: "Degree in Chemistry",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "JKUAT",
//         ],
//         description:
//           "Study chemicals and chemical processes to develop new products",
//         growth: "10% (2023-2028)",
//         subjects: ["Chemistry", "Mathematics", "Science & Technology"],
//         icon: <Science />,
//       },
//       {
//         career: "Biologist",
//         confidence: 78,
//         skills: [
//           "Biological Research",
//           "Laboratory Skills",
//           "Data Analysis",
//           "Field Work",
//         ],
//         education: "Degree in Biology",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Study living organisms and their relationships with the environment",
//         growth: "13% (2023-2028)",
//         subjects: ["Biology", "Science & Technology", "Mathematics"],
//         icon: <Biotech />,
//       },
//       {
//         career: "Geologist",
//         confidence: 76,
//         skills: ["Field Work", "Mineral Identification", "Mapping", "Analysis"],
//         education: "Degree in Geology",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Study the Earth, its materials, and the processes that shape it",
//         growth: "15% (2023-2028)",
//         subjects: ["Geography", "Science & Technology", "Mathematics"],
//         icon: <Agriculture />,
//       },
//       {
//         career: "Meteorologist",
//         confidence: 74,
//         skills: [
//           "Weather Analysis",
//           "Climate Science",
//           "Data Interpretation",
//           "Forecasting",
//         ],
//         education: "Degree in Meteorology",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["University of Nairobi", "Kenyatta University"],
//         description: "Study and predict weather patterns and climate changes",
//         growth: "12% (2023-2028)",
//         subjects: ["Geography", "Mathematics", "Science & Technology"],
//         icon: <Cloud />,
//       },
//       {
//         career: "Astronomer",
//         confidence: 72,
//         skills: [
//           "Observational Astronomy",
//           "Data Analysis",
//           "Physics",
//           "Mathematical Modeling",
//         ],
//         education: "Degree in Astronomy/Physics",
//         pathway: "University",
//         demand: "Low",
//         salary: "Medium",
//         kenyan_institutions: ["University of Nairobi"],
//         description: "Study celestial objects and phenomena in the universe",
//         growth: "8% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Science & Technology"],
//         icon: <Science />,
//       },
//     ],

//     // Healthcare Careers (80+ options)
//     healthcare: [
//       {
//         career: "Medical Doctor",
//         confidence: 90,
//         skills: [
//           "Medical Knowledge",
//           "Diagnosis",
//           "Patient Care",
//           "Communication",
//         ],
//         education: "MBChB Degree (6 years)",
//         pathway: "University",
//         demand: "Very High",
//         salary: "Very High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Moi University",
//           "Kenyatta University",
//           "JKUAT",
//         ],
//         description:
//           "Diagnose and treat illnesses, injuries, and other health conditions",
//         growth: "20% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Registered Nurse",
//         confidence: 78,
//         skills: [
//           "Patient Care",
//           "Medical Knowledge",
//           "Empathy",
//           "Communication",
//         ],
//         education: "Diploma in Nursing (3 years)",
//         pathway: "College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Medical Training College",
//           "Nairobi Hospital Training School",
//           "Aga Khan University Hospital",
//         ],
//         description:
//           "Provide direct patient care and assist doctors in medical procedures",
//         growth: "18% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "English Language"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Clinical Officer",
//         confidence: 75,
//         skills: [
//           "Diagnosis",
//           "Treatment",
//           "Patient Management",
//           "Medical Procedures",
//         ],
//         education: "Diploma in Clinical Medicine (3 years)",
//         pathway: "College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Medical Training College",
//           "Various Medical Training Colleges",
//         ],
//         description:
//           "Diagnose and treat common illnesses and perform minor medical procedures",
//         growth: "16% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Dentist",
//         confidence: 82,
//         skills: [
//           "Dental Procedures",
//           "Oral Health",
//           "Patient Care",
//           "Manual Dexterity",
//         ],
//         education: "Degree in Dental Surgery (5 years)",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: ["University of Nairobi", "Kenyatta University"],
//         description:
//           "Diagnose and treat dental problems and promote oral health",
//         growth: "15% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Pharmacist",
//         confidence: 80,
//         skills: [
//           "Medication Knowledge",
//           "Dispensing",
//           "Patient Counseling",
//           "Chemistry",
//         ],
//         education: "Degree in Pharmacy (5 years)",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Mount Kenya University",
//         ],
//         description:
//           "Prepare and dispense medications and provide drug information",
//         growth: "14% (2023-2028)",
//         subjects: ["Chemistry", "Biology", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Physiotherapist",
//         confidence: 77,
//         skills: [
//           "Rehabilitation",
//           "Physical Therapy",
//           "Anatomy",
//           "Patient Care",
//         ],
//         education: "Degree in Physiotherapy (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Help patients recover movement and function through physical therapy",
//         growth: "16% (2023-2028)",
//         subjects: ["Biology", "Physics", "Physical Education"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Medical Laboratory Technologist",
//         confidence: 76,
//         skills: [
//           "Laboratory Testing",
//           "Sample Analysis",
//           "Quality Control",
//           "Equipment Operation",
//         ],
//         education: "Diploma in Medical Laboratory Sciences (3 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Medical Training College",
//           "Various Medical Training Colleges",
//         ],
//         description:
//           "Perform laboratory tests to help diagnose and treat diseases",
//         growth: "15% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "Mathematics"],
//         icon: <Science />,
//       },
//       {
//         career: "Radiographer",
//         confidence: 74,
//         skills: [
//           "Medical Imaging",
//           "Radiation Safety",
//           "Patient Care",
//           "Equipment Operation",
//         ],
//         education: "Diploma in Radiography (3 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Medical Training College",
//           "University of Nairobi",
//         ],
//         description:
//           "Operate medical imaging equipment to diagnose and treat diseases",
//         growth: "14% (2023-2028)",
//         subjects: ["Physics", "Biology", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Nutritionist/Dietitian",
//         confidence: 73,
//         skills: [
//           "Nutrition Science",
//           "Diet Planning",
//           "Health Education",
//           "Counseling",
//         ],
//         education: "Degree in Nutrition and Dietetics (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "University of Nairobi",
//           "JKUAT",
//         ],
//         description:
//           "Advise people on healthy eating and develop nutrition plans",
//         growth: "17% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "Home Science"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Public Health Officer",
//         confidence: 75,
//         skills: [
//           "Community Health",
//           "Epidemiology",
//           "Health Education",
//           "Policy Implementation",
//         ],
//         education: "Degree in Public Health (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "University of Nairobi",
//           "Moi University",
//         ],
//         description: "Work to improve community health and prevent diseases",
//         growth: "18% (2023-2028)",
//         subjects: ["Biology", "Social Studies", "English Language"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Veterinary Doctor",
//         confidence: 79,
//         skills: ["Animal Medicine", "Surgery", "Diagnosis", "Animal Care"],
//         education: "Degree in Veterinary Medicine (6 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: ["University of Nairobi", "JKUAT"],
//         description: "Diagnose and treat illnesses and injuries in animals",
//         growth: "16% (2023-2028)",
//         subjects: ["Biology", "Chemistry", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Optometrist",
//         confidence: 76,
//         skills: [
//           "Eye Examination",
//           "Vision Testing",
//           "Contact Lens Fitting",
//           "Patient Care",
//         ],
//         education: "Degree in Optometry (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["University of Nairobi", "Kenyatta University"],
//         description:
//           "Examine eyes and prescribe corrective lenses or vision therapy",
//         growth: "15% (2023-2028)",
//         subjects: ["Biology", "Physics", "Mathematics"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Medical Records Officer",
//         confidence: 70,
//         skills: [
//           "Record Keeping",
//           "Data Management",
//           "Confidentiality",
//           "Organization",
//         ],
//         education: "Diploma in Health Records (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Medical Training College",
//           "Various Medical Training Colleges",
//         ],
//         description:
//           "Manage and maintain patient medical records and information systems",
//         growth: "13% (2023-2028)",
//         subjects: ["Business Studies", "Computer Studies", "English Language"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Health Administrator",
//         confidence: 74,
//         skills: [
//           "Healthcare Management",
//           "Administration",
//           "Leadership",
//           "Budgeting",
//         ],
//         education: "Degree in Health Systems Management (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "University of Nairobi",
//           "Mount Kenya University",
//         ],
//         description:
//           "Manage healthcare facilities and coordinate medical services",
//         growth: "16% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "English Language"],
//         icon: <MedicalServices />,
//       },
//       {
//         career: "Community Health Worker",
//         confidence: 68,
//         skills: [
//           "Health Education",
//           "Community Outreach",
//           "Basic Healthcare",
//           "Communication",
//         ],
//         education: "Certificate in Community Health (1 year)",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Low",
//         kenyan_institutions: [
//           "Various Vocational Training Centers",
//           "KMTC Outreach Centers",
//         ],
//         description:
//           "Provide basic healthcare services and health education in communities",
//         growth: "20% (2023-2028)",
//         subjects: ["Biology", "Social Studies", "English Language"],
//         icon: <MedicalServices />,
//       },
//     ],

//     // Business & Finance (100+ options)
//     business_finance: [
//       {
//         career: "Chartered Accountant",
//         confidence: 85,
//         skills: ["Accounting", "Auditing", "Financial Analysis", "Taxation"],
//         education: "Degree in Accounting + CPA (4+ years)",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Strathmore University",
//           "KCA University",
//           "Kenyatta University",
//         ],
//         description:
//           "Manage financial records, conduct audits, and provide financial advice",
//         growth: "15% (2023-2028)",
//         subjects: ["Mathematics", "Business Studies", "English Language"],
//         icon: <AccountBalance />,
//       },
//       {
//         career: "Financial Analyst",
//         confidence: 80,
//         skills: [
//           "Financial Modeling",
//           "Analysis",
//           "Excel",
//           "Investment Research",
//         ],
//         education: "Degree in Finance/Economics (4 years)",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "Strathmore University",
//           "University of Nairobi",
//           "USIU Africa",
//           "Kenyatta University",
//         ],
//         description:
//           "Analyze financial data and provide investment recommendations",
//         growth: "16% (2023-2028)",
//         subjects: ["Mathematics", "Business Studies", "Economics"],
//         icon: <TrendingUp />,
//       },
//       {
//         career: "Marketing Manager",
//         confidence: 77,
//         skills: [
//           "Strategy",
//           "Communication",
//           "Market Research",
//           "Digital Marketing",
//         ],
//         education: "Degree in Marketing/Business (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Mount Kenya University",
//           "Strathmore University",
//         ],
//         description:
//           "Develop and implement marketing strategies to promote products/services",
//         growth: "14% (2023-2028)",
//         subjects: ["Business Studies", "English Language", "Creative Arts"],
//         icon: <Business />,
//       },
//       {
//         career: "Human Resources Manager",
//         confidence: 76,
//         skills: ["Recruitment", "Employee Relations", "Training", "Labor Laws"],
//         education: "Degree in Human Resources (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Mount Kenya University",
//         ],
//         description:
//           "Manage recruitment, employee relations, and organizational development",
//         growth: "13% (2023-2028)",
//         subjects: ["Business Studies", "Social Studies", "English Language"],
//         icon: <Group />,
//       },
//       {
//         career: "Business Analyst",
//         confidence: 79,
//         skills: [
//           "Requirements Analysis",
//           "Process Improvement",
//           "Data Analysis",
//           "Communication",
//         ],
//         education: "Degree in Business/IT (4 years)",
//         pathway: "University",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Strathmore University",
//           "University of Nairobi",
//           "KCA University",
//         ],
//         description: "Analyze business processes and recommend improvements",
//         growth: "18% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "Computer Studies"],
//         icon: <Business />,
//       },
//       {
//         career: "Entrepreneur/Business Owner",
//         confidence: 75,
//         skills: [
//           "Leadership",
//           "Risk Management",
//           "Innovation",
//           "Financial Management",
//         ],
//         education: "Business Training + Experience",
//         pathway: "Various",
//         demand: "High",
//         salary: "Variable",
//         kenyan_institutions: [
//           "Strathmore Business School",
//           "University of Nairobi Entrepreneurship Center",
//         ],
//         description: "Start and manage your own business venture",
//         growth: "20% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "Creative Arts"],
//         icon: <Business />,
//       },
//       {
//         career: "Banking Officer",
//         confidence: 73,
//         skills: [
//           "Customer Service",
//           "Financial Products",
//           "Sales",
//           "Compliance",
//         ],
//         education: "Degree in Banking/Finance (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Cooperative University",
//           "KCA University",
//           "Mount Kenya University",
//         ],
//         description:
//           "Manage bank operations and provide financial services to customers",
//         growth: "12% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "English Language"],
//         icon: <AccountBalance />,
//       },
//       {
//         career: "Insurance Agent",
//         confidence: 71,
//         skills: [
//           "Sales",
//           "Customer Service",
//           "Insurance Products",
//           "Risk Assessment",
//         ],
//         education: "Diploma in Insurance (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "College of Insurance",
//           "Various Technical Colleges",
//         ],
//         description:
//           "Sell insurance policies and provide risk management advice",
//         growth: "14% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "English Language"],
//         icon: <Business />,
//       },
//       {
//         career: "Real Estate Agent",
//         confidence: 72,
//         skills: [
//           "Sales",
//           "Negotiation",
//           "Property Knowledge",
//           "Customer Service",
//         ],
//         education: "Certificate in Real Estate (1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Variable",
//         kenyan_institutions: ["Various Real Estate Training Schools"],
//         description: "Help clients buy, sell, and rent properties",
//         growth: "16% (2023-2028)",
//         subjects: ["Business Studies", "Geography", "English Language"],
//         icon: <Business />,
//       },
//       {
//         career: "Supply Chain Manager",
//         confidence: 78,
//         skills: [
//           "Logistics",
//           "Inventory Management",
//           "Procurement",
//           "Distribution",
//         ],
//         education: "Degree in Supply Chain Management (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "JKUAT",
//           "University of Nairobi",
//           "Kenyatta University",
//         ],
//         description:
//           "Manage the flow of goods and services from production to consumption",
//         growth: "15% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "Geography"],
//         icon: <LocalShipping />,
//       },
//       {
//         career: "Project Manager",
//         confidence: 76,
//         skills: ["Planning", "Coordination", "Leadership", "Budget Management"],
//         education: "Degree + Project Management Certification",
//         pathway: "University",
//         demand: "High",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Strathmore University",
//           "KCA University",
//         ],
//         description:
//           "Plan and oversee projects to ensure they are completed successfully",
//         growth: "17% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "English Language"],
//         icon: <Work />,
//       },
//       {
//         career: "Management Consultant",
//         confidence: 82,
//         skills: ["Problem Solving", "Analysis", "Strategy", "Communication"],
//         education: "Degree in Business/Management (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: [
//           "Strathmore University",
//           "University of Nairobi",
//           "USIU Africa",
//         ],
//         description:
//           "Advise organizations on how to improve performance and efficiency",
//         growth: "16% (2023-2028)",
//         subjects: ["Business Studies", "Mathematics", "English Language"],
//         icon: <Business />,
//       },
//       {
//         career: "Actuary",
//         confidence: 84,
//         skills: [
//           "Statistics",
//           "Risk Assessment",
//           "Mathematics",
//           "Financial Modeling",
//         ],
//         education: "Degree in Actuarial Science (4 years)",
//         pathway: "University",
//         demand: "High",
//         salary: "Very High",
//         kenyan_institutions: [
//           "JKUAT",
//           "University of Nairobi",
//           "Strathmore University",
//         ],
//         description: "Analyze financial risks using mathematics and statistics",
//         growth: "18% (2023-2028)",
//         subjects: ["Mathematics", "Business Studies", "Computer Studies"],
//         icon: <Calculate />,
//       },
//       {
//         career: "Investment Banker",
//         confidence: 81,
//         skills: [
//           "Financial Analysis",
//           "Deal Making",
//           "Negotiation",
//           "Market Knowledge",
//         ],
//         education: "Degree in Finance/Economics (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Very High",
//         kenyan_institutions: [
//           "Strathmore University",
//           "University of Nairobi",
//           "USIU Africa",
//         ],
//         description:
//           "Help companies raise capital and execute financial transactions",
//         growth: "15% (2023-2028)",
//         subjects: ["Mathematics", "Business Studies", "Economics"],
//         icon: <TrendingUp />,
//       },
//       {
//         career: "Tax Consultant",
//         confidence: 74,
//         skills: ["Tax Law", "Compliance", "Planning", "Analysis"],
//         education: "Degree in Accounting/Taxation (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Mount Kenya University",
//         ],
//         description:
//           "Advise clients on tax matters and ensure compliance with tax laws",
//         growth: "14% (2023-2028)",
//         subjects: ["Mathematics", "Business Studies", "Social Studies"],
//         icon: <AccountBalance />,
//       },
//     ],

//     // Creative Arts (60+ options)
//     creative_arts: [
//       {
//         career: "Graphic Designer",
//         confidence: 76,
//         skills: [
//           "Creativity",
//           "Software Skills",
//           "Visual Communication",
//           "Typography",
//         ],
//         education: "Diploma in Graphic Design (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Nairobi Technical Training Institute",
//           "Kenya Institute of Design",
//           "Buru Buru Institute of Fine Arts",
//         ],
//         description: "Create visual concepts to communicate ideas and messages",
//         growth: "16% (2023-2028)",
//         subjects: ["Creative Arts", "Computer Studies", "English Language"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Journalist",
//         confidence: 74,
//         skills: ["Writing", "Research", "Communication", "Interviewing"],
//         education: "Degree in Journalism (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Daystar University",
//           "USIU Africa",
//           "Kenyatta University",
//         ],
//         description:
//           "Research and report news stories for various media outlets",
//         growth: "12% (2023-2028)",
//         subjects: ["English Language", "Social Studies", "History"],
//         icon: <MenuBook />,
//       },
//       {
//         career: "Musician",
//         confidence: 72,
//         skills: ["Musical Talent", "Performance", "Composition", "Practice"],
//         education: "Music School/Self-taught",
//         pathway: "Vocational",
//         demand: "Low",
//         salary: "Variable",
//         kenyan_institutions: [
//           "Kenya Conservatoire of Music",
//           "Kenyatta University Music Department",
//         ],
//         description: "Perform, compose, and record music professionally",
//         growth: "10% (2023-2028)",
//         subjects: ["Music", "Creative Arts", "English Language"],
//         icon: <MusicNoteIcon />,
//       },
//       {
//         career: "Actor/Actress",
//         confidence: 70,
//         skills: [
//           "Performance",
//           "Emotional Expression",
//           "Memorization",
//           "Voice Projection",
//         ],
//         education: "Drama School/Theatre Training",
//         pathway: "Vocational",
//         demand: "Low",
//         salary: "Variable",
//         kenyan_institutions: [
//           "Kenya National Theatre",
//           "University of Nairobi Drama Department",
//         ],
//         description:
//           "Perform roles in films, television shows, and theater productions",
//         growth: "11% (2023-2028)",
//         subjects: ["Creative Arts", "English Language", "Music"],
//         icon: <TheaterComedy />,
//       },
//       {
//         career: "Photographer",
//         confidence: 73,
//         skills: ["Creativity", "Technical Skills", "Composition", "Editing"],
//         education: "Photography Courses/Certificate (1-2 years)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Nairobi Photography School",
//           "Various Art Institutes",
//         ],
//         description: "Capture and create visual images for various purposes",
//         growth: "14% (2023-2028)",
//         subjects: ["Creative Arts", "Physics", "Computer Studies"],
//         icon: <CameraAlt />,
//       },
//       {
//         career: "Fashion Designer",
//         confidence: 71,
//         skills: ["Creativity", "Design", "Trend Awareness", "Sewing"],
//         education: "Diploma in Fashion Design (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "Nairobi Technical Training Institute",
//         ],
//         description:
//           "Create clothing and accessory designs for various markets",
//         growth: "13% (2023-2028)",
//         subjects: ["Creative Arts", "Home Science", "Business Studies"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Interior Designer",
//         confidence: 75,
//         skills: ["Creativity", "Spatial Awareness", "Client Management", "CAD"],
//         education: "Diploma in Interior Design (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Technical University of Kenya",
//         ],
//         description:
//           "Design and decorate interior spaces for homes and businesses",
//         growth: "15% (2023-2028)",
//         subjects: ["Creative Arts", "Mathematics", "Physics"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Video Editor",
//         confidence: 74,
//         skills: [
//           "Creativity",
//           "Software Skills",
//           "Storytelling",
//           "Attention to Detail",
//         ],
//         education: "Diploma in Film Production (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "MultiMedia University",
//           "Kenya Institute of Mass Communication",
//         ],
//         description:
//           "Edit and assemble raw footage into finished video products",
//         growth: "18% (2023-2028)",
//         subjects: ["Creative Arts", "Computer Studies", "English Language"],
//         icon: <CameraAlt />,
//       },
//       {
//         career: "Animator",
//         confidence: 73,
//         skills: ["Drawing", "Software Skills", "Creativity", "Storytelling"],
//         education: "Diploma in Animation (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "MultiMedia University",
//           "Kenyatta University",
//           "Nairobi Technical Training Institute",
//         ],
//         description:
//           "Create animated sequences for films, games, and advertisements",
//         growth: "17% (2023-2028)",
//         subjects: ["Creative Arts", "Computer Studies", "Mathematics"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Architect",
//         confidence: 79,
//         skills: ["Design", "Mathematics", "Spatial Awareness", "CAD"],
//         education: "Degree in Architecture (5 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "JKUAT",
//           "Technical University of Kenya",
//         ],
//         description: "Design buildings and oversee their construction",
//         growth: "16% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Creative Arts"],
//         icon: <Architecture />,
//       },
//       {
//         career: "Art Director",
//         confidence: 77,
//         skills: [
//           "Creativity",
//           "Leadership",
//           "Visual Design",
//           "Project Management",
//         ],
//         education: "Degree in Fine Arts/Design (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "University of Nairobi",
//           "Buru Buru Institute of Fine Arts",
//         ],
//         description:
//           "Oversee the visual style and images in various media productions",
//         growth: "14% (2023-2028)",
//         subjects: ["Creative Arts", "Business Studies", "English Language"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Copywriter",
//         confidence: 76,
//         skills: ["Writing", "Creativity", "Marketing", "Communication"],
//         education: "Degree in Communications/Journalism (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Daystar University",
//           "Kenyatta University",
//         ],
//         description:
//           "Write persuasive text for advertisements and marketing materials",
//         growth: "15% (2023-2028)",
//         subjects: ["English Language", "Business Studies", "Creative Arts"],
//         icon: <MenuBook />,
//       },
//       {
//         career: "Game Developer",
//         confidence: 78,
//         skills: ["Programming", "Creativity", "Game Design", "Problem Solving"],
//         education: "Degree in Game Development/Computer Science (4 years)",
//         pathway: "University",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "JKUAT",
//           "KCA University",
//           "MultiMedia University",
//         ],
//         description: "Design and develop video games for various platforms",
//         growth: "20% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Creative Arts"],
//         icon: <Code />,
//       },
//       {
//         career: "UI/UX Designer",
//         confidence: 77,
//         skills: [
//           "User Research",
//           "Wireframing",
//           "Prototyping",
//           "Visual Design",
//         ],
//         education: "Diploma in UI/UX Design (2 years)",
//         pathway: "College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Nairobi Design Institute",
//           "Various Technical Colleges",
//         ],
//         description:
//           "Design user interfaces and experiences for digital products",
//         growth: "22% (2023-2028)",
//         subjects: ["Computer Studies", "Creative Arts", "Psychology"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Film Director",
//         confidence: 72,
//         skills: [
//           "Storytelling",
//           "Leadership",
//           "Creative Vision",
//           "Communication",
//         ],
//         education: "Film School/Degree in Film Production",
//         pathway: "University/Vocational",
//         demand: "Low",
//         salary: "Variable",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "MultiMedia University",
//           "Kenya Film School",
//         ],
//         description: "Oversee the creative aspects of film production",
//         growth: "12% (2023-2028)",
//         subjects: ["Creative Arts", "English Language", "History"],
//         icon: <CameraAlt />,
//       },
//     ],

//     // Education & Social Services (50+ options)
//     education_social: [
//       {
//         career: "Secondary School Teacher",
//         confidence: 75,
//         skills: [
//           "Teaching",
//           "Subject Knowledge",
//           "Communication",
//           "Classroom Management",
//         ],
//         education: "Degree + Teaching Certificate (4+ years)",
//         pathway: "University",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenyatta University",
//           "University of Nairobi",
//           "Moi University",
//           "Maseno University",
//         ],
//         description:
//           "Educate students in specific subjects at secondary school level",
//         growth: "14% (2023-2028)",
//         subjects: [
//           "Subject Specialization",
//           "English Language",
//           "Social Studies",
//         ],
//         icon: <School />,
//       },
//       {
//         career: "Primary School Teacher",
//         confidence: 73,
//         skills: ["Teaching", "Child Development", "Communication", "Patience"],
//         education: "Diploma in Primary Education (2 years)",
//         pathway: "College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Various Teacher Training Colleges",
//           "Kenyatta University",
//           "University of Nairobi",
//         ],
//         description: "Educate young children in basic subjects and life skills",
//         growth: "15% (2023-2028)",
//         subjects: [
//           "All Primary Subjects",
//           "Child Development",
//           "Teaching Methods",
//         ],
//         icon: <School />,
//       },
//       {
//         career: "University Lecturer",
//         confidence: 82,
//         skills: [
//           "Research",
//           "Teaching",
//           "Subject Expertise",
//           "Academic Writing",
//         ],
//         education: "Masters/PhD in Specialized Field",
//         pathway: "University",
//         demand: "Medium",
//         salary: "High",
//         kenyan_institutions: ["All Public and Private Universities in Kenya"],
//         description: "Teach and conduct research at university level",
//         growth: "12% (2023-2028)",
//         subjects: [
//           "Specialized Subject",
//           "Research Methods",
//           "Academic Writing",
//         ],
//         icon: <School />,
//       },
//       {
//         career: "Social Worker",
//         confidence: 72,
//         skills: [
//           "Empathy",
//           "Communication",
//           "Problem Solving",
//           "Case Management",
//         ],
//         education: "Degree in Social Work (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Help individuals and communities overcome challenges and improve wellbeing",
//         growth: "16% (2023-2028)",
//         subjects: ["Social Studies", "Psychology", "English Language"],
//         icon: <Group />,
//       },
//       {
//         career: "Counselor",
//         confidence: 74,
//         skills: [
//           "Listening",
//           "Empathy",
//           "Communication",
//           "Psychology Knowledge",
//         ],
//         education: "Degree in Counseling Psychology (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Daystar University",
//         ],
//         description:
//           "Provide guidance and support to individuals facing personal challenges",
//         growth: "18% (2023-2028)",
//         subjects: ["Psychology", "Social Studies", "English Language"],
//         icon: <PsychologyAlt />,
//       },
//       {
//         career: "Childcare Worker",
//         confidence: 68,
//         skills: ["Child Care", "Patience", "Communication", "Safety Awareness"],
//         education: "Certificate in Early Childhood Education (1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Low",
//         kenyan_institutions: [
//           "Various ECD Colleges",
//           "Kenya Institute of Special Education",
//         ],
//         description:
//           "Care for and supervise young children in various settings",
//         growth: "14% (2023-2028)",
//         subjects: ["Child Development", "Home Science", "Social Studies"],
//         icon: <Group />,
//       },
//       {
//         career: "Special Needs Teacher",
//         confidence: 76,
//         skills: [
//           "Special Education",
//           "Patience",
//           "Adaptability",
//           "Individualized Instruction",
//         ],
//         education: "Diploma in Special Needs Education (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Kenya Institute of Special Education",
//           "Various Teacher Training Colleges",
//         ],
//         description:
//           "Educate students with disabilities or special learning needs",
//         growth: "17% (2023-2028)",
//         subjects: [
//           "Special Education Methods",
//           "Psychology",
//           "Teaching Strategies",
//         ],
//         icon: <School />,
//       },
//       {
//         career: "Youth Worker",
//         confidence: 71,
//         skills: [
//           "Mentoring",
//           "Communication",
//           "Program Planning",
//           "Community Engagement",
//         ],
//         education: "Diploma in Youth Development (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Various Community Development Colleges",
//           "University of Nairobi",
//         ],
//         description:
//           "Support and guide young people in their personal development",
//         growth: "15% (2023-2028)",
//         subjects: ["Social Studies", "Psychology", "Communication Skills"],
//         icon: <Group />,
//       },
//       {
//         career: "Community Development Officer",
//         confidence: 73,
//         skills: [
//           "Community Engagement",
//           "Project Management",
//           "Communication",
//           "Needs Assessment",
//         ],
//         education: "Degree in Community Development (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Work with communities to identify needs and develop improvement projects",
//         growth: "16% (2023-2028)",
//         subjects: ["Social Studies", "Economics", "Geography"],
//         icon: <Public />,
//       },
//       {
//         career: "Pastoral Worker",
//         confidence: 70,
//         skills: [
//           "Spiritual Guidance",
//           "Counseling",
//           "Leadership",
//           "Public Speaking",
//         ],
//         education: "Theological Training (2-4 years)",
//         pathway: "College/University",
//         demand: "Medium",
//         salary: "Variable",
//         kenyan_institutions: [
//           "Various Theological Colleges",
//           "University of Nairobi",
//         ],
//         description:
//           "Provide spiritual guidance and support to religious communities",
//         growth: "13% (2023-2028)",
//         subjects: ["Religious Education", "Social Studies", "English Language"],
//         icon: <PsychologyAlt />,
//       },
//       {
//         career: "Career Counselor",
//         confidence: 75,
//         skills: ["Assessment", "Guidance", "Communication", "Career Knowledge"],
//         education: "Degree in Counseling/Career Development (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Mount Kenya University",
//         ],
//         description:
//           "Help individuals make career decisions and plan career paths",
//         growth: "17% (2023-2028)",
//         subjects: ["Psychology", "Business Studies", "Social Studies"],
//         icon: <Work />,
//       },
//       {
//         career: "Adult Education Teacher",
//         confidence: 72,
//         skills: [
//           "Teaching",
//           "Patience",
//           "Communication",
//           "Curriculum Development",
//         ],
//         education: "Diploma in Adult Education (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Various Adult Education Centers",
//         ],
//         description: "Teach basic literacy and skills to adult learners",
//         growth: "14% (2023-2028)",
//         subjects: ["Literacy", "Numeracy", "Life Skills"],
//         icon: <School />,
//       },
//       {
//         career: "Library Scientist",
//         confidence: 74,
//         skills: [
//           "Information Management",
//           "Research",
//           "Organization",
//           "Customer Service",
//         ],
//         education: "Degree in Library Science (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["University of Nairobi", "Kenyatta University"],
//         description:
//           "Manage library resources and help users access information",
//         growth: "12% (2023-2028)",
//         subjects: ["English Language", "Computer Studies", "Research Methods"],
//         icon: <MenuBook />,
//       },
//       {
//         career: "Museum Curator",
//         confidence: 73,
//         skills: [
//           "Research",
//           "Exhibition Design",
//           "Artifact Preservation",
//           "Public Education",
//         ],
//         education: "Degree in Museum Studies/History (4 years)",
//         pathway: "University",
//         demand: "Low",
//         salary: "Medium",
//         kenyan_institutions: ["University of Nairobi", "Kenyatta University"],
//         description:
//           "Manage museum collections and create educational exhibitions",
//         growth: "11% (2023-2028)",
//         subjects: ["History", "Creative Arts", "Research Methods"],
//         icon: <MenuBook />,
//       },
//       {
//         career: "Educational Administrator",
//         confidence: 77,
//         skills: [
//           "Leadership",
//           "Management",
//           "Policy Implementation",
//           "Budgeting",
//         ],
//         education: "Degree in Education Administration (4 years)",
//         pathway: "University",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "University of Nairobi",
//           "Kenyatta University",
//           "Moi University",
//         ],
//         description:
//           "Manage educational institutions and oversee academic programs",
//         growth: "15% (2023-2028)",
//         subjects: ["Business Studies", "Education", "Leadership"],
//         icon: <School />,
//       },
//     ],

//     // Technical & Vocational (80+ options)
//     technical_vocational: [
//       {
//         career: "Electrician",
//         confidence: 70,
//         skills: ["Electrical Systems", "Safety", "Troubleshooting", "Wiring"],
//         education: "Artisan Certificate (1-2 years)",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "NYS Technical Institute",
//           "Various Vocational Centers",
//           "Technical Training Institutes",
//         ],
//         description:
//           "Install, maintain, and repair electrical systems and equipment",
//         growth: "16% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Pre-Technical"],
//         icon: <ElectricBolt />,
//       },
//       {
//         career: "Plumber",
//         confidence: 68,
//         skills: ["Pipe Systems", "Installation", "Repair", "Blueprint Reading"],
//         education: "Artisan Certificate (1-2 years)",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Youth Polytechnics",
//           "Technical Training Institutes",
//           "NYS",
//         ],
//         description: "Install and repair water supply and drainage systems",
//         growth: "15% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Pre-Technical"],
//         icon: <Build />,
//       },
//       {
//         career: "Carpenter",
//         confidence: 69,
//         skills: ["Woodworking", "Precision", "Creativity", "Blueprint Reading"],
//         education: "Artisan Certificate (1-2 years)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Youth Polytechnics",
//           "Technical Training Institutes",
//         ],
//         description:
//           "Construct, install, and repair wooden structures and furniture",
//         growth: "14% (2023-2028)",
//         subjects: ["Mathematics", "Creative Arts", "Pre-Technical"],
//         icon: <Build />,
//       },
//       {
//         career: "Mason",
//         confidence: 67,
//         skills: [
//           "Brickwork",
//           "Concrete Work",
//           "Measurement",
//           "Physical Stamina",
//         ],
//         education: "Artisan Certificate (1 year)",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Youth Polytechnics",
//           "Technical Training Institutes",
//         ],
//         description: "Build structures with bricks, blocks, and stone",
//         growth: "16% (2023-2028)",
//         subjects: ["Mathematics", "Physics", "Pre-Technical"],
//         icon: <Build />,
//       },
//       {
//         career: "Welder",
//         confidence: 71,
//         skills: ["Metal Work", "Safety", "Precision", "Blueprint Reading"],
//         education: "Artisan Certificate (1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["Technical Training Institutes", "NYS"],
//         description: "Join metal parts using various welding techniques",
//         growth: "15% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Pre-Technical"],
//         icon: <Build />,
//       },
//       {
//         career: "Auto Mechanic",
//         confidence: 72,
//         skills: [
//           "Mechanical Skills",
//           "Problem Solving",
//           "Attention to Detail",
//           "Diagnostics",
//         ],
//         education: "Artisan Certificate (1-2 years)",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Technical Training Institutes",
//           "NYS",
//           "Various Automotive Schools",
//         ],
//         description: "Repair and maintain automobiles and other vehicles",
//         growth: "17% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Pre-Technical"],
//         icon: <DirectionsCar />,
//       },
//       {
//         career: "HVAC Technician",
//         confidence: 70,
//         skills: [
//           "Heating/Cooling Systems",
//           "Refrigeration",
//           "Electrical Work",
//           "Troubleshooting",
//         ],
//         education: "Artisan Certificate (1-2 years)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["Technical Training Institutes", "NYS"],
//         description:
//           "Install and maintain heating, ventilation, and air conditioning systems",
//         growth: "18% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Pre-Technical"],
//         icon: <Build />,
//       },
//       {
//         career: "Heavy Equipment Operator",
//         confidence: 69,
//         skills: [
//           "Equipment Operation",
//           "Safety",
//           "Coordination",
//           "Maintenance",
//         ],
//         education: "Vocational Training (6 months - 1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["NYS", "Various Construction Training Centers"],
//         description:
//           "Operate heavy machinery for construction and other projects",
//         growth: "16% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Pre-Technical"],
//         icon: <Engineering />,
//       },
//       {
//         career: "Painter",
//         confidence: 66,
//         skills: [
//           "Color Theory",
//           "Surface Preparation",
//           "Attention to Detail",
//           "Physical Stamina",
//         ],
//         education: "Vocational Training (6 months - 1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Youth Polytechnics",
//           "Various Vocational Centers",
//         ],
//         description:
//           "Apply paint and finishes to buildings and other structures",
//         growth: "14% (2023-2028)",
//         subjects: ["Creative Arts", "Mathematics", "Chemistry"],
//         icon: <Palette />,
//       },
//       {
//         career: "Solar Technician",
//         confidence: 73,
//         skills: [
//           "Solar Systems",
//           "Electrical Work",
//           "Installation",
//           "Maintenance",
//         ],
//         education: "Certificate in Solar Technology (1 year)",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Various Technical Institutes",
//           "Renewable Energy Training Centers",
//         ],
//         description: "Install and maintain solar energy systems",
//         growth: "25% (2023-2028)",
//         subjects: ["Physics", "Mathematics", "Science & Technology"],
//         icon: <ElectricBolt />,
//       },
//       {
//         career: "ICT Technician",
//         confidence: 74,
//         skills: [
//           "Computer Repair",
//           "Networking",
//           "Software Installation",
//           "Troubleshooting",
//         ],
//         education: "Diploma in ICT (2 years)",
//         pathway: "College",
//         demand: "High",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Technical Training Institutes",
//           "Various ICT Colleges",
//         ],
//         description:
//           "Install, maintain, and repair computer systems and networks",
//         growth: "20% (2023-2028)",
//         subjects: ["Computer Studies", "Mathematics", "Physics"],
//         icon: <Computer />,
//       },
//       {
//         career: "Beautician",
//         confidence: 71,
//         skills: [
//           "Hair Styling",
//           "Skin Care",
//           "Makeup Artistry",
//           "Customer Service",
//         ],
//         education: "Certificate in Beauty Therapy (1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: [
//           "Various Beauty Schools",
//           "Technical Training Institutes",
//         ],
//         description: "Provide beauty treatments and services to clients",
//         growth: "16% (2023-2028)",
//         subjects: ["Creative Arts", "Chemistry", "Business Studies"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Chef",
//         confidence: 72,
//         skills: [
//           "Cooking",
//           "Food Preparation",
//           "Menu Planning",
//           "Kitchen Management",
//         ],
//         education: "Diploma in Culinary Arts (2 years)",
//         pathway: "College",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["Utalii College", "Various Hospitality Colleges"],
//         description:
//           "Prepare and cook food in restaurants and other establishments",
//         growth: "17% (2023-2028)",
//         subjects: ["Home Science", "Business Studies", "Chemistry"],
//         icon: <Restaurant />,
//       },
//       {
//         career: "Tailor/Fashion Designer",
//         confidence: 70,
//         skills: ["Sewing", "Pattern Making", "Design", "Measurement"],
//         education: "Certificate in Tailoring (1 year)",
//         pathway: "Vocational",
//         demand: "Medium",
//         salary: "Medium",
//         kenyan_institutions: ["Youth Polytechnics", "Various Fashion Schools"],
//         description:
//           "Create and alter clothing according to customer specifications",
//         growth: "15% (2023-2028)",
//         subjects: ["Creative Arts", "Mathematics", "Home Science"],
//         icon: <DesignServicesIcon />,
//       },
//       {
//         career: "Driver",
//         confidence: 65,
//         skills: ["Driving", "Navigation", "Safety", "Vehicle Maintenance"],
//         education: "Driving School License",
//         pathway: "Vocational",
//         demand: "High",
//         salary: "Low",
//         kenyan_institutions: ["Various Driving Schools"],
//         description:
//           "Transport people or goods using various types of vehicles",
//         growth: "14% (2023-2028)",
//         subjects: ["Geography", "Mathematics", "Social Studies"],
//         icon: <DirectionsCar />,
//       },
//     ],
//   };

//   // Enhanced analysis functions
//   const performAdvancedAnalysis = (results, interests, learner) => {
//     const subjectAverages = calculateEnhancedSubjectAverages(
//       results,
//       learner?.class
//     );
//     const overallAverage = calculateOverallAverage(subjectAverages);
//     const performanceLevel = getPerformanceLevel(overallAverage);
//     const detectedInterests = analyzeEnhancedInterests(interests);

//     // Calculate skill profiles
//     const skillProfile = calculateSkillProfile(
//       subjectAverages,
//       detectedInterests
//     );
//     const learningStyle = analyzeLearningStyle(results, interests);
//     const personalityTraits = inferPersonalityTraits(
//       subjectAverages,
//       detectedInterests
//     );

//     const analysis = {
//       performanceLevel,
//       overallAverage,
//       subjectAverages,
//       currentClass: learner?.class,
//       interests: detectedInterests,
//       skillProfile,
//       learningStyle,
//       personalityTraits,
//       careerRecommendations: generateEnhancedCareerRecommendations(
//         subjectAverages,
//         performanceLevel,
//         detectedInterests,
//         skillProfile,
//         personalityTraits
//       ),
//       improvementAreas: identifyImprovementAreas(subjectAverages),
//       strengths: identifyStrengths(subjectAverages),
//       confidenceScore: calculateConfidenceScore(
//         subjectAverages,
//         detectedInterests
//       ),
//       learningAdvice: generateLearningAdvice(
//         performanceLevel,
//         subjectAverages,
//         learner?.class
//       ),
//       pathwayRecommendation: getPathwayRecommendation(performanceLevel),
//       marketInsights: getMarketInsights(skillProfile, performanceLevel),
//     };

//     return analysis;
//   };

//   const calculateEnhancedSubjectAverages = (results, currentClass) => {
//     const subjectTotals = {};
//     const subjectCounts = {};
//     const subjectTrends = {};

//     Object.values(results).forEach((termData) => {
//       Object.values(termData).forEach((examData) => {
//         examData.forEach(({ subject, marks }) => {
//           const normalizedSubject = enhancedSubjectMappings[subject]
//             ? subject
//             : Object.keys(enhancedSubjectMappings).find(
//                 (key) =>
//                   key.toLowerCase().includes(subject.toLowerCase()) ||
//                   subject.toLowerCase().includes(key.toLowerCase())
//               ) || subject;

//           if (!subjectTotals[normalizedSubject]) {
//             subjectTotals[normalizedSubject] = 0;
//             subjectCounts[normalizedSubject] = 0;
//             subjectTrends[normalizedSubject] = [];
//           }

//           subjectTotals[normalizedSubject] += Number(marks);
//           subjectCounts[normalizedSubject] += 1;
//           subjectTrends[normalizedSubject].push(Number(marks));
//         });
//       });
//     });

//     const averages = Object.entries(subjectTotals)
//       .map(([subject, total]) => {
//         const average = total / subjectCounts[subject];
//         const trend = calculateTrend(subjectTrends[subject]);
//         const subjectInfo = enhancedSubjectMappings[subject] || {
//           category: "General",
//           weight: 1.0,
//           skills: [],
//         };

//         return {
//           subject,
//           average,
//           count: subjectCounts[subject],
//           trend,
//           category: subjectInfo.category,
//           weight: subjectInfo.weight,
//           skills: subjectInfo.skills,
//           recent: true,
//         };
//       })
//       .sort((a, b) => b.average * b.weight - a.average * a.weight);

//     return averages;
//   };

//   const calculateTrend = (marks) => {
//     if (marks.length < 2) return "stable";
//     const firstHalf = marks.slice(0, Math.floor(marks.length / 2));
//     const secondHalf = marks.slice(Math.floor(marks.length / 2));
//     const firstAvg = firstHalf.reduce((a, b) => a + b, 0) / firstHalf.length;
//     const secondAvg = secondHalf.reduce((a, b) => a + b, 0) / secondHalf.length;

//     if (secondAvg > firstAvg + 5) return "improving";
//     if (secondAvg < firstAvg - 5) return "declining";
//     return "stable";
//   };

//   const analyzeEnhancedInterests = (interestsData) => {
//     if (!interestsData) return null;

//     let homeInterests = [];
//     let schoolInterests = [];

//     if (interestsData.interests) {
//       homeInterests = interestsData.interests.home || [];
//       schoolInterests = interestsData.interests.school || [];
//     } else {
//       homeInterests = interestsData.home || [];
//       schoolInterests = interestsData.school || [];
//     }

//     const interests = {
//       home: homeInterests,
//       school: schoolInterests,
//       detectedCategories: [],
//       primaryInterest: null,
//       secondaryInterest: null,
//       interestStrength: {},
//       combinedInterests: [],
//     };

//     const allInterestText = [];

//     // Process interests
//     homeInterests.forEach((interest) => {
//       if (interest.activities && Array.isArray(interest.activities)) {
//         allInterestText.push(...interest.activities);
//       }
//       if (interest.category) {
//         allInterestText.push(interest.category);
//       }
//       if (interest.notes) {
//         allInterestText.push(interest.notes);
//       }
//     });

//     schoolInterests.forEach((interest) => {
//       if (interest.activities && Array.isArray(interest.activities)) {
//         allInterestText.push(...interest.activities);
//       }
//       if (interest.category) {
//         allInterestText.push(interest.category);
//       }
//       if (interest.notes) {
//         allInterestText.push(interest.notes);
//       }
//     });

//     // Enhanced interest detection
//     const categoryScores = {};

//     allInterestText.forEach((interestText) => {
//       const text = interestText.toString().toLowerCase();

//       Object.entries(enhancedInterestCategories).forEach(([category, data]) => {
//         data.keywords.forEach((keyword) => {
//           if (text.includes(keyword)) {
//             categoryScores[category] = (categoryScores[category] || 0) + 1;
//           }
//         });
//       });
//     });

//     // Sort by strength
//     interests.detectedCategories = Object.entries(categoryScores)
//       .sort(([, a], [, b]) => b - a)
//       .map(([category]) => category);

//     interests.interestStrength = categoryScores;

//     if (interests.detectedCategories.length > 0) {
//       interests.primaryInterest = interests.detectedCategories[0];
//       interests.secondaryInterest = interests.detectedCategories[1] || null;
//     }

//     // Create combined interest profile
//     interests.combinedInterests = interests.detectedCategories.map(
//       (category) => ({
//         category,
//         strength: categoryScores[category],
//         relatedSkills: enhancedInterestCategories[category].skills,
//         potentialCareers: enhancedInterestCategories[category].careers,
//       })
//     );

//     return interests;
//   };

//   const calculateSkillProfile = (subjectAverages, interests) => {
//     const skills = {
//       analytical: 0,
//       creative: 0,
//       technical: 0,
//       communication: 0,
//       practical: 0,
//       leadership: 0,
//       interpersonal: 0,
//     };

//     // Calculate from subjects
//     subjectAverages.forEach((subject) => {
//       const subjectInfo = enhancedSubjectMappings[subject.subject];
//       if (subjectInfo) {
//         subjectInfo.skills.forEach((skill) => {
//           skills[skill] =
//             (skills[skill] || 0) + (subject.average * subjectInfo.weight) / 100;
//         });
//       }
//     });

//     // Boost from interests
//     if (interests && interests.combinedInterests) {
//       interests.combinedInterests.forEach((interest) => {
//         interest.relatedSkills.forEach((skill) => {
//           skills[skill] = (skills[skill] || 0) + interest.strength * 10;
//         });
//       });
//     }

//     // Normalize scores
//     Object.keys(skills).forEach((skill) => {
//       skills[skill] = Math.min(100, Math.max(0, skills[skill]));
//     });

//     return skills;
//   };

//   const analyzeLearningStyle = (results, interests) => {
//     // Simplified learning style analysis
//     const styles = {
//       visual: 50,
//       auditory: 50,
//       kinesthetic: 50,
//     };

//     // Add logic to analyze learning style based on performance patterns
//     return styles;
//   };

//   const inferPersonalityTraits = (subjectAverages, interests) => {
//     const traits = {
//       analytical: 50,
//       creative: 50,
//       social: 50,
//       practical: 50,
//       leadership: 50,
//     };

//     // Add logic to infer personality based on subject performance and interests
//     return traits;
//   };

//   const generateEnhancedCareerRecommendations = (
//     subjectAverages,
//     performanceLevel,
//     interests,
//     skillProfile,
//     personalityTraits
//   ) => {
//     const allRecommendations = [];
//     const seenCareers = new Set();

//     // 1. Academic-performance based recommendations
//     subjectAverages
//       .filter((s) => s.recent && s.average >= 50)
//       .forEach((subject) => {
//         const relevantCareers = findCareersBySubject(
//           subject.subject,
//           performanceLevel
//         );
//         relevantCareers.forEach((career) => {
//           if (!seenCareers.has(career.career)) {
//             seenCareers.add(career.career);
//             const academicScore = calculateAcademicScore(
//               career,
//               subject,
//               performanceLevel
//             );
//             const interestScore = calculateCareerInterestScore(
//               career,
//               interests
//             );
//             const skillScore = calculateSkillMatch(career, skillProfile);
//             const totalScore =
//               academicScore * 0.4 + interestScore * 0.3 + skillScore * 0.3;

//             allRecommendations.push({
//               ...career,
//               confidenceScore: Math.round(totalScore),
//               academicScore: Math.round(academicScore),
//               interestScore: Math.round(interestScore),
//               skillScore: Math.round(skillScore),
//               matchType: "Academic + Interest + Skills",
//               reasons: generateEnhancedReasons(
//                 career,
//                 subject,
//                 interests,
//                 skillProfile
//               ),
//               category: getCareerCategory(career.career),
//             });
//           }
//         });
//       });

//     // 2. Interest-primary recommendations
//     if (interests && interests.detectedCategories.length > 0) {
//       interests.detectedCategories.forEach((category) => {
//         const interestCareers = findCareersByInterest(category);
//         interestCareers.forEach((career) => {
//           if (!seenCareers.has(career.career)) {
//             seenCareers.add(career.career);
//             const academicScore = findBestAcademicMatch(
//               career,
//               subjectAverages,
//               performanceLevel
//             );
//             const interestScore = calculatePureInterestScore(
//               career,
//               interests,
//               category
//             );
//             const skillScore = calculateSkillMatch(career, skillProfile);
//             const totalScore =
//               academicScore * 0.3 + interestScore * 0.4 + skillScore * 0.3;

//             allRecommendations.push({
//               ...career,
//               confidenceScore: Math.round(totalScore),
//               academicScore: Math.round(academicScore),
//               interestScore: Math.round(interestScore),
//               skillScore: Math.round(skillScore),
//               matchType: "Interest Primary",
//               reasons: generateInterestPrimaryReasons(
//                 career,
//                 interests,
//                 category
//               ),
//               category: getCareerCategory(career.career),
//             });
//           }
//         });
//       });
//     }

//     // 3. Skill-based recommendations
//     const topSkills = Object.entries(skillProfile)
//       .sort(([, a], [, b]) => b - a)
//       .slice(0, 3)
//       .map(([skill]) => skill);

//     topSkills.forEach((skill) => {
//       const skillCareers = findCareersBySkill(skill);
//       skillCareers.forEach((career) => {
//         if (
//           !seenCareers.has(career.career) &&
//           allRecommendations.length < 100
//         ) {
//           seenCareers.add(career.career);
//           const academicScore = findBestAcademicMatch(
//             career,
//             subjectAverages,
//             performanceLevel
//           );
//           const interestScore = calculateCareerInterestScore(career, interests);
//           const skillScore = calculateSkillMatch(career, skillProfile);
//           const totalScore =
//             academicScore * 0.25 + interestScore * 0.25 + skillScore * 0.5;

//           allRecommendations.push({
//             ...career,
//             confidenceScore: Math.round(totalScore),
//             academicScore: Math.round(academicScore),
//             interestScore: Math.round(interestScore),
//             skillScore: Math.round(skillScore),
//             matchType: "Skill Primary",
//             reasons: [
//               `Strong ${skill} skills`,
//               "Good skill-to-career alignment",
//             ],
//             category: getCareerCategory(career.career),
//           });
//         }
//       });
//     });

//     // Sort and return
//     return allRecommendations
//       .sort((a, b) => b.confidenceScore - a.confidenceScore)
//       .slice(0, 50); // Return top 50 recommendations
//   };

//   const findCareersBySubject = (subject, performanceLevel) => {
//     const allCareers = [];
//     Object.values(comprehensiveCareerDatabase).forEach((category) => {
//       category.forEach((career) => {
//         if (career.subjects && career.subjects.includes(subject)) {
//           allCareers.push(career);
//         }
//       });
//     });
//     return allCareers.slice(0, 10);
//   };

//   const findCareersByInterest = (interestCategory) => {
//     return comprehensiveCareerDatabase[interestCategory] || [];
//   };

//   const findCareersBySkill = (skill) => {
//     const allCareers = [];
//     Object.values(comprehensiveCareerDatabase).forEach((category) => {
//       category.forEach((career) => {
//         if (
//           career.skills &&
//           career.skills.some((s) =>
//             s.toLowerCase().includes(skill.toLowerCase())
//           )
//         ) {
//           allCareers.push(career);
//         }
//       });
//     });
//     return allCareers.slice(0, 10);
//   };

//   const calculateAcademicScore = (career, subject, performanceLevel) => {
//     let score = career.confidence;

//     // Adjust based on subject performance
//     if (subject.average >= 80) score += 20;
//     else if (subject.average >= 70) score += 15;
//     else if (subject.average >= 60) score += 10;
//     else if (subject.average >= 50) score += 5;

//     // Adjust based on performance level
//     if (performanceLevel === "excellent") score += 15;
//     else if (performanceLevel === "good") score += 10;
//     else if (performanceLevel === "average") score += 5;

//     return Math.max(30, Math.min(95, score));
//   };

//   const calculateCareerInterestScore = (career, interests) => {
//     if (!interests || !interests.detectedCategories.length) return 50;

//     let score = 50;

//     // Check if career category matches interest categories
//     const careerCategory = getCareerCategory(career.career);
//     if (interests.detectedCategories.includes(careerCategory)) {
//       if (careerCategory === interests.primaryInterest) score += 30;
//       else if (careerCategory === interests.secondaryInterest) score += 15;
//       else score += 10;
//     }

//     return Math.max(20, Math.min(90, score));
//   };

//   const calculatePureInterestScore = (career, interests, category) => {
//     if (!interests) return career.confidence;

//     let score = career.confidence;

//     if (category === interests.primaryInterest) score += 25;
//     else if (category === interests.secondaryInterest) score += 15;
//     else score += 5;

//     return Math.max(40, Math.min(95, score));
//   };

//   const calculateSkillMatch = (career, skillProfile) => {
//     let matchScore = 50;

//     // Simple skill matching - in a real system, this would be more sophisticated
//     career.skills.forEach((skill) => {
//       const skillKey = mapSkillToProfile(skill);
//       if (skillProfile[skillKey]) {
//         matchScore += skillProfile[skillKey] / 10;
//       }
//     });

//     return Math.min(95, matchScore);
//   };

//   const mapSkillToProfile = (skill) => {
//     const skillMap = {
//       analytical: "analytical",
//       creative: "creative",
//       technical: "technical",
//       communication: "communication",
//       practical: "practical",
//       leadership: "leadership",
//       interpersonal: "interpersonal",
//     };

//     for (const [key, value] of Object.entries(skillMap)) {
//       if (skill.toLowerCase().includes(key)) return value;
//     }
//     return "practical";
//   };

//   const findBestAcademicMatch = (career, subjectAverages, performanceLevel) => {
//     // Find the best matching subject for this career
//     const relevantSubjects = subjectAverages.filter(
//       (s) =>
//         s.average >= 50 &&
//         career.subjects &&
//         career.subjects.some((subject) =>
//           s.subject.toLowerCase().includes(subject.toLowerCase())
//         )
//     );

//     if (relevantSubjects.length > 0) {
//       const bestSubject = relevantSubjects[0];
//       return Math.min(
//         90,
//         bestSubject.average + (performanceLevel === "excellent" ? 10 : 0)
//       );
//     }

//     // Default academic confidence based on performance level
//     const baseScores = {
//       excellent: 75,
//       good: 60,
//       average: 45,
//       belowAverage: 30,
//       needsImprovement: 20,
//     };

//     return baseScores[performanceLevel] || 50;
//   };

//   const getCareerCategory = (careerName) => {
//     for (const [category, careers] of Object.entries(
//       comprehensiveCareerDatabase
//     )) {
//       if (careers.some((c) => c.career === careerName)) {
//         return category;
//       }
//     }
//     return "stem_technology";
//   };

//   const generateEnhancedReasons = (
//     career,
//     subject,
//     interests,
//     skillProfile
//   ) => {
//     const reasons = [];

//     // Academic reasons
//     if (career.academicScore >= 70) {
//       reasons.push(
//         `Excellent performance in ${subject.subject} (${subject.average.toFixed(
//           1
//         )}%)`
//       );
//     } else if (career.academicScore >= 50) {
//       reasons.push(
//         `Good performance in ${subject.subject} (${subject.average.toFixed(
//           1
//         )}%)`
//       );
//     }

//     // Interest reasons
//     if (interests && interests.detectedCategories.length > 0) {
//       const careerCategory = getCareerCategory(career.career);
//       if (interests.detectedCategories.includes(careerCategory)) {
//         if (careerCategory === interests.primaryInterest) {
//           reasons.push(
//             `Matches primary interest in ${interests.primaryInterest} activities`
//           );
//         } else {
//           reasons.push(`Aligns with interests in ${careerCategory}`);
//         }
//       }
//     }

//     // Skill-based reasons
//     if (career.skills) {
//       reasons.push(
//         `Requires skills in ${career.skills.slice(0, 2).join(" and ")}`
//       );
//     }

//     return reasons.length > 0
//       ? reasons
//       : ["Good overall fit based on academic profile"];
//   };

//   const generateInterestPrimaryReasons = (career, interests, category) => {
//     const reasons = [];

//     reasons.push(`Strong alignment with ${category} interests`);

//     if (category === interests.primaryInterest) {
//       reasons.push("Matches primary area of interest");
//     }

//     if (career.academicScore >= 50) {
//       reasons.push("Supported by adequate academic performance");
//     }

//     if (career.skills) {
//       reasons.push(
//         `Opportunity to develop ${career.skills
//           .slice(0, 2)
//           .join(" and ")} skills`
//       );
//     }

//     return reasons;
//   };

//   const identifyImprovementAreas = (subjectAverages) => {
//     return subjectAverages
//       .filter((subject) => subject.average < 50)
//       .map((subject) => ({
//         subject: subject.subject,
//         currentScore: subject.average,
//         targetScore: 60,
//         improvementNeeded: (60 - subject.average).toFixed(1),
//       }));
//   };

//   const identifyStrengths = (subjectAverages) => {
//     return subjectAverages
//       .filter((subject) => subject.average >= 70)
//       .map((subject) => ({
//         subject: subject.subject,
//         score: subject.average,
//         level: subject.average >= 85 ? "Exceptional" : "Strong",
//       }));
//   };

//   const calculateConfidenceScore = (subjectAverages, interests) => {
//     if (subjectAverages.length === 0) return 0;

//     let score = 50;

//     // Data completeness
//     if (subjectAverages.length >= 5) score += 20;
//     else if (subjectAverages.length >= 3) score += 10;

//     // Academic performance
//     const average = calculateOverallAverage(subjectAverages);
//     if (average >= 60) score += 20;
//     else if (average >= 40) score += 10;

//     // Interests data
//     if (interests && interests.detectedCategories.length > 0) score += 15;

//     return Math.min(95, score);
//   };

//   const calculateOverallAverage = (subjectAverages) => {
//     if (subjectAverages.length === 0) return 0;
//     const total = subjectAverages.reduce(
//       (sum, subject) => sum + subject.average,
//       0
//     );
//     return total / subjectAverages.length;
//   };

//   const getPerformanceLevel = (average) => {
//     if (average >= 85) return "excellent";
//     if (average >= 70) return "good";
//     if (average >= 55) return "average";
//     if (average >= 40) return "belowAverage";
//     return "needsImprovement";
//   };

//   const generateLearningAdvice = (
//     performanceLevel,
//     subjectAverages,
//     currentClass
//   ) => {
//     const advice = {
//       excellent: [
//         "Continue excelling in your strong subjects",
//         "Consider participating in academic competitions",
//         "Explore advanced topics in your areas of interest",
//       ],
//       good: [
//         "Focus on maintaining your current performance",
//         "Identify specific areas for minor improvements",
//         "Develop deeper understanding in your strong subjects",
//       ],
//       average: [
//         "Create a structured study schedule",
//         "Seek help in weaker subjects from teachers",
//         "Focus on understanding fundamental concepts",
//       ],
//       belowAverage: [
//         "Develop basic literacy and numeracy skills",
//         "Work closely with teachers to identify gaps",
//         "Focus on one subject at a time for improvement",
//       ],
//       needsImprovement: [
//         "Start with foundational skills building",
//         "Consider one-on-one tutoring support",
//         "Set small, achievable learning goals",
//       ],
//     };

//     return advice[performanceLevel] || advice.average;
//   };

//   const getPathwayRecommendation = (performanceLevel) => {
//     const pathways = {
//       excellent: {
//         pathway: "University Degree Pathway",
//         description: "Direct entry to university for bachelor degree programs",
//         requirements:
//           "Mean grade of C+ and above with relevant subject combinations",
//       },
//       good: {
//         pathway: "Diploma/College Pathway",
//         description: "Technical training through diploma programs",
//         requirements: "Mean grade of C- to C+ for diploma courses",
//       },
//       average: {
//         pathway: "Certificate/Vocational Training",
//         description: "Skills-based training through certificate programs",
//         requirements: "Mean grade of D to D+ for certificate courses",
//       },
//       belowAverage: {
//         pathway: "Vocational Skills Training",
//         description: "Basic skills training through youth polytechnics",
//         requirements: "Focus on foundational skills improvement",
//       },
//       needsImprovement: {
//         pathway: "Basic Skills Development",
//         description: "Remedial education and basic skills training",
//         requirements: "Literacy and numeracy skills development",
//       },
//     };

//     return pathways[performanceLevel] || pathways.average;
//   };

//   const getMarketInsights = (skillProfile, performanceLevel) => {
//     return {
//       highDemandFields: ["Technology", "Healthcare", "Renewable Energy"],
//       emergingFields: [
//         "Artificial Intelligence",
//         "Data Science",
//         "Cybersecurity",
//       ],
//       recommendedSkills: [
//         "Digital Literacy",
//         "Critical Thinking",
//         "Communication",
//       ],
//     };
//   };

//   // Enhanced filtering system
//   const filterCareers = (careers, filters) => {
//     return careers.filter((career) => {
//       // Confidence threshold
//       if (career.confidenceScore < filters.confidenceThreshold) return false;

//       // Education level
//       if (filters.educationLevel !== "all") {
//         if (
//           filters.educationLevel === "university" &&
//           career.pathway !== "University"
//         )
//           return false;
//         if (
//           filters.educationLevel === "college" &&
//           career.pathway !== "College"
//         )
//           return false;
//         if (
//           filters.educationLevel === "vocational" &&
//           career.pathway !== "Vocational"
//         )
//           return false;
//       }

//       // Interest area
//       if (
//         filters.interestArea !== "all" &&
//         career.category !== filters.interestArea
//       )
//         return false;

//       return true;
//     });
//   };

//   const fetchInsights = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const [insightsResponse, resultsResponse] = await Promise.all([
//         axios.get(
//           `https://kidsm.vercel.app/api/schools/learner/${learnerId}/career-insights`
//         ),
//         axios.get(
//           `https://kidsm.vercel.app/api/schools/learner/${learnerId}/results`
//         ),
//       ]);

//       // Fetch interests data if available
//       let interests = null;
//       try {
//         const interestsResponse = await axios.get(
//           `https://kidsm.vercel.app/api/schools/learner/${learnerId}/interests`
//         );
//         interests = interestsResponse.data;
//       } catch (error) {
//         console.log("No interests data available");
//       }

//       setInsightsData(insightsResponse.data);
//       setResultsData(resultsResponse.data.results);
//       setInterestsData(interests);

//       const analysis = performAdvancedAnalysis(
//         resultsResponse.data.results,
//         interests,
//         learner
//       );
//       setDetailedAnalysis(analysis);
//     } catch (error) {
//       console.error("Fetch error:", error);
//       setError("Failed to load career insights");

//       if (error.response?.status === 404) {
//         await generateInsights();
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const generateInsights = async () => {
//     try {
//       setLoading(true);
//       await axios.post(
//         `https://kidsm.vercel.app/api/schools/update-career-insights`,
//         { learnerId }
//       );
//       await fetchInsights();
//     } catch (error) {
//       console.error("Generation error:", error);
//       setError(
//         "Failed to generate insights. Please ensure the student has sufficient data."
//       );
//       setSnackbar({
//         open: true,
//         message: "Failed to generate insights",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCareerPress = (career) => {
//     setSelectedCareer(career);
//     setShowAdviceModal(true);
//   };

//   const handleRefresh = async () => {
//     await generateInsights();
//   };

//   useEffect(() => {
//     if (learnerId) {
//       fetchInsights();
//     }
//   }, [learnerId]);

//   // Loading state
//   if (loading) {
//     return (
//       <Container
//         maxWidth="lg"
//         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "100vh",
//           }}
//         >
//           <CircularProgress color="primary" />
//           <Typography sx={{ mt: 2, color: "#666" }}>
//             Analyzing academic performance and interests...
//           </Typography>
//         </Box>
//       </Container>
//     );
//   }

//   // Error state
//   if (error || !detailedAnalysis) {
//     return (
//       <Container
//         maxWidth="lg"
//         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             minHeight: "100vh",
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: "1rem",
//               color: "#e74c3c",
//               mb: 2,
//               textAlign: "center",
//             }}
//           >
//             {error || "No sufficient data available for career insights."}
//           </Typography>
//           <Button
//             variant="contained"
//             onClick={fetchInsights}
//             sx={{ bgcolor: "#6200ee", borderRadius: 2, textTransform: "none" }}
//           >
//             Check Again
//           </Button>
//         </Box>
//       </Container>
//     );
//   }

//   const filteredCareers = filterCareers(
//     detailedAnalysis.careerRecommendations,
//     filters
//   );

//   return (
//     <Container
//       maxWidth="lg"
//       sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
//     >
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         {/* Enhanced Header */}
//         <Typography
//           variant="h4"
//           sx={{ fontWeight: "bold", color: "#333", mb: 2, textAlign: "center" }}
//         >
//           AI Career Intelligence System
//         </Typography>
//         <Typography
//           sx={{ fontSize: "1rem", color: "#666", mb: 4, textAlign: "center" }}
//         >
//           Advanced talent identification and career pathway analysis
//         </Typography>

//         {/* Student Info */}
//         <Card sx={{ p: 3, mb: 4, bgcolor: "white" }}>
//           <Grid container spacing={3} alignItems="center">
//             <Grid item xs={12} md={8}>
//               <Typography variant="h5" gutterBottom>
//                 {learner?.fullName || "Student"}
//               </Typography>
//               <Typography color="textSecondary" gutterBottom>
//                 Admission: {learner?.admissionNumber} • Class: {learner?.class}
//               </Typography>
//               <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
//                 <Chip
//                   label={`Overall: ${detailedAnalysis.overallAverage.toFixed(
//                     1
//                   )}%`}
//                   color="primary"
//                   variant="outlined"
//                 />
//                 <Chip
//                   label={`Performance: ${detailedAnalysis.performanceLevel}`}
//                   color="secondary"
//                   variant="outlined"
//                 />
//                 <Chip
//                   label={`Confidence: ${detailedAnalysis.confidenceScore}%`}
//                   color="success"
//                   variant="outlined"
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </Card>

//         {/* Filters Section */}
//         <Card sx={{ p: 3, mb: 4, bgcolor: "white" }}>
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             🔍 Refine Career Suggestions
//           </Typography>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Education Pathway</InputLabel>
//                 <Select
//                   value={filters.educationLevel}
//                   onChange={(e) =>
//                     setFilters({ ...filters, educationLevel: e.target.value })
//                   }
//                 >
//                   <MenuItem value="all">All Pathways</MenuItem>
//                   <MenuItem value="university">University Degree</MenuItem>
//                   <MenuItem value="college">College Diploma</MenuItem>
//                   <MenuItem value="vocational">Vocational Training</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel>Interest Area</InputLabel>
//                 <Select
//                   value={filters.interestArea}
//                   onChange={(e) =>
//                     setFilters({ ...filters, interestArea: e.target.value })
//                   }
//                 >
//                   <MenuItem value="all">All Areas</MenuItem>
//                   <MenuItem value="stem_technology">STEM & Technology</MenuItem>
//                   <MenuItem value="healthcare">Healthcare</MenuItem>
//                   <MenuItem value="business_finance">
//                     Business & Finance
//                   </MenuItem>
//                   <MenuItem value="creative_arts">Creative Arts</MenuItem>
//                   <MenuItem value="education_social">
//                     Education & Social
//                   </MenuItem>
//                   <MenuItem value="technical_vocational">
//                     Technical & Vocational
//                   </MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <Typography gutterBottom>
//                 Minimum Confidence: {filters.confidenceThreshold}%
//               </Typography>
//               <Slider
//                 value={filters.confidenceThreshold}
//                 onChange={(e, newValue) =>
//                   setFilters({ ...filters, confidenceThreshold: newValue })
//                 }
//                 min={30}
//                 max={95}
//                 valueLabelDisplay="auto"
//               />
//             </Grid>
//           </Grid>
//         </Card>

//         {/* Enhanced Tabs */}
//         <Tabs
//           value={activeTab}
//           onChange={(e, newValue) => setActiveTab(newValue)}
//           sx={{ mb: 3 }}
//         >
//           <Tab label="Career Matches" />
//           <Tab label="Skill Analysis" />
//           <Tab label="Pathway Planning" />
//           <Tab label="Market Insights" />
//         </Tabs>

//         {/* Tab Content */}
//         {activeTab === 0 && (
//           <Box>
//             <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
//               🎯 Career Recommendations ({filteredCareers.length} matches)
//             </Typography>

//             {filteredCareers.length > 0 ? (
//               <Grid container spacing={3}>
//                 {filteredCareers.map((career, index) => (
//                   <Grid item xs={12} md={6} lg={4} key={index}>
//                     <CareerCard
//                       career={career}
//                       onSelect={handleCareerPress}
//                       index={index}
//                     />
//                   </Grid>
//                 ))}
//               </Grid>
//             ) : (
//               <Card sx={{ p: 4, textAlign: "center" }}>
//                 <Typography color="textSecondary">
//                   No careers match your current filters. Try adjusting the
//                   criteria.
//                 </Typography>
//               </Card>
//             )}
//           </Box>
//         )}

//         {activeTab === 1 && (
//           <Box>
//             <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
//               📊 Skill Analysis
//             </Typography>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <Card sx={{ p: 3 }}>
//                   <Typography variant="h6" gutterBottom>
//                     Skill Profile
//                   </Typography>
//                   <ResponsiveContainer width="100%" height={300}>
//                     <RadarChart
//                       data={Object.entries(detailedAnalysis.skillProfile).map(
//                         ([skill, value]) => ({
//                           subject:
//                             skill.charAt(0).toUpperCase() + skill.slice(1),
//                           A: value,
//                           fullMark: 100,
//                         })
//                       )}
//                     >
//                       <PolarGrid />
//                       <PolarAngleAxis dataKey="subject" />
//                       <PolarRadiusAxis angle={30} domain={[0, 100]} />
//                       <Radar
//                         name="Skills"
//                         dataKey="A"
//                         stroke="#8884d8"
//                         fill="#8884d8"
//                         fillOpacity={0.6}
//                       />
//                     </RadarChart>
//                   </ResponsiveContainer>
//                 </Card>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Card sx={{ p: 3 }}>
//                   <Typography variant="h6" gutterBottom>
//                     Subject Performance
//                   </Typography>
//                   <ResponsiveContainer width="100%" height={300}>
//                     <BarChart
//                       data={detailedAnalysis.subjectAverages.slice(0, 8)}
//                     >
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis
//                         dataKey="subject"
//                         angle={-45}
//                         textAnchor="end"
//                         height={80}
//                       />
//                       <YAxis />
//                       <Tooltip />
//                       <Bar dataKey="average" fill="#82ca9d" />
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Box>
//         )}

//         {activeTab === 2 && (
//           <Box>
//             <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
//               🎓 Educational Pathway
//             </Typography>
//             <Card sx={{ p: 3, mb: 3 }}>
//               <Typography variant="h6" color="primary" gutterBottom>
//                 {detailedAnalysis.pathwayRecommendation.pathway}
//               </Typography>
//               <Typography paragraph>
//                 {detailedAnalysis.pathwayRecommendation.description}
//               </Typography>
//               <Typography variant="body2" color="textSecondary">
//                 Requirements:{" "}
//                 {detailedAnalysis.pathwayRecommendation.requirements}
//               </Typography>
//             </Card>
//           </Box>
//         )}

//         {activeTab === 3 && (
//           <Box>
//             <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
//               💼 Market Insights
//             </Typography>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <Card sx={{ p: 3 }}>
//                   <Typography variant="h6" gutterBottom>
//                     High Demand Fields
//                   </Typography>
//                   <List>
//                     {detailedAnalysis.marketInsights.highDemandFields.map(
//                       (field, index) => (
//                         <ListItem key={index}>
//                           <ListItemIcon>
//                             <TrendingUp color="success" />
//                           </ListItemIcon>
//                           <ListItemText primary={field} />
//                         </ListItem>
//                       )
//                     )}
//                   </List>
//                 </Card>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Card sx={{ p: 3 }}>
//                   <Typography variant="h6" gutterBottom>
//                     Recommended Skills
//                   </Typography>
//                   <List>
//                     {detailedAnalysis.marketInsights.recommendedSkills.map(
//                       (skill, index) => (
//                         <ListItem key={index}>
//                           <ListItemIcon>
//                             <Work color="primary" />
//                           </ListItemIcon>
//                           <ListItemText primary={skill} />
//                         </ListItem>
//                       )
//                     )}
//                   </List>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Box>
//         )}

//         {/* Refresh Button */}
//         <Box sx={{ mt: 4, textAlign: "center" }}>
//           <Button
//             variant="contained"
//             onClick={handleRefresh}
//             sx={{
//               bgcolor: "#6200ee",
//               borderRadius: 2,
//               py: 1.5,
//               px: 4,
//               textTransform: "none",
//               fontWeight: "bold",
//               "&:hover": { bgcolor: "#3700b3" },
//             }}
//           >
//             Generate New Insights
//           </Button>
//         </Box>
//       </motion.div>

//       {/* Enhanced Career Detail Modal */}
//       <CareerDetailModal
//         open={showAdviceModal}
//         career={selectedCareer}
//         onClose={() => setShowAdviceModal(false)}
//         analysis={detailedAnalysis}
//       />

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         message={snackbar.message}
//       />
//     </Container>
//   );
// };

// // Career Card Component
// const CareerCard = ({ career, onSelect, index }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 20 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.5, delay: index * 0.1 }}
//   >
//     <Card
//       sx={{
//         p: 2,
//         cursor: "pointer",
//         transition: "all 0.3s",
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         "&:hover": {
//           transform: "translateY(-4px)",
//           boxShadow: 6,
//           bgcolor: "#f8f9fa",
//         },
//       }}
//       onClick={() => onSelect(career)}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           mb: 1,
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
//           <Avatar sx={{ bgcolor: "#6200ee", width: 40, height: 40 }}>
//             {career.icon}
//           </Avatar>
//           <Box sx={{ flex: 1 }}>
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: "bold", lineHeight: 1.2 }}
//             >
//               {career.career}
//             </Typography>
//           </Box>
//         </Box>
//         <Chip
//           label={`${career.confidenceScore}%`}
//           color={
//             career.confidenceScore >= 80
//               ? "success"
//               : career.confidenceScore >= 60
//               ? "warning"
//               : "error"
//           }
//           size="small"
//         />
//       </Box>

//       <Typography
//         variant="body2"
//         color="text.secondary"
//         sx={{ mb: 1, flex: 1 }}
//       >
//         {career.education}
//       </Typography>

//       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}>
//         {career.skills.slice(0, 3).map((skill, i) => (
//           <Chip key={i} label={skill} size="small" variant="outlined" />
//         ))}
//         {career.skills.length > 3 && (
//           <Chip
//             label={`+${career.skills.length - 3}`}
//             size="small"
//             variant="outlined"
//           />
//         )}
//       </Box>

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Typography variant="caption" color="text.secondary">
//           {career.pathway} • {career.demand}
//         </Typography>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//           <AttachMoney
//             fontSize="small"
//             color={career.salary === "Very High" ? "success" : "primary"}
//           />
//           <Typography variant="caption" color="text.secondary">
//             {career.salary}
//           </Typography>
//         </Box>
//       </Box>
//     </Card>
//   </motion.div>
// );

// // Career Detail Modal Component
// const CareerDetailModal = ({ open, career, onClose, analysis }) => (
//   <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//     <DialogTitle>
//       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//         <Avatar sx={{ bgcolor: "#6200ee", width: 50, height: 50 }}>
//           {career?.icon}
//         </Avatar>
//         <Box>
//           <Typography variant="h5" fontWeight="bold">
//             {career?.career}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {career?.description}
//           </Typography>
//         </Box>
//       </Box>
//     </DialogTitle>
//     <DialogContent>
//       {career && (
//         <Box>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>
//                 📊 Match Analysis
//               </Typography>
//               <Card sx={{ p: 2, mb: 2 }}>
//                 <Box sx={{ mb: 2 }}>
//                   <Typography>
//                     Overall Confidence:{" "}
//                     <strong>{career.confidenceScore}%</strong>
//                   </Typography>
//                   <LinearProgress
//                     variant="determinate"
//                     value={career.confidenceScore}
//                     sx={{ height: 8, borderRadius: 4, mt: 1 }}
//                     color={
//                       career.confidenceScore >= 80
//                         ? "success"
//                         : career.confidenceScore >= 60
//                         ? "warning"
//                         : "error"
//                     }
//                   />
//                 </Box>
//                 <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <Typography variant="body2">
//                     Academic Fit: {career.academicScore}%
//                   </Typography>
//                   <Typography variant="body2">
//                     Interest Match: {career.interestScore}%
//                   </Typography>
//                   <Typography variant="body2">
//                     Skill Alignment: {career.skillScore}%
//                   </Typography>
//                 </Box>
//               </Card>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>
//                 🎓 Education Pathway
//               </Typography>
//               <Card sx={{ p: 2 }}>
//                 <Typography>
//                   <strong>{career.education}</strong>
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mt: 1 }}
//                 >
//                   Pathway: {career.pathway}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mt: 2, fontWeight: "bold" }}
//                 >
//                   Growth Outlook: {career.growth}
//                 </Typography>
//               </Card>
//             </Grid>

//             {/* Kenyan Institutions */}
//             {career.kenyan_institutions && (
//               <Grid item xs={12}>
//                 <Typography variant="h6" gutterBottom>
//                   🏫 Recommended Kenyan Institutions
//                 </Typography>
//                 <Card sx={{ p: 2 }}>
//                   <List dense>
//                     {career.kenyan_institutions.map((inst, idx) => (
//                       <ListItem key={idx}>
//                         <ListItemIcon>
//                           <School color="primary" />
//                         </ListItemIcon>
//                         <ListItemText primary={inst} />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Card>
//               </Grid>
//             )}

//             {/* Skills */}
//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>
//                 💪 Required Skills
//               </Typography>
//               <Card sx={{ p: 2 }}>
//                 <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                   {career.skills.map((skill, index) => (
//                     <Chip
//                       key={index}
//                       label={skill}
//                       color="primary"
//                       variant="outlined"
//                     />
//                   ))}
//                 </Box>
//               </Card>
//             </Grid>

//             {/* Career Outlook */}
//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>
//                 💼 Career Outlook
//               </Typography>
//               <Card sx={{ p: 2 }}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     mb: 1,
//                   }}
//                 >
//                   <Typography>Demand:</Typography>
//                   <Typography
//                     fontWeight="bold"
//                     color={
//                       career.demand === "Very High"
//                         ? "success"
//                         : career.demand === "High"
//                         ? "primary"
//                         : "text.secondary"
//                     }
//                   >
//                     {career.demand}
//                   </Typography>
//                 </Box>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     mb: 1,
//                   }}
//                 >
//                   <Typography>Salary Potential:</Typography>
//                   <Typography
//                     fontWeight="bold"
//                     color={
//                       career.salary === "Very High"
//                         ? "success"
//                         : career.salary === "High"
//                         ? "primary"
//                         : "text.secondary"
//                     }
//                   >
//                     {career.salary}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <Typography>Growth:</Typography>
//                   <Typography fontWeight="bold" color="primary">
//                     {career.growth}
//                   </Typography>
//                 </Box>
//               </Card>
//             </Grid>

//             {/* Related Subjects */}
//             {career.subjects && (
//               <Grid item xs={12}>
//                 <Typography variant="h6" gutterBottom>
//                   📚 Key Subjects
//                 </Typography>
//                 <Card sx={{ p: 2 }}>
//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                     {career.subjects.map((subject, index) => (
//                       <Chip
//                         key={index}
//                         label={subject}
//                         color="secondary"
//                         variant="filled"
//                         icon={<School />}
//                       />
//                     ))}
//                   </Box>
//                 </Card>
//               </Grid>
//             )}
//           </Grid>
//         </Box>
//       )}
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={onClose}>Close</Button>
//     </DialogActions>
//   </Dialog>
// );

// // Add missing LinearProgress import
// const LinearProgress = ({ variant, value, sx, color }) => (
//   <Box sx={{ ...sx, bgcolor: "#e0e0e0", borderRadius: 4 }}>
//     <Box
//       sx={{
//         height: "100%",
//         borderRadius: 4,
//         bgcolor:
//           color === "success"
//             ? "#4caf50"
//             : color === "warning"
//             ? "#ff9800"
//             : "#f44336",
//         width: `${value}%`,
//         transition: "width 0.5s ease-in-out",
//       }}
//     />
//   </Box>
// );

// export default EnhancedCareerInsights;

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  Card,
  CardContent,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Slider,
  Rating,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Paper,
  LinearProgress,
} from "@mui/material";
import { motion } from "framer-motion";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
  LineChart,
  Line,
  AreaChart,
  Area,
} from "recharts";
import axios from "axios";
import {
  School,
  Computer,
  Science,
  MedicalServices,
  Business,
  Engineering,
  Agriculture,
  Sports,
  Restaurant,
  Build,
  Calculate,
  Palette,
  Psychology,
  Public,
  AccountBalance,
  LocalHospital,
  Code,
  Cloud,
  Security,
  DataArray,
  ElectricBolt,
  Architecture,
  DirectionsCar,
  Flight,
  LocalShipping,
  Factory,
  Biotech,
  PsychologyAlt,
  Group,
  Translate,
  MenuBook,
  TheaterComedy,
  CameraAlt,
  TrendingUp,
  Work,
  AccessTime,
  AttachMoney,
  MusicNote,
  FitnessCenter,
  Nature,
  Brush,
  Calculate as CalculateIcon,
  Language,
  History,
  Public as PublicIcon,
  Spa,
  Star,
  Favorite,
  EmojiEvents,
} from "@mui/icons-material";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import MusicNoteIcon from "@mui/icons-material/MusicNote";

// Comprehensive CBC Subject Mappings for Kenyan Curriculum
const cbcSubjectMappings = {
  // Lower Primary (Grade 1-3)
  "Literacy Activities": {
    category: "Languages",
    weight: 1.1,
    skills: ["communication", "linguistic", "creative", "analytical"],
    relatedCareers: [
      "Journalism",
      "Writing",
      "Teaching",
      "Law",
      "Public Relations",
    ],
  },
  "Kiswahili Language Activities": {
    category: "Languages",
    weight: 1.0,
    skills: ["communication", "cultural", "linguistic", "interpersonal"],
    relatedCareers: [
      "Translation",
      "Tourism",
      "Diplomacy",
      "Teaching",
      "Media",
    ],
  },
  "English Language Activities": {
    category: "Languages",
    weight: 1.1,
    skills: ["communication", "critical_thinking", "analysis", "linguistic"],
    relatedCareers: [
      "Writing",
      "Teaching",
      "Law",
      "Journalism",
      "Public Speaking",
    ],
  },
  "Mathematical Activities": {
    category: "STEM",
    weight: 1.2,
    skills: ["analytical", "logical", "quantitative", "problem_solving"],
    relatedCareers: [
      "Engineering",
      "Data Science",
      "Finance",
      "Research",
      "Technology",
    ],
  },
  "Environmental Activities": {
    category: "Sciences",
    weight: 1.1,
    skills: ["scientific", "environmental", "observational", "analytical"],
    relatedCareers: [
      "Environmental Science",
      "Agriculture",
      "Geography",
      "Conservation",
    ],
  },
  "Hygiene and Nutrition Activities": {
    category: "Life Skills",
    weight: 0.9,
    skills: ["practical", "health", "organizational", "interpersonal"],
    relatedCareers: [
      "Nutrition",
      "Healthcare",
      "Home Economics",
      "Public Health",
    ],
  },
  "Religious Education": {
    category: "Humanities",
    weight: 0.9,
    skills: ["ethical", "cultural", "analytical", "interpersonal"],
    relatedCareers: [
      "Religious Studies",
      "Counseling",
      "Social Work",
      "Community Development",
    ],
  },
  "Movement and Creative Activities": {
    category: "Creative & Physical",
    weight: 1.0,
    skills: ["creative", "physical", "coordination", "expressive"],
    relatedCareers: [
      "Sports",
      "Dance",
      "Theater",
      "Physical Education",
      "Coaching",
    ],
  },

  // Upper Primary (Grade 4-6)
  English: {
    category: "Languages",
    weight: 1.1,
    skills: ["communication", "critical_thinking", "analysis", "linguistic"],
    relatedCareers: [
      "Writing",
      "Law",
      "Journalism",
      "Teaching",
      "Public Relations",
    ],
  },
  Kiswahili: {
    category: "Languages",
    weight: 1.0,
    skills: ["communication", "cultural", "linguistic", "interpersonal"],
    relatedCareers: [
      "Translation",
      "Tourism",
      "Media",
      "Diplomacy",
      "Community Work",
    ],
  },
  Mathematics: {
    category: "STEM",
    weight: 1.3,
    skills: ["analytical", "logical", "quantitative", "problem_solving"],
    relatedCareers: [
      "Engineering",
      "Computer Science",
      "Finance",
      "Research",
      "Statistics",
    ],
  },
  "Science and Technology": {
    category: "STEM",
    weight: 1.3,
    skills: ["scientific", "technical", "research", "analytical"],
    relatedCareers: [
      "Medicine",
      "Engineering",
      "Research",
      "Technology",
      "Environmental Science",
    ],
  },
  "Social Studies": {
    category: "Humanities",
    weight: 1.0,
    skills: ["analytical", "social", "research", "communication"],
    relatedCareers: [
      "History",
      "Geography",
      "Sociology",
      "Political Science",
      "Anthropology",
    ],
  },
  "Creative Arts": {
    category: "Creative",
    weight: 1.0,
    skills: ["creative", "artistic", "innovative", "visual"],
    relatedCareers: ["Art", "Design", "Music", "Drama", "Film Production"],
  },
  "Physical and Health Education": {
    category: "Physical",
    weight: 0.9,
    skills: ["physical", "teamwork", "strategic", "leadership"],
    relatedCareers: [
      "Sports",
      "Coaching",
      "Fitness",
      "Physical Therapy",
      "Recreation",
    ],
  },
  "Home Science": {
    category: "Applied Sciences",
    weight: 1.0,
    skills: ["practical", "creative", "management", "organizational"],
    relatedCareers: [
      "Nutrition",
      "Interior Design",
      "Hospitality",
      "Child Development",
      "Fashion",
    ],
  },
  Agriculture: {
    category: "Applied Sciences",
    weight: 1.1,
    skills: ["practical", "environmental", "management", "technical"],
    relatedCareers: [
      "Farming",
      "Agribusiness",
      "Environmental Science",
      "Research",
      "Food Science",
    ],
  },
  "Religious Education (IRE/CRE)": {
    category: "Humanities",
    weight: 0.9,
    skills: ["ethical", "cultural", "analytical", "interpersonal"],
    relatedCareers: [
      "Religious Leadership",
      "Counseling",
      "Teaching",
      "Social Work",
    ],
  },

  // Junior Secondary (Grade 7-9)
  "Pre-Technical Studies": {
    category: "Technical",
    weight: 1.2,
    skills: ["technical", "practical", "problem_solving", "mechanical"],
    relatedCareers: [
      "Engineering",
      "Architecture",
      "Technical Drawing",
      "Construction",
      "Manufacturing",
    ],
  },
  "Business Studies": {
    category: "Business",
    weight: 1.1,
    skills: ["analytical", "commercial", "management", "financial"],
    relatedCareers: [
      "Business",
      "Accounting",
      "Entrepreneurship",
      "Marketing",
      "Management",
    ],
  },
  "Computer Studies": {
    category: "STEM",
    weight: 1.3,
    skills: ["technical", "analytical", "innovative", "problem_solving"],
    relatedCareers: [
      "Software Development",
      "IT",
      "Data Science",
      "Cybersecurity",
      "Web Development",
    ],
  },
  "Life Skills Education": {
    category: "Life Skills",
    weight: 0.9,
    skills: ["interpersonal", "emotional", "practical", "leadership"],
    relatedCareers: [
      "Counseling",
      "Psychology",
      "Social Work",
      "Human Resources",
      "Education",
    ],
  },

  // Handle variations and aliases
  "Number Work": "Mathematics",
  "Language Activities": "English",
  Reading: "English",
  Writing: "English",
  "Language/Total": "English",
  "Reading/Jumla": "English",
  "Kiswahili/Jumla": "Kiswahili",
  "Kiswahili Lugha": "Kiswahili",
  "Kiswahili Insha": "Kiswahili",
  "Science & Technology": "Science and Technology",
  Science: "Science and Technology",
  Environmental: "Environmental Activities",
  CRE: "Religious Education (IRE/CRE)",
  IRE: "Religious Education (IRE/CRE)",
  PHE: "Physical and Health Education",
  "Art and Craft": "Creative Arts",
  Music: "Creative Arts",
};

// Enhanced interest detection with comprehensive categories for Kenyan context
const enhancedInterestCategories = {
  // Sports & Physical Activities
  sports_physical: {
    keywords: [
      "football",
      "soccer",
      "athletics",
      "running",
      "jumping",
      "sports",
      "basketball",
      "volleyball",
      "netball",
      "rugby",
      "cricket",
      "swimming",
      "tennis",
      "boxing",
      "martial arts",
      "coaching",
      "training",
      "fitness",
      "exercise",
      "gym",
      "workout",
      "competition",
      "tournament",
      "match",
      "playing",
      "practice",
      "sport",
      "athlete",
      "team",
      "game",
      "race",
    ],
    skills: ["physical", "teamwork", "leadership", "strategic", "discipline"],
    careers: [
      "Sports",
      "Coaching",
      "Fitness Training",
      "Physical Therapy",
      "Sports Medicine",
    ],
    icon: <Sports />,
    color: "#4CAF50",
  },

  // Music & Performing Arts
  music_performing: {
    keywords: [
      "music",
      "singing",
      "dancing",
      "acting",
      "drama",
      "theater",
      "playing instrument",
      "guitar",
      "piano",
      "drums",
      "violin",
      "performing",
      "stage",
      "concert",
      "choir",
      "band",
      "orchestra",
      "composing",
      "songwriting",
      "recording",
      "karaoke",
      "musical",
      "dance",
      "ballet",
      "traditional dance",
      "cultural performance",
      "entertainment",
      "show",
      "performance",
      "artist",
      "musician",
    ],
    skills: ["creative", "performance", "expressive", "rhythmic", "artistic"],
    careers: [
      "Music",
      "Performing Arts",
      "Entertainment",
      "Teaching",
      "Production",
    ],
    icon: <MusicNote />,
    color: "#9C27B0",
  },

  // Visual Arts & Creativity
  visual_arts: {
    keywords: [
      "drawing",
      "painting",
      "sketching",
      "art",
      "design",
      "craft",
      "sculpture",
      "pottery",
      "carving",
      "beadwork",
      "weaving",
      "coloring",
      "creative",
      "artistic",
      "illustration",
      "graphic",
      "photography",
      "filming",
      "video",
      "editing",
      "animation",
      "fashion",
      "designing",
      "decorating",
      "beauty",
      "makeup",
      "creative writing",
      "poetry",
      "storytelling",
      "blogging",
    ],
    skills: ["creative", "artistic", "innovative", "visual", "detailed"],
    careers: ["Visual Arts", "Design", "Media", "Fashion", "Writing"],
    icon: <Palette />,
    color: "#FF9800",
  },

  // Technology & Computing
  technology_computing: {
    keywords: [
      "computers",
      "coding",
      "programming",
      "technology",
      "gadgets",
      "video games",
      "gaming",
      "robotics",
      "electronics",
      "phones",
      "internet",
      "social media",
      "websites",
      "apps",
      "software",
      "hardware",
      "repair",
      "building",
      "inventing",
      "innovating",
      "digital",
      "online",
      "cyber",
      "AI",
      "artificial intelligence",
      "machine learning",
      "data",
      "analytics",
      "computing",
      "tech",
    ],
    skills: [
      "technical",
      "analytical",
      "innovative",
      "problem_solving",
      "logical",
    ],
    careers: [
      "Technology",
      "Engineering",
      "Research",
      "Data Science",
      "Development",
    ],
    icon: <Computer />,
    color: "#2196F3",
  },

  // Science & Nature
  science_nature: {
    keywords: [
      "science",
      "experiments",
      "chemistry",
      "physics",
      "biology",
      "nature",
      "animals",
      "plants",
      "environment",
      "conservation",
      "gardening",
      "farming",
      "agriculture",
      "weather",
      "climate",
      "space",
      "stars",
      "planets",
      "discovery",
      "research",
      "invention",
      "exploration",
      "wildlife",
      "birds",
      "insects",
      "geology",
      "rocks",
      "minerals",
      "fossils",
      "ecosystem",
    ],
    skills: [
      "scientific",
      "observational",
      "analytical",
      "research",
      "environmental",
    ],
    careers: [
      "Science",
      "Research",
      "Environmental",
      "Agriculture",
      "Healthcare",
    ],
    icon: <Science />,
    color: "#4CAF50",
  },

  // Helping & Social Activities
  helping_social: {
    keywords: [
      "helping",
      "teaching",
      "mentoring",
      "counseling",
      "caring",
      "nursing",
      "doctors",
      "hospital",
      "community",
      "volunteering",
      "charity",
      "social work",
      "elderly",
      "children",
      "babies",
      "support",
      "guidance",
      "advice",
      "listening",
      "understanding",
      "empathy",
      "kindness",
      "service",
      "leadership",
      "teamwork",
      "cooperation",
      "collaboration",
      "sharing",
      "caring for others",
    ],
    skills: [
      "empathy",
      "communication",
      "interpersonal",
      "supportive",
      "leadership",
    ],
    careers: [
      "Healthcare",
      "Education",
      "Social Work",
      "Community Development",
      "Counseling",
    ],
    icon: <Group />,
    color: "#F44336",
  },

  // Business & Entrepreneurship
  business_entrepreneurship: {
    keywords: [
      "business",
      "selling",
      "marketing",
      "money",
      "finance",
      "entrepreneur",
      "startup",
      "commerce",
      "trade",
      "shop",
      "managing",
      "organizing",
      "planning",
      "budgeting",
      "saving",
      "investing",
      "negotiating",
      "deals",
      "profit",
      "enterprise",
      "innovation",
      "leadership",
      "management",
      "administration",
      "accounting",
      "calculating",
      "numbers",
      "economics",
    ],
    skills: [
      "commercial",
      "leadership",
      "strategic",
      "financial",
      "management",
    ],
    careers: [
      "Business",
      "Finance",
      "Management",
      "Entrepreneurship",
      "Marketing",
    ],
    icon: <Business />,
    color: "#FFC107",
  },

  // Outdoor & Practical Activities
  outdoor_practical: {
    keywords: [
      "outdoors",
      "camping",
      "hiking",
      "farming",
      "construction",
      "building",
      "fixing",
      "repairing",
      "mechanical",
      "engineering",
      "gardening",
      "fishing",
      "hunting",
      "exploring",
      "adventure",
      "nature walks",
      "forest",
      "mountains",
      "rivers",
      "lakes",
      "crafts",
      "woodwork",
      "metalwork",
      "technical",
      "hands-on",
      "practical",
      "manual work",
      "construction",
      "manufacturing",
    ],
    skills: [
      "physical",
      "practical",
      "technical",
      "environmental",
      "mechanical",
    ],
    careers: [
      "Agriculture",
      "Construction",
      "Engineering",
      "Environmental",
      "Technical",
    ],
    icon: <Agriculture />,
    color: "#795548",
  },

  // Language & Communication
  language_communication: {
    keywords: [
      "reading",
      "writing",
      "languages",
      "debate",
      "public speaking",
      "storytelling",
      "journalism",
      "translation",
      "literature",
      "poetry",
      "blogging",
      "reporting",
      "news",
      "media",
      "discussion",
      "argument",
      "persuasion",
      "negotiation",
      "english",
      "kiswahili",
      "foreign languages",
      "communication",
      "expression",
      "vocabulary",
      "grammar",
      "composition",
    ],
    skills: [
      "communication",
      "linguistic",
      "analytical",
      "creative",
      "interpersonal",
    ],
    careers: [
      "Media",
      "Writing",
      "Translation",
      "Education",
      "Public Relations",
    ],
    icon: <Translate />,
    color: "#3F51B5",
  },

  // Cultural & Traditional Activities
  cultural_traditional: {
    keywords: [
      "culture",
      "traditional",
      "heritage",
      "customs",
      "rituals",
      "ceremonies",
      "festivals",
      "dances",
      "songs",
      "stories",
      "history",
      "ancestors",
      "traditions",
      "cultural events",
      "community gatherings",
      "elders",
      "wisdom",
      "knowledge",
      "indigenous",
      "local",
      "tribal",
      "ethnic",
      "cultural practices",
    ],
    skills: [
      "cultural",
      "historical",
      "interpersonal",
      "preservation",
      "communication",
    ],
    careers: [
      "Cultural Studies",
      "Anthropology",
      "Tourism",
      "Museum Work",
      "Community Development",
    ],
    icon: <PublicIcon />,
    color: "#8BC34A",
  },
};

// Comprehensive career database for Kenyan context
const comprehensiveCareerDatabase = {
  // Careers based on CBC Subjects
  subject_based: [
    {
      career: "Software Engineer",
      confidence: 85,
      skills: [
        "Programming",
        "Problem Solving",
        "Algorithms",
        "Software Design",
      ],
      education: "Degree in Computer Science/Software Engineering",
      pathway: "University",
      demand: "Very High",
      salary: "High",
      kenyan_institutions: [
        "University of Nairobi",
        "JKUAT",
        "Strathmore University",
      ],
      description:
        "Design, develop, and maintain software applications and systems",
      growth: "25% (2023-2028)",
      subjects: ["Mathematics", "Computer Studies", "Physics"],
      icon: <Code />,
      category: "technology_computing",
    },
    {
      career: "Medical Doctor",
      confidence: 90,
      skills: [
        "Medical Knowledge",
        "Diagnosis",
        "Patient Care",
        "Communication",
      ],
      education: "MBChB Degree (6 years)",
      pathway: "University",
      demand: "Very High",
      salary: "Very High",
      kenyan_institutions: [
        "University of Nairobi",
        "Moi University",
        "Kenyatta University",
      ],
      description:
        "Diagnose and treat illnesses, injuries, and other health conditions",
      growth: "20% (2023-2028)",
      subjects: ["Biology", "Chemistry", "Mathematics"],
      icon: <MedicalServices />,
      category: "helping_social",
    },
    {
      career: "Civil Engineer",
      confidence: 84,
      skills: ["Structural Design", "Project Management", "Mathematics", "CAD"],
      education: "Degree in Civil Engineering",
      pathway: "University",
      demand: "High",
      salary: "High",
      kenyan_institutions: [
        "University of Nairobi",
        "JKUAT",
        "Technical University of Kenya",
      ],
      description:
        "Design and supervise construction of infrastructure projects",
      growth: "16% (2023-2028)",
      subjects: ["Mathematics", "Physics", "Pre-Technical Studies"],
      icon: <Architecture />,
      category: "technology_computing",
    },
    {
      career: "Journalist",
      confidence: 74,
      skills: ["Writing", "Research", "Communication", "Interviewing"],
      education: "Degree in Journalism/Mass Communication",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Daystar University",
        "USIU Africa",
      ],
      description: "Research and report news stories for various media outlets",
      growth: "12% (2023-2028)",
      subjects: ["English", "Social Studies", "Languages"],
      icon: <MenuBook />,
      category: "language_communication",
    },
    {
      career: "Agricultural Engineer",
      confidence: 78,
      skills: [
        "Agricultural Systems",
        "Technology",
        "Problem Solving",
        "Design",
      ],
      education: "Degree in Agricultural Engineering",
      pathway: "University",
      demand: "High",
      salary: "Medium",
      kenyan_institutions: [
        "JKUAT",
        "University of Nairobi",
        "Egerton University",
      ],
      description: "Develop engineering solutions for agricultural problems",
      growth: "18% (2023-2028)",
      subjects: ["Mathematics", "Physics", "Agriculture"],
      icon: <Agriculture />,
      category: "technology_computing",
    },
    {
      career: "Business Analyst",
      confidence: 79,
      skills: [
        "Requirements Analysis",
        "Process Improvement",
        "Data Analysis",
        "Communication",
      ],
      education: "Degree in Business/IT",
      pathway: "University",
      demand: "High",
      salary: "Medium",
      kenyan_institutions: [
        "Strathmore University",
        "University of Nairobi",
        "KCA University",
      ],
      description: "Analyze business processes and recommend improvements",
      growth: "18% (2023-2028)",
      subjects: ["Mathematics", "Business Studies", "Computer Studies"],
      icon: <Business />,
      category: "business_entrepreneurship",
    },
    {
      career: "Environmental Scientist",
      confidence: 76,
      skills: ["Research", "Analysis", "Environmental Assessment", "Reporting"],
      education: "Degree in Environmental Science",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Kenyatta University",
        "University of Nairobi",
        "Moi University",
      ],
      description: "Study environmental problems and develop solutions",
      growth: "15% (2023-2028)",
      subjects: ["Science and Technology", "Geography", "Mathematics"],
      icon: <Nature />,
      category: "science_nature",
    },
    {
      career: "Graphic Designer",
      confidence: 76,
      skills: [
        "Creativity",
        "Software Skills",
        "Visual Communication",
        "Typography",
      ],
      education: "Diploma in Graphic Design",
      pathway: "College",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Nairobi Technical Training Institute",
        "Kenya Institute of Design",
      ],
      description: "Create visual concepts to communicate ideas and messages",
      growth: "16% (2023-2028)",
      subjects: ["Creative Arts", "Computer Studies", "English"],
      icon: <DesignServicesIcon />,
      category: "visual_arts",
    },
  ],

  // Careers based on Interests
  interest_based: [
    // Sports-related careers
    {
      career: "Professional Athlete",
      confidence: 82,
      skills: [
        "Physical Fitness",
        "Discipline",
        "Teamwork",
        "Strategic Thinking",
      ],
      education: "Sports Training + Talent Development",
      pathway: "Sports Academy/University",
      demand: "Medium",
      salary: "Variable",
      kenyan_institutions: [
        "Kenyatta University",
        "University of Nairobi",
        "Various Sports Academies",
      ],
      description:
        "Compete in professional sports at national and international levels",
      growth: "15% (2023-2028)",
      interests: ["sports_physical"],
      icon: <Sports />,
      category: "sports_physical",
    },
    {
      career: "Sports Coach",
      confidence: 75,
      skills: ["Leadership", "Training", "Strategy", "Motivation"],
      education: "Diploma in Sports Science/Coaching",
      pathway: "College/University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Kenyatta University",
        "KIF Institute",
        "Various Sports Colleges",
      ],
      description: "Train and guide athletes to improve their performance",
      growth: "18% (2023-2028)",
      interests: ["sports_physical"],
      icon: <FitnessCenter />,
      category: "sports_physical",
    },
    {
      career: "Physical Education Teacher",
      confidence: 73,
      skills: ["Teaching", "Fitness", "Leadership", "Communication"],
      education: "Degree in Physical Education",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Kenyatta University",
        "University of Nairobi",
        "Egerton University",
      ],
      description: "Educate students about physical fitness and sports",
      growth: "14% (2023-2028)",
      interests: ["sports_physical"],
      icon: <School />,
      category: "sports_physical",
    },

    // Music and Performing Arts careers
    {
      career: "Musician/Performer",
      confidence: 78,
      skills: ["Musical Talent", "Performance", "Composition", "Practice"],
      education: "Music School/Self-taught",
      pathway: "Vocational/University",
      demand: "Low",
      salary: "Variable",
      kenyan_institutions: [
        "Kenya Conservatoire of Music",
        "Kenyatta University Music Department",
      ],
      description: "Perform, compose, and record music professionally",
      growth: "10% (2023-2028)",
      interests: ["music_performing"],
      icon: <MusicNoteIcon />,
      category: "music_performing",
    },
    {
      career: "Music Teacher",
      confidence: 74,
      skills: ["Teaching", "Musical Knowledge", "Patience", "Communication"],
      education: "Diploma/Degree in Music Education",
      pathway: "College/University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Kenyatta University",
        "University of Nairobi",
        "Various Music Schools",
      ],
      description: "Teach music theory and practice to students",
      growth: "12% (2023-2028)",
      interests: ["music_performing"],
      icon: <School />,
      category: "music_performing",
    },
    {
      career: "Sound Engineer",
      confidence: 76,
      skills: [
        "Technical Skills",
        "Audio Production",
        "Creativity",
        "Attention to Detail",
      ],
      education: "Diploma in Sound Engineering",
      pathway: "College",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "MultiMedia University",
        "Kenya Institute of Mass Communication",
      ],
      description: "Record, mix, and produce audio content",
      growth: "16% (2023-2028)",
      interests: ["music_performing"],
      icon: <MusicNote />,
      category: "music_performing",
    },

    // Visual Arts careers
    {
      career: "Fine Artist",
      confidence: 72,
      skills: [
        "Creativity",
        "Technical Skill",
        "Originality",
        "Business Acumen",
      ],
      education: "Art School/Self-taught",
      pathway: "Vocational/University",
      demand: "Low",
      salary: "Variable",
      kenyan_institutions: [
        "Buru Buru Institute of Fine Arts",
        "Kenyatta University Art Department",
      ],
      description: "Create original artworks for exhibition and sale",
      growth: "11% (2023-2028)",
      interests: ["visual_arts"],
      icon: <Palette />,
      category: "visual_arts",
    },
    {
      career: "Fashion Designer",
      confidence: 71,
      skills: ["Creativity", "Design", "Trend Awareness", "Sewing"],
      education: "Diploma in Fashion Design",
      pathway: "College",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Kenyatta University",
        "Nairobi Technical Training Institute",
      ],
      description: "Create clothing and accessory designs for various markets",
      growth: "13% (2023-2028)",
      interests: ["visual_arts"],
      icon: <DesignServicesIcon />,
      category: "visual_arts",
    },
    {
      career: "Photographer",
      confidence: 73,
      skills: ["Creativity", "Technical Skills", "Composition", "Editing"],
      education: "Photography Courses/Certificate",
      pathway: "Vocational",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Nairobi Photography School",
        "Various Art Institutes",
      ],
      description: "Capture and create visual images for various purposes",
      growth: "14% (2023-2028)",
      interests: ["visual_arts"],
      icon: <CameraAlt />,
      category: "visual_arts",
    },

    // Technology and Computing careers
    {
      career: "Game Developer",
      confidence: 78,
      skills: ["Programming", "Creativity", "Game Design", "Problem Solving"],
      education: "Degree in Game Development/Computer Science",
      pathway: "University",
      demand: "High",
      salary: "Medium",
      kenyan_institutions: ["JKUAT", "KCA University", "MultiMedia University"],
      description: "Design and develop video games for various platforms",
      growth: "20% (2023-2028)",
      interests: ["technology_computing"],
      icon: <Code />,
      category: "technology_computing",
    },
    {
      career: "IT Support Specialist",
      confidence: 72,
      skills: [
        "Technical Support",
        "Troubleshooting",
        "Networking",
        "Hardware",
      ],
      education: "Diploma in IT/Computer Studies",
      pathway: "College",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Kenya Institute of Business Studies",
        "Nairobi Technical Institute",
      ],
      description:
        "Provide technical assistance and support for computer systems",
      growth: "12% (2023-2028)",
      interests: ["technology_computing"],
      icon: <Computer />,
      category: "technology_computing",
    },

    // Helping and Social careers
    {
      career: "Social Worker",
      confidence: 72,
      skills: [
        "Empathy",
        "Communication",
        "Problem Solving",
        "Case Management",
      ],
      education: "Degree in Social Work",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Kenyatta University",
        "Moi University",
      ],
      description: "Help individuals and communities overcome challenges",
      growth: "16% (2023-2028)",
      interests: ["helping_social"],
      icon: <Group />,
      category: "helping_social",
    },
    {
      career: "Counselor",
      confidence: 74,
      skills: ["Listening", "Empathy", "Communication", "Psychology Knowledge"],
      education: "Degree in Counseling Psychology",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Kenyatta University",
        "Daystar University",
      ],
      description:
        "Provide guidance and support to individuals facing personal challenges",
      growth: "18% (2023-2028)",
      interests: ["helping_social"],
      icon: <PsychologyAlt />,
      category: "helping_social",
    },

    // Business and Entrepreneurship careers
    {
      career: "Entrepreneur/Business Owner",
      confidence: 75,
      skills: [
        "Leadership",
        "Risk Management",
        "Innovation",
        "Financial Management",
      ],
      education: "Business Training + Experience",
      pathway: "Various",
      demand: "High",
      salary: "Variable",
      kenyan_institutions: [
        "Strathmore Business School",
        "University of Nairobi Entrepreneurship Center",
      ],
      description: "Start and manage your own business venture",
      growth: "20% (2023-2028)",
      interests: ["business_entrepreneurship"],
      icon: <Business />,
      category: "business_entrepreneurship",
    },
    {
      career: "Marketing Manager",
      confidence: 77,
      skills: [
        "Strategy",
        "Communication",
        "Market Research",
        "Digital Marketing",
      ],
      education: "Degree in Marketing/Business",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Kenyatta University",
        "Mount Kenya University",
      ],
      description:
        "Develop and implement marketing strategies to promote products/services",
      growth: "14% (2023-2028)",
      interests: ["business_entrepreneurship"],
      icon: <TrendingUp />,
      category: "business_entrepreneurship",
    },

    // Outdoor and Practical careers
    {
      career: "Agricultural Manager",
      confidence: 76,
      skills: [
        "Farm Management",
        "Planning",
        "Technical Knowledge",
        "Business Acumen",
      ],
      education: "Degree in Agriculture/Agribusiness",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Egerton University",
        "University of Nairobi",
        "JKUAT",
      ],
      description: "Manage agricultural operations and farm businesses",
      growth: "17% (2023-2028)",
      interests: ["outdoor_practical"],
      icon: <Agriculture />,
      category: "outdoor_practical",
    },
    {
      career: "Tour Guide",
      confidence: 70,
      skills: ["Communication", "Knowledge", "Customer Service", "Leadership"],
      education: "Certificate in Tour Guiding",
      pathway: "Vocational",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "Utalii College",
        "Various Tourism Training Centers",
      ],
      description: "Guide tourists through attractions and provide information",
      growth: "15% (2023-2028)",
      interests: ["outdoor_practical", "cultural_traditional"],
      icon: <Public />,
      category: "outdoor_practical",
    },

    // Language and Communication careers
    {
      career: "Content Writer",
      confidence: 74,
      skills: ["Writing", "Research", "Creativity", "SEO Knowledge"],
      education: "Degree in Communications/Journalism",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Daystar University",
        "Kenyatta University",
      ],
      description:
        "Create written content for websites, blogs, and marketing materials",
      growth: "16% (2023-2028)",
      interests: ["language_communication"],
      icon: <MenuBook />,
      category: "language_communication",
    },
    {
      career: "Translator/Interpreter",
      confidence: 76,
      skills: [
        "Language Proficiency",
        "Cultural Knowledge",
        "Accuracy",
        "Communication",
      ],
      education: "Degree in Languages/Translation",
      pathway: "University",
      demand: "Medium",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Kenyatta University",
        "Moi University",
      ],
      description:
        "Translate written or spoken content between different languages",
      growth: "14% (2023-2028)",
      interests: ["language_communication"],
      icon: <Translate />,
      category: "language_communication",
    },

    // Cultural and Traditional careers
    {
      career: "Cultural Officer",
      confidence: 72,
      skills: [
        "Cultural Knowledge",
        "Preservation",
        "Community Engagement",
        "Research",
      ],
      education: "Degree in Cultural Studies/Anthropology",
      pathway: "University",
      demand: "Low",
      salary: "Medium",
      kenyan_institutions: [
        "University of Nairobi",
        "Kenyatta University",
        "Moi University",
      ],
      description: "Preserve and promote cultural heritage and traditions",
      growth: "12% (2023-2028)",
      interests: ["cultural_traditional"],
      icon: <PublicIcon />,
      category: "cultural_traditional",
    },
    {
      career: "Museum Curator",
      confidence: 73,
      skills: [
        "Research",
        "Exhibition Design",
        "Artifact Preservation",
        "Public Education",
      ],
      education: "Degree in Museum Studies/History",
      pathway: "University",
      demand: "Low",
      salary: "Medium",
      kenyan_institutions: ["University of Nairobi", "Kenyatta University"],
      description:
        "Manage museum collections and create educational exhibitions",
      growth: "11% (2023-2028)",
      interests: ["cultural_traditional"],
      icon: <History />,
      category: "cultural_traditional",
    },
  ],
};

const EnhancedCareerInsights = () => {
  const { state } = useLocation();
  const { learnerId, learner } = state || {};
  const [insightsData, setInsightsData] = useState(null);
  const [resultsData, setResultsData] = useState(null);
  const [interestsData, setInterestsData] = useState(null);
  const [detailedAnalysis, setDetailedAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [showAdviceModal, setShowAdviceModal] = useState(false);
  const [selectedCareer, setSelectedCareer] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [filters, setFilters] = useState({
    educationLevel: "all",
    interestArea: "all",
    confidenceThreshold: 60,
    analysisType: "both",
  });

  // Function to generate dedicated interest-based career projections
  const generateInterestBasedCareerProjections = (interests) => {
    if (!interests || !interests.combinedInterests.length) return null;

    const projections = {
      primaryInterest: null,
      secondaryInterest: null,
      careerPathways: [],
      skillDevelopment: [],
      extracurricularRecommendations: [],
      longTermPotential: [],
    };

    // Primary interest projection
    if (interests.primaryInterest) {
      const primaryCategory =
        enhancedInterestCategories[interests.primaryInterest];
      projections.primaryInterest = {
        category: interests.primaryInterest,
        strength: interests.interestStrength[interests.primaryInterest],
        description: `Strong passion for ${interests.primaryInterest.replace(
          "_",
          " "
        )} activities`,
        topCareers: comprehensiveCareerDatabase.interest_based
          .filter((career) => career.category === interests.primaryInterest)
          .slice(0, 5)
          .map((career) => ({
            name: career.career,
            confidence: Math.min(
              95,
              70 + interests.interestStrength[interests.primaryInterest] * 5
            ),
            pathway: career.pathway,
            description: career.description,
          })),
      };
    }

    // Secondary interest projection
    if (interests.secondaryInterest) {
      const secondaryCategory =
        enhancedInterestCategories[interests.secondaryInterest];
      projections.secondaryInterest = {
        category: interests.secondaryInterest,
        strength: interests.interestStrength[interests.secondaryInterest],
        description: `Developing interest in ${interests.secondaryInterest.replace(
          "_",
          " "
        )} activities`,
        topCareers: comprehensiveCareerDatabase.interest_based
          .filter((career) => career.category === interests.secondaryInterest)
          .slice(0, 3)
          .map((career) => ({
            name: career.career,
            confidence: Math.min(
              90,
              60 + interests.interestStrength[interests.secondaryInterest] * 4
            ),
            pathway: career.pathway,
            description: career.description,
          })),
      };
    }

    // Career pathways based on combined interests
    projections.careerPathways = interests.combinedInterests.map(
      (interest) => ({
        interest: interest.category,
        careerOpportunities: interest.potentialCareers,
        growthPotential: "High",
        marketDemand: "Growing in Kenya",
        recommendedActions: generateRecommendedActions(interest.category),
      })
    );

    // Skill development recommendations
    projections.skillDevelopment = interests.combinedInterests
      .flatMap((interest) =>
        interest.relatedSkills.map((skill) => ({
          skill,
          importance: "High",
          developmentActivities: generateSkillDevelopmentActivities(
            skill,
            interest.category
          ),
        }))
      )
      .slice(0, 8);

    // Extracurricular recommendations
    projections.extracurricularRecommendations =
      interests.combinedInterests.map((interest) => ({
        area: interest.category,
        activities: generateExtracurricularActivities(interest.category),
        benefits: "Skill development and portfolio building",
      }));

    // Long-term potential
    projections.longTermPotential = interests.combinedInterests.map(
      (interest) => ({
        area: interest.category,
        futureTrend: getFutureTrend(interest.category),
        kenyanOpportunities: getKenyanOpportunities(interest.category),
        globalPotential: "High",
      })
    );

    return projections;
  };

  // Helper functions for interest projections
  const generateRecommendedActions = (interestCategory) => {
    const actions = {
      sports_physical: [
        "Join school sports teams",
        "Participate in inter-school competitions",
        "Attend sports training camps",
        "Develop coaching skills",
      ],
      music_performing: [
        "Join school choir or band",
        "Participate in drama festivals",
        "Take music lessons",
        "Perform in community events",
      ],
      visual_arts: [
        "Create art portfolio",
        "Participate in art competitions",
        "Join art clubs",
        "Learn digital design tools",
      ],
      technology_computing: [
        "Join coding club",
        "Participate in tech competitions",
        "Build personal projects",
        "Learn programming languages",
      ],
      science_nature: [
        "Join science club",
        "Participate in science fairs",
        "Start a small garden",
        "Conduct simple experiments",
      ],
      helping_social: [
        "Join community service club",
        "Volunteer at local organizations",
        "Develop leadership skills",
        "Participate in peer counseling",
      ],
      business_entrepreneurship: [
        "Start small business project",
        "Join entrepreneurship club",
        "Learn about marketing",
        "Participate in business competitions",
      ],
      outdoor_practical: [
        "Join scouts movement",
        "Learn practical skills",
        "Participate in outdoor activities",
        "Develop technical abilities",
      ],
      language_communication: [
        "Join debate club",
        "Write for school magazine",
        "Learn new languages",
        "Practice public speaking",
      ],
      cultural_traditional: [
        "Participate in cultural events",
        "Learn traditional skills",
        "Join cultural clubs",
        "Document local traditions",
      ],
    };
    return (
      actions[interestCategory] || [
        "Join relevant clubs and activities",
        "Develop related skills",
        "Seek mentorship",
      ]
    );
  };

  const generateSkillDevelopmentActivities = (skill, category) => {
    const activities = {
      analytical: [
        "Practice problem-solving",
        "Join math club",
        "Learn coding",
        "Play strategy games",
      ],
      creative: [
        "Practice daily",
        "Join art clubs",
        "Experiment with different mediums",
        "Keep a creative journal",
      ],
      technical: [
        "Hands-on projects",
        "Technical workshops",
        "Online tutorials",
        "Mentorship",
      ],
      communication: [
        "Public speaking practice",
        "Join debate club",
        "Writing exercises",
        "Group discussions",
      ],
      practical: [
        "DIY projects",
        "Practical workshops",
        "Apprenticeship",
        "Skill-building activities",
      ],
      leadership: [
        "Lead group projects",
        "Join student council",
        "Organize events",
        "Team sports",
      ],
      interpersonal: [
        "Group activities",
        "Volunteer work",
        "Peer counseling",
        "Team projects",
      ],
    };
    return (
      activities[skill] || [
        "Practice regularly",
        "Seek feedback",
        "Set improvement goals",
      ]
    );
  };

  const generateExtracurricularActivities = (category) => {
    const activities = {
      sports_physical: [
        "School teams",
        "Sports clubs",
        "Fitness training",
        "Coaching",
      ],
      music_performing: [
        "School band",
        "Drama club",
        "Music lessons",
        "Performances",
      ],
      visual_arts: [
        "Art club",
        "Photography",
        "Design projects",
        "Exhibitions",
      ],
      technology_computing: [
        "Coding club",
        "Robotics",
        "Tech projects",
        "Hackathons",
      ],
      science_nature: [
        "Science club",
        "Environmental projects",
        "Research",
        "Experiments",
      ],
      helping_social: [
        "Community service",
        "Peer counseling",
        "Leadership programs",
        "Volunteering",
      ],
      business_entrepreneurship: [
        "Business club",
        "Young entrepreneurs",
        "Market days",
        "Projects",
      ],
      outdoor_practical: [
        "Scouts",
        "Agriculture club",
        "Technical projects",
        "Outdoor adventures",
      ],
      language_communication: [
        "Debate club",
        "Journalism",
        "Writing contests",
        "Language clubs",
      ],
      cultural_traditional: [
        "Cultural clubs",
        "Traditional arts",
        "Heritage projects",
        "Festivals",
      ],
    };
    return (
      activities[category] || [
        "Join relevant clubs",
        "Participate in competitions",
        "Develop skills",
      ]
    );
  };

  const getFutureTrend = (category) => {
    const trends = {
      sports_physical:
        "Growing sports industry in Kenya with increased professional opportunities",
      music_performing:
        "Expanding creative industry with digital platforms creating new opportunities",
      visual_arts: "Digital art and design fields experiencing rapid growth",
      technology_computing:
        "High demand for tech skills in Kenya's growing digital economy",
      science_nature:
        "Increasing focus on environmental conservation and scientific research",
      helping_social:
        "Growing need for social services and community development",
      business_entrepreneurship:
        "Vibrant startup ecosystem with government support",
      outdoor_practical:
        "Sustainable agriculture and green technologies on the rise",
      language_communication:
        "Globalization increasing demand for communication skills",
      cultural_traditional:
        "Cultural tourism and heritage preservation gaining importance",
    };
    return (
      trends[category] || "Positive growth outlook with diverse opportunities"
    );
  };

  const getKenyanOpportunities = (category) => {
    const opportunities = {
      sports_physical:
        "Professional leagues, coaching, sports management, fitness industry",
      music_performing:
        "Music industry, events, teaching, digital content creation",
      visual_arts: "Design firms, advertising, media, freelance opportunities",
      technology_computing:
        "Tech companies, startups, digital services, IT support",
      science_nature:
        "Research institutions, conservation, agriculture, healthcare",
      helping_social: "NGOs, community development, healthcare, education",
      business_entrepreneurship:
        "Startups, SMEs, corporate careers, consulting",
      outdoor_practical: "Agriculture, construction, tourism, conservation",
      language_communication:
        "Media, publishing, translation, corporate communications",
      cultural_traditional:
        "Tourism, cultural institutions, education, preservation",
    };
    return (
      opportunities[category] || "Diverse opportunities across multiple sectors"
    );
  };

  // Enhanced analysis functions
  const performAdvancedAnalysis = (results, interests, learner) => {
    const subjectAverages = calculateEnhancedSubjectAverages(
      results,
      learner?.class
    );
    const overallAverage = calculateOverallAverage(subjectAverages);
    const performanceLevel = getPerformanceLevel(overallAverage);
    const detectedInterests = analyzeEnhancedInterests(interests);

    // Calculate skill profiles
    const skillProfile = calculateSkillProfile(
      subjectAverages,
      detectedInterests
    );

    // Generate interest-based career projections
    const interestProjections =
      generateInterestBasedCareerProjections(detectedInterests);

    const analysis = {
      performanceLevel,
      overallAverage,
      subjectAverages,
      currentClass: learner?.class,
      interests: detectedInterests,
      skillProfile,
      careerRecommendations: generateEnhancedCareerRecommendations(
        subjectAverages,
        performanceLevel,
        detectedInterests,
        skillProfile
      ),
      improvementAreas: identifyImprovementAreas(subjectAverages),
      strengths: identifyStrengths(subjectAverages),
      confidenceScore: calculateConfidenceScore(
        subjectAverages,
        detectedInterests
      ),
      learningAdvice: generateLearningAdvice(
        performanceLevel,
        subjectAverages,
        learner?.class
      ),
      pathwayRecommendation: getPathwayRecommendation(performanceLevel),
      marketInsights: getMarketInsights(skillProfile, performanceLevel),
      interestProjections,
    };

    return analysis;
  };

  const calculateEnhancedSubjectAverages = (results, currentClass) => {
    if (!results) return [];

    const subjectTotals = {};
    const subjectCounts = {};
    const subjectTrends = {};

    Object.values(results).forEach((termData) => {
      Object.values(termData).forEach((examData) => {
        examData.forEach(({ subject, marks }) => {
          // Normalize subject name using CBC mappings
          let normalizedSubject = cbcSubjectMappings[subject] || subject;
          if (typeof normalizedSubject === "string") {
            normalizedSubject = cbcSubjectMappings[normalizedSubject] || {
              category: "General",
              weight: 1.0,
              skills: [],
            };
          }

          const subjectName =
            typeof normalizedSubject === "string" ? normalizedSubject : subject;
          const subjectInfo =
            typeof normalizedSubject === "object"
              ? normalizedSubject
              : cbcSubjectMappings[subjectName] || {
                  category: "General",
                  weight: 1.0,
                  skills: [],
                };

          if (!subjectTotals[subjectName]) {
            subjectTotals[subjectName] = 0;
            subjectCounts[subjectName] = 0;
            subjectTrends[subjectName] = [];
          }

          subjectTotals[subjectName] += Number(marks);
          subjectCounts[subjectName] += 1;
          subjectTrends[subjectName].push(Number(marks));
        });
      });
    });

    const averages = Object.entries(subjectTotals)
      .map(([subject, total]) => {
        const average = total / subjectCounts[subject];
        const trend = calculateTrend(subjectTrends[subject]);
        const subjectInfo =
          typeof cbcSubjectMappings[subject] === "object"
            ? cbcSubjectMappings[subject]
            : {
                category: "General",
                weight: 1.0,
                skills: [],
                relatedCareers: [],
              };

        return {
          subject,
          average,
          count: subjectCounts[subject],
          trend,
          category: subjectInfo.category,
          weight: subjectInfo.weight,
          skills: subjectInfo.skills,
          relatedCareers: subjectInfo.relatedCareers,
          recent: true,
        };
      })
      .sort((a, b) => b.average * b.weight - a.average * a.weight);

    return averages;
  };

  const calculateTrend = (marks) => {
    if (marks.length < 2) return "stable";
    const firstHalf = marks.slice(0, Math.floor(marks.length / 2));
    const secondHalf = marks.slice(Math.floor(marks.length / 2));
    const firstAvg = firstHalf.reduce((a, b) => a + b, 0) / firstHalf.length;
    const secondAvg = secondHalf.reduce((a, b) => a + b, 0) / secondHalf.length;

    if (secondAvg > firstAvg + 5) return "improving";
    if (secondAvg < firstAvg - 5) return "declining";
    return "stable";
  };

  const analyzeEnhancedInterests = (interestsData) => {
    if (!interestsData) return null;

    let homeInterests = [];
    let schoolInterests = [];

    if (interestsData.interests) {
      homeInterests = interestsData.interests.home || [];
      schoolInterests = interestsData.interests.school || [];
    } else {
      homeInterests = interestsData.home || [];
      schoolInterests = interestsData.school || [];
    }

    const interests = {
      home: homeInterests,
      school: schoolInterests,
      detectedCategories: [],
      primaryInterest: null,
      secondaryInterest: null,
      interestStrength: {},
      combinedInterests: [],
    };

    const allInterestText = [];

    // Process home interests
    homeInterests.forEach((interest) => {
      if (interest.activities && Array.isArray(interest.activities)) {
        allInterestText.push(...interest.activities);
      }
      if (interest.category) {
        allInterestText.push(interest.category);
      }
      if (interest.notes) {
        allInterestText.push(interest.notes);
      }
      if (interest.description) {
        allInterestText.push(interest.description);
      }
    });

    // Process school interests
    schoolInterests.forEach((interest) => {
      if (interest.activities && Array.isArray(interest.activities)) {
        allInterestText.push(...interest.activities);
      }
      if (interest.category) {
        allInterestText.push(interest.category);
      }
      if (interest.notes) {
        allInterestText.push(interest.notes);
      }
      if (interest.description) {
        allInterestText.push(interest.description);
      }
    });

    // Enhanced interest detection
    const categoryScores = {};

    allInterestText.forEach((interestText) => {
      const text = interestText.toString().toLowerCase();

      Object.entries(enhancedInterestCategories).forEach(([category, data]) => {
        data.keywords.forEach((keyword) => {
          if (text.includes(keyword.toLowerCase())) {
            categoryScores[category] = (categoryScores[category] || 0) + 1;
          }
        });
      });
    });

    // Sort by strength
    interests.detectedCategories = Object.entries(categoryScores)
      .sort(([, a], [, b]) => b - a)
      .map(([category]) => category);

    interests.interestStrength = categoryScores;

    if (interests.detectedCategories.length > 0) {
      interests.primaryInterest = interests.detectedCategories[0];
      interests.secondaryInterest = interests.detectedCategories[1] || null;
    }

    // Create combined interest profile
    interests.combinedInterests = interests.detectedCategories.map(
      (category) => ({
        category,
        strength: categoryScores[category],
        relatedSkills: enhancedInterestCategories[category].skills,
        potentialCareers: enhancedInterestCategories[category].careers,
        icon: enhancedInterestCategories[category].icon,
        color: enhancedInterestCategories[category].color,
      })
    );

    return interests;
  };

  const calculateSkillProfile = (subjectAverages, interests) => {
    const skills = {
      analytical: 0,
      creative: 0,
      technical: 0,
      communication: 0,
      practical: 0,
      leadership: 0,
      interpersonal: 0,
    };

    // Calculate from subjects
    subjectAverages.forEach((subject) => {
      const subjectInfo = cbcSubjectMappings[subject.subject];
      if (subjectInfo && subjectInfo.skills) {
        subjectInfo.skills.forEach((skill) => {
          skills[skill] =
            (skills[skill] || 0) + (subject.average * subjectInfo.weight) / 100;
        });
      }
    });

    // Boost from interests
    if (interests && interests.combinedInterests) {
      interests.combinedInterests.forEach((interest) => {
        interest.relatedSkills.forEach((skill) => {
          skills[skill] = (skills[skill] || 0) + interest.strength * 10;
        });
      });
    }

    // Normalize scores
    Object.keys(skills).forEach((skill) => {
      skills[skill] = Math.min(100, Math.max(0, skills[skill]));
    });

    return skills;
  };

  const generateEnhancedCareerRecommendations = (
    subjectAverages,
    performanceLevel,
    interests,
    skillProfile
  ) => {
    const allRecommendations = [];
    const seenCareers = new Set();

    // 1. Subject-based recommendations (CBC Curriculum focused)
    if (filters.analysisType !== "interests") {
      subjectAverages
        .filter((s) => s.recent && s.average >= 50)
        .forEach((subject) => {
          const relevantCareers = findCareersBySubject(
            subject.subject,
            performanceLevel
          );
          relevantCareers.forEach((career) => {
            if (!seenCareers.has(career.career)) {
              seenCareers.add(career.career);
              const academicScore = calculateAcademicScore(
                career,
                subject,
                performanceLevel
              );
              const interestScore = calculateCareerInterestScore(
                career,
                interests
              );
              const skillScore = calculateSkillMatch(career, skillProfile);
              const totalScore =
                academicScore * 0.5 + interestScore * 0.3 + skillScore * 0.2;

              allRecommendations.push({
                ...career,
                confidenceScore: Math.round(totalScore),
                academicScore: Math.round(academicScore),
                interestScore: Math.round(interestScore),
                skillScore: Math.round(skillScore),
                matchType: "Academic Strength",
                reasons: generateSubjectBasedReasons(career, subject),
                category: career.category,
                analysisSource: "subjects",
              });
            }
          });
        });
    }

    // 2. Interest-based recommendations
    if (
      filters.analysisType !== "subjects" &&
      interests &&
      interests.detectedCategories.length > 0
    ) {
      interests.detectedCategories.forEach((category) => {
        const interestCareers = findCareersByInterest(category);
        interestCareers.forEach((career) => {
          if (!seenCareers.has(career.career)) {
            seenCareers.add(career.career);
            const academicScore = findBestAcademicMatch(
              career,
              subjectAverages,
              performanceLevel
            );
            const interestScore = calculatePureInterestScore(
              career,
              interests,
              category
            );
            const skillScore = calculateSkillMatch(career, skillProfile);
            const totalScore =
              academicScore * 0.3 + interestScore * 0.5 + skillScore * 0.2;

            allRecommendations.push({
              ...career,
              confidenceScore: Math.round(totalScore),
              academicScore: Math.round(academicScore),
              interestScore: Math.round(interestScore),
              skillScore: Math.round(skillScore),
              matchType: "Interest Match",
              reasons: generateInterestBasedReasons(
                career,
                interests,
                category
              ),
              category: career.category,
              analysisSource: "interests",
            });
          }
        });
      });
    }

    // Sort and return
    return allRecommendations
      .sort((a, b) => b.confidenceScore - a.confidenceScore)
      .slice(0, 50);
  };

  const findCareersBySubject = (subject, performanceLevel) => {
    const allCareers = [];

    // Get careers from subject-based database
    comprehensiveCareerDatabase.subject_based.forEach((career) => {
      if (career.subjects && career.subjects.includes(subject)) {
        allCareers.push(career);
      }
    });

    // Also check interest-based careers that might match the subject
    comprehensiveCareerDatabase.interest_based.forEach((career) => {
      if (career.subjects && career.subjects.includes(subject)) {
        allCareers.push(career);
      }
    });

    return allCareers.slice(0, 10);
  };

  const findCareersByInterest = (interestCategory) => {
    return comprehensiveCareerDatabase.interest_based
      .filter((career) => career.category === interestCategory)
      .slice(0, 15);
  };

  const calculateAcademicScore = (career, subject, performanceLevel) => {
    let score = career.confidence || 70;

    // Adjust based on subject performance
    if (subject.average >= 80) score += 20;
    else if (subject.average >= 70) score += 15;
    else if (subject.average >= 60) score += 10;
    else if (subject.average >= 50) score += 5;

    // Adjust based on performance level
    if (performanceLevel === "excellent") score += 15;
    else if (performanceLevel === "good") score += 10;
    else if (performanceLevel === "average") score += 5;

    return Math.max(30, Math.min(95, score));
  };

  const calculateCareerInterestScore = (career, interests) => {
    if (!interests || !interests.detectedCategories.length) return 50;

    let score = 50;

    // Check if career category matches interest categories
    if (interests.detectedCategories.includes(career.category)) {
      if (career.category === interests.primaryInterest) score += 30;
      else if (career.category === interests.secondaryInterest) score += 15;
      else score += 10;
    }

    return Math.max(20, Math.min(90, score));
  };

  const calculatePureInterestScore = (career, interests, category) => {
    if (!interests) return career.confidence || 70;

    let score = career.confidence || 70;

    if (category === interests.primaryInterest) score += 25;
    else if (category === interests.secondaryInterest) score += 15;
    else score += 5;

    return Math.max(40, Math.min(95, score));
  };

  const calculateSkillMatch = (career, skillProfile) => {
    let matchScore = 50;

    // Simple skill matching
    if (career.skills) {
      career.skills.forEach((skill) => {
        const skillKey = mapSkillToProfile(skill);
        if (skillProfile[skillKey]) {
          matchScore += skillProfile[skillKey] / 10;
        }
      });
    }

    return Math.min(95, matchScore);
  };

  const mapSkillToProfile = (skill) => {
    const skillMap = {
      analytical: "analytical",
      creative: "creative",
      technical: "technical",
      communication: "communication",
      practical: "practical",
      leadership: "leadership",
      interpersonal: "interpersonal",
    };

    for (const [key, value] of Object.entries(skillMap)) {
      if (skill.toLowerCase().includes(key)) return value;
    }
    return "practical";
  };

  const findBestAcademicMatch = (career, subjectAverages, performanceLevel) => {
    // Find the best matching subject for this career
    if (career.subjects) {
      const relevantSubjects = subjectAverages.filter(
        (s) =>
          s.average >= 50 &&
          career.subjects.some((subject) =>
            s.subject.toLowerCase().includes(subject.toLowerCase())
          )
      );

      if (relevantSubjects.length > 0) {
        const bestSubject = relevantSubjects[0];
        return Math.min(
          90,
          bestSubject.average + (performanceLevel === "excellent" ? 10 : 0)
        );
      }
    }

    // Default academic confidence based on performance level
    const baseScores = {
      excellent: 75,
      good: 60,
      average: 45,
      belowAverage: 30,
      needsImprovement: 20,
    };

    return baseScores[performanceLevel] || 50;
  };

  const generateSubjectBasedReasons = (career, subject) => {
    const reasons = [];

    reasons.push(
      `Strong performance in ${subject.subject} (${subject.average.toFixed(
        1
      )}%)`
    );

    if (subject.relatedCareers && subject.relatedCareers.length > 0) {
      reasons.push(`Common career path for ${subject.subject} students`);
    }

    if (career.subjects) {
      reasons.push(
        `Requires strong ${career.subjects.slice(0, 2).join(" and ")} skills`
      );
    }

    return reasons;
  };

  const generateInterestBasedReasons = (career, interests, category) => {
    const reasons = [];

    const interestCategory = enhancedInterestCategories[category];
    if (interestCategory) {
      reasons.push(
        `Matches your interest in ${category.replace("_", " ")} activities`
      );
    }

    if (category === interests.primaryInterest) {
      reasons.push("Aligns with your primary area of passion");
    }

    if (career.skills) {
      reasons.push(
        `Opportunity to develop ${career.skills
          .slice(0, 2)
          .join(" and ")} skills`
      );
    }

    return reasons;
  };

  const identifyImprovementAreas = (subjectAverages) => {
    return subjectAverages
      .filter((subject) => subject.average < 50)
      .map((subject) => ({
        subject: subject.subject,
        currentScore: subject.average,
        targetScore: 60,
        improvementNeeded: (60 - subject.average).toFixed(1),
      }));
  };

  const identifyStrengths = (subjectAverages) => {
    return subjectAverages
      .filter((subject) => subject.average >= 70)
      .map((subject) => ({
        subject: subject.subject,
        score: subject.average,
        level: subject.average >= 85 ? "Exceptional" : "Strong",
      }));
  };

  const calculateConfidenceScore = (subjectAverages, interests) => {
    if (subjectAverages.length === 0) return 0;

    let score = 50;

    // Data completeness
    if (subjectAverages.length >= 5) score += 20;
    else if (subjectAverages.length >= 3) score += 10;

    // Academic performance
    const average = calculateOverallAverage(subjectAverages);
    if (average >= 60) score += 20;
    else if (average >= 40) score += 10;

    // Interests data
    if (interests && interests.detectedCategories.length > 0) score += 15;

    return Math.min(95, score);
  };

  const calculateOverallAverage = (subjectAverages) => {
    if (subjectAverages.length === 0) return 0;
    const total = subjectAverages.reduce(
      (sum, subject) => sum + subject.average,
      0
    );
    return total / subjectAverages.length;
  };

  const getPerformanceLevel = (average) => {
    if (average >= 85) return "excellent";
    if (average >= 70) return "good";
    if (average >= 55) return "average";
    if (average >= 40) return "belowAverage";
    return "needsImprovement";
  };

  const generateLearningAdvice = (
    performanceLevel,
    subjectAverages,
    currentClass
  ) => {
    const advice = {
      excellent: [
        "Continue excelling in your strong subjects",
        "Consider participating in academic competitions",
        "Explore advanced topics in your areas of interest",
      ],
      good: [
        "Focus on maintaining your current performance",
        "Identify specific areas for minor improvements",
        "Develop deeper understanding in your strong subjects",
      ],
      average: [
        "Create a structured study schedule",
        "Seek help in weaker subjects from teachers",
        "Focus on understanding fundamental concepts",
      ],
      belowAverage: [
        "Develop basic literacy and numeracy skills",
        "Work closely with teachers to identify gaps",
        "Focus on one subject at a time for improvement",
      ],
      needsImprovement: [
        "Start with foundational skills building",
        "Consider one-on-one tutoring support",
        "Set small, achievable learning goals",
      ],
    };

    return advice[performanceLevel] || advice.average;
  };

  const getPathwayRecommendation = (performanceLevel) => {
    const pathways = {
      excellent: {
        pathway: "University Degree Pathway",
        description: "Direct entry to university for bachelor degree programs",
        requirements:
          "Mean grade of C+ and above with relevant subject combinations",
      },
      good: {
        pathway: "Diploma/College Pathway",
        description: "Technical training through diploma programs",
        requirements: "Mean grade of C- to C+ for diploma courses",
      },
      average: {
        pathway: "Certificate/Vocational Training",
        description: "Skills-based training through certificate programs",
        requirements: "Mean grade of D to D+ for certificate courses",
      },
      belowAverage: {
        pathway: "Vocational Skills Training",
        description: "Basic skills training through youth polytechnics",
        requirements: "Focus on foundational skills improvement",
      },
      needsImprovement: {
        pathway: "Basic Skills Development",
        description: "Remedial education and basic skills training",
        requirements: "Literacy and numeracy skills development",
      },
    };

    return pathways[performanceLevel] || pathways.average;
  };

  const getMarketInsights = (skillProfile, performanceLevel) => {
    return {
      highDemandFields: [
        "Technology",
        "Healthcare",
        "Renewable Energy",
        "Education",
      ],
      emergingFields: [
        "Artificial Intelligence",
        "Data Science",
        "Cybersecurity",
        "Digital Marketing",
      ],
      recommendedSkills: [
        "Digital Literacy",
        "Critical Thinking",
        "Communication",
        "Problem Solving",
      ],
    };
  };

  // Enhanced filtering system
  const filterCareers = (careers, filters) => {
    return careers.filter((career) => {
      // Confidence threshold
      if (career.confidenceScore < filters.confidenceThreshold) return false;

      // Education level
      if (filters.educationLevel !== "all") {
        if (
          filters.educationLevel === "university" &&
          career.pathway !== "University"
        )
          return false;
        if (
          filters.educationLevel === "college" &&
          career.pathway !== "College"
        )
          return false;
        if (
          filters.educationLevel === "vocational" &&
          career.pathway !== "Vocational"
        )
          return false;
      }

      // Interest area
      if (
        filters.interestArea !== "all" &&
        career.category !== filters.interestArea
      )
        return false;

      // Analysis type
      if (
        filters.analysisType === "subjects" &&
        career.analysisSource !== "subjects"
      )
        return false;
      if (
        filters.analysisType === "interests" &&
        career.analysisSource !== "interests"
      )
        return false;

      return true;
    });
  };

  const fetchInsights = async () => {
    try {
      setLoading(true);
      setError(null);

      const [resultsResponse, interestsResponse] = await Promise.all([
        axios.get(
          `https://kidsm.vercel.app/api/schools/learner/${learnerId}/results`
        ),
        axios.get(
          `https://kidsm.vercel.app/api/schools/learner/${learnerId}/interests`
        ),
      ]);

      setResultsData(resultsResponse.data.results);
      setInterestsData(interestsResponse.data);

      const analysis = performAdvancedAnalysis(
        resultsResponse.data.results,
        interestsResponse.data,
        learner
      );
      setDetailedAnalysis(analysis);
    } catch (error) {
      console.error("Fetch error:", error);
      setError(
        "Failed to load career insights. Please ensure the student has sufficient data."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCareerPress = (career) => {
    setSelectedCareer(career);
    setShowAdviceModal(true);
  };

  const handleRefresh = async () => {
    await fetchInsights();
  };

  useEffect(() => {
    if (learnerId) {
      fetchInsights();
    }
  }, [learnerId]);

  // NEW: Interest Projections Tab Content
  const renderInterestProjections = () => {
    if (!detailedAnalysis.interestProjections) {
      return (
        <Card sx={{ p: 4, textAlign: "center" }}>
          <Typography color="textSecondary">
            No interest data available for career projections. Please ensure
            interests are recorded by parents and teachers.
          </Typography>
        </Card>
      );
    }

    const projections = detailedAnalysis.interestProjections;

    return (
      <Box>
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          💫 Career Projections Based on Interests
        </Typography>

        {/* Primary Interest Focus */}
        {projections.primaryInterest && (
          <Card
            sx={{
              p: 3,
              mb: 3,
              borderLeft: `4px solid ${
                enhancedInterestCategories[projections.primaryInterest.category]
                  ?.color || "#6200ee"
              }`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Favorite color="error" sx={{ mr: 1 }} />
              <Typography variant="h6" color="primary">
                Primary Interest Focus
              </Typography>
            </Box>
            <Typography variant="h6" gutterBottom>
              {projections.primaryInterest.category
                .replace("_", " ")
                .toUpperCase()}
            </Typography>
            <Typography paragraph>
              {projections.primaryInterest.description} (Strength:{" "}
              {projections.primaryInterest.strength})
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              🎯 Top Career Matches
            </Typography>
            <Grid container spacing={2}>
              {projections.primaryInterest.topCareers.map((career, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                        mb: 1,
                      }}
                    >
                      <Typography fontWeight="bold">{career.name}</Typography>
                      <Chip
                        label={`${career.confidence}%`}
                        size="small"
                        color={career.confidence >= 80 ? "success" : "primary"}
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      {career.pathway}
                    </Typography>
                    <Typography variant="body2">
                      {career.description}
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Card>
        )}

        {/* Secondary Interest Development */}
        {projections.secondaryInterest && (
          <Card
            sx={{
              p: 3,
              mb: 3,
              borderLeft: `4px solid ${
                enhancedInterestCategories[
                  projections.secondaryInterest.category
                ]?.color || "#6200ee"
              }`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Star color="warning" sx={{ mr: 1 }} />
              <Typography variant="h6" color="primary">
                Secondary Interest Development
              </Typography>
            </Box>
            <Typography variant="h6" gutterBottom>
              {projections.secondaryInterest.category
                .replace("_", " ")
                .toUpperCase()}
            </Typography>
            <Typography paragraph>
              {projections.secondaryInterest.description} (Strength:{" "}
              {projections.secondaryInterest.strength})
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              💡 Potential Career Paths
            </Typography>
            <Grid container spacing={2}>
              {projections.secondaryInterest.topCareers.map((career, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Card variant="outlined" sx={{ p: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "start",
                        mb: 1,
                      }}
                    >
                      <Typography fontWeight="bold">{career.name}</Typography>
                      <Chip
                        label={`${career.confidence}%`}
                        size="small"
                        color={career.confidence >= 70 ? "primary" : "default"}
                      />
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {career.pathway}
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Card>
        )}

        {/* Skill Development Plan */}
        <Card sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            🛠️ Skill Development Plan
          </Typography>
          <Grid container spacing={2}>
            {projections.skillDevelopment.map((skill, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card variant="outlined" sx={{ p: 2 }}>
                  <Typography fontWeight="bold" gutterBottom>
                    {skill.skill.charAt(0).toUpperCase() + skill.skill.slice(1)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Importance: {skill.importance}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Development Activities:</strong>{" "}
                    {skill.developmentActivities.join(", ")}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Card>

        {/* Extracurricular Recommendations */}
        <Card sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            🎪 Extracurricular Recommendations
          </Typography>
          <Grid container spacing={2}>
            {projections.extracurricularRecommendations.map((rec, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card variant="outlined" sx={{ p: 2 }}>
                  <Typography fontWeight="bold" gutterBottom>
                    {rec.area.replace("_", " ").toUpperCase()}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Activities:</strong> {rec.activities.join(", ")}
                  </Typography>
                  <Typography variant="body2" color="success.main">
                    {rec.benefits}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Card>

        {/* Long-term Potential */}
        <Card sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            🚀 Long-term Career Potential
          </Typography>
          <Grid container spacing={2}>
            {projections.longTermPotential.map((potential, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card variant="outlined" sx={{ p: 2 }}>
                  <Typography fontWeight="bold" gutterBottom>
                    {potential.area.replace("_", " ").toUpperCase()}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Future Trend:</strong> {potential.futureTrend}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Kenyan Opportunities:</strong>{" "}
                    {potential.kenyanOpportunities}
                  </Typography>
                  <Typography variant="body2" color="primary.main">
                    Global Potential: {potential.globalPotential}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Box>
    );
  };

  // Loading state
  if (loading) {
    return (
      <Container
        maxWidth="lg"
        sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <CircularProgress color="primary" />
          <Typography sx={{ mt: 2, color: "#666" }}>
            Analyzing CBC performance and interests...
          </Typography>
        </Box>
      </Container>
    );
  }

  // Error state
  if (error || !detailedAnalysis) {
    return (
      <Container
        maxWidth="lg"
        sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <Typography
            sx={{
              fontSize: "1rem",
              color: "#e74c3c",
              mb: 2,
              textAlign: "center",
            }}
          >
            {error || "No sufficient data available for career insights."}
          </Typography>
          <Button
            variant="contained"
            onClick={fetchInsights}
            sx={{ bgcolor: "#6200ee", borderRadius: 2, textTransform: "none" }}
          >
            Try Again
          </Button>
        </Box>
      </Container>
    );
  }

  const filteredCareers = filterCareers(
    detailedAnalysis.careerRecommendations,
    filters
  );

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Enhanced Header */}
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", color: "#333", mb: 2, textAlign: "center" }}
        >
         AI Powered CBC Career Insights and Projections
        </Typography>
        <Typography
          sx={{ fontSize: "1rem", color: "#666", mb: 4, textAlign: "center" }}
        >
          Comprehensive career analysis based on CBC performance and student
          interests
        </Typography>

        {/* Student Info */}
        <Card sx={{ p: 3, mb: 4, bgcolor: "white" }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="h5" gutterBottom>
                {learner?.fullName || "Student"}
              </Typography>
              <Typography color="textSecondary" gutterBottom>
                Admission: {learner?.admissionNumber} • Class: {learner?.class}
              </Typography>
              <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
                <Chip
                  label={`Overall: ${detailedAnalysis.overallAverage.toFixed(
                    1
                  )}%`}
                  color="primary"
                  variant="outlined"
                />
                <Chip
                  label={`Performance: ${detailedAnalysis.performanceLevel}`}
                  color="secondary"
                  variant="outlined"
                />
                <Chip
                  label={`Confidence: ${detailedAnalysis.confidenceScore}%`}
                  color="success"
                  variant="outlined"
                />
              </Box>
            </Grid>
          </Grid>
        </Card>

        {/* Analysis Type Selector */}
        <Card sx={{ p: 3, mb: 4, bgcolor: "white" }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            🎯 Analysis Focus
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>Analysis Type</InputLabel>
                <Select
                  value={filters.analysisType}
                  onChange={(e) =>
                    setFilters({ ...filters, analysisType: e.target.value })
                  }
                >
                  <MenuItem value="both">Both Subjects & Interests</MenuItem>
                  <MenuItem value="subjects">CBC Subjects Only</MenuItem>
                  <MenuItem value="interests">Interests Only</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography variant="body2" color="textSecondary">
                {filters.analysisType === "both" &&
                  "Showing careers based on both academic performance and personal interests"}
                {filters.analysisType === "subjects" &&
                  "Showing careers primarily based on CBC subject performance"}
                {filters.analysisType === "interests" &&
                  "Showing careers primarily based on student interests and passions"}
              </Typography>
            </Grid>
          </Grid>
        </Card>

        {/* Filters Section */}
        <Card sx={{ p: 3, mb: 4, bgcolor: "white" }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            🔍 Refine Career Suggestions
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Education Pathway</InputLabel>
                <Select
                  value={filters.educationLevel}
                  onChange={(e) =>
                    setFilters({ ...filters, educationLevel: e.target.value })
                  }
                >
                  <MenuItem value="all">All Pathways</MenuItem>
                  <MenuItem value="university">University Degree</MenuItem>
                  <MenuItem value="college">College Diploma</MenuItem>
                  <MenuItem value="vocational">Vocational Training</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Interest Area</InputLabel>
                <Select
                  value={filters.interestArea}
                  onChange={(e) =>
                    setFilters({ ...filters, interestArea: e.target.value })
                  }
                >
                  <MenuItem value="all">All Areas</MenuItem>
                  {Object.entries(enhancedInterestCategories).map(
                    ([key, category]) => (
                      <MenuItem key={key} value={key}>
                        {key.replace("_", " ").toUpperCase()}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography gutterBottom>
                Minimum Confidence: {filters.confidenceThreshold}%
              </Typography>
              <Slider
                value={filters.confidenceThreshold}
                onChange={(e, newValue) =>
                  setFilters({ ...filters, confidenceThreshold: newValue })
                }
                min={30}
                max={95}
                valueLabelDisplay="auto"
              />
            </Grid>
          </Grid>
        </Card>

        {/* Enhanced Tabs - NOW INCLUDES INTEREST PROJECTIONS */}
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ mb: 3 }}
        >
          <Tab label="Career Matches" />
          <Tab label="Subject Analysis" />
          <Tab label="Interest Profile" />
          <Tab label="Interest Projections" />
          <Tab label="Pathway Planning" />
        </Tabs>

        {/* Tab Content */}
        {activeTab === 0 && (
          <Box>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              🎯 Career Recommendations ({filteredCareers.length} matches)
            </Typography>

            {filteredCareers.length > 0 ? (
              <Grid container spacing={3}>
                {filteredCareers.map((career, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index}>
                    <CareerCard
                      career={career}
                      onSelect={handleCareerPress}
                      index={index}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Card sx={{ p: 4, textAlign: "center" }}>
                <Typography color="textSecondary">
                  No careers match your current filters. Try adjusting the
                  criteria.
                </Typography>
              </Card>
            )}
          </Box>
        )}

        {activeTab === 1 && (
          <Box>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              📚 CBC Subject Performance
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Top Performing Subjects
                  </Typography>
                  <List>
                    {detailedAnalysis.strengths.map((strength, index) => (
                      <ListItem key={index}>
                        <ListItemIcon>
                          <School color="success" />
                        </ListItemIcon>
                        <ListItemText
                          primary={strength.subject}
                          secondary={`${strength.score.toFixed(1)}% - ${
                            strength.level
                          }`}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Areas for Improvement
                  </Typography>
                  <List>
                    {detailedAnalysis.improvementAreas.map((area, index) => (
                      <ListItem key={index}>
                        <ListItemIcon>
                          <School color="warning" />
                        </ListItemIcon>
                        <ListItemText
                          primary={area.subject}
                          secondary={`${area.currentScore.toFixed(
                            1
                          )}% - Needs +${area.improvementNeeded}%`}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Subject Performance Overview
                  </Typography>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart
                      data={detailedAnalysis.subjectAverages.slice(0, 10)}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="subject"
                        angle={-45}
                        textAnchor="end"
                        height={80}
                      />
                      <YAxis />
                      <Tooltip />
                      <Bar dataKey="average" fill="#82ca9d" />
                    </BarChart>
                  </ResponsiveContainer>
                </Card>
              </Grid>
            </Grid>
          </Box>
        )}

        {activeTab === 2 && (
          <Box>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              💫 Interest Profile
            </Typography>
            {detailedAnalysis.interests &&
            detailedAnalysis.interests.combinedInterests.length > 0 ? (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom>
                      Detected Interests
                    </Typography>
                    <List>
                      {detailedAnalysis.interests.combinedInterests.map(
                        (interest, index) => (
                          <ListItem key={index}>
                            <ListItemIcon sx={{ color: interest.color }}>
                              {interest.icon}
                            </ListItemIcon>
                            <ListItemText
                              primary={interest.category
                                .replace("_", " ")
                                .toUpperCase()}
                              secondary={`Strength: ${
                                interest.strength
                              } | Related Careers: ${interest.potentialCareers.join(
                                ", "
                              )}`}
                            />
                          </ListItem>
                        )
                      )}
                    </List>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom>
                      Skill Profile
                    </Typography>
                    <ResponsiveContainer width="100%" height={300}>
                      <RadarChart
                        data={Object.entries(detailedAnalysis.skillProfile).map(
                          ([skill, value]) => ({
                            subject:
                              skill.charAt(0).toUpperCase() + skill.slice(1),
                            A: value,
                            fullMark: 100,
                          })
                        )}
                      >
                        <PolarGrid />
                        <PolarAngleAxis dataKey="subject" />
                        <PolarRadiusAxis angle={30} domain={[0, 100]} />
                        <Radar
                          name="Skills"
                          dataKey="A"
                          stroke="#8884d8"
                          fill="#8884d8"
                          fillOpacity={0.6}
                        />
                      </RadarChart>
                    </ResponsiveContainer>
                  </Card>
                </Grid>
              </Grid>
            ) : (
              <Card sx={{ p: 4, textAlign: "center" }}>
                <Typography color="textSecondary">
                  No interest data available. Please ensure interests are
                  recorded by parents and teachers.
                </Typography>
              </Card>
            )}
          </Box>
        )}

        {activeTab === 3 &&
          // NEW: Interest Projections Tab
          renderInterestProjections()}

        {activeTab === 4 && (
          <Box>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              🎓 Educational Pathway
            </Typography>
            <Card sx={{ p: 3, mb: 3 }}>
              <Typography variant="h6" color="primary" gutterBottom>
                {detailedAnalysis.pathwayRecommendation.pathway}
              </Typography>
              <Typography paragraph>
                {detailedAnalysis.pathwayRecommendation.description}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Requirements:{" "}
                {detailedAnalysis.pathwayRecommendation.requirements}
              </Typography>
            </Card>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    High Demand Fields
                  </Typography>
                  <List>
                    {detailedAnalysis.marketInsights.highDemandFields.map(
                      (field, index) => (
                        <ListItem key={index}>
                          <ListItemIcon>
                            <TrendingUp color="success" />
                          </ListItemIcon>
                          <ListItemText primary={field} />
                        </ListItem>
                      )
                    )}
                  </List>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Recommended Skills
                  </Typography>
                  <List>
                    {detailedAnalysis.marketInsights.recommendedSkills.map(
                      (skill, index) => (
                        <ListItem key={index}>
                          <ListItemIcon>
                            <Work color="primary" />
                          </ListItemIcon>
                          <ListItemText primary={skill} />
                        </ListItem>
                      )
                    )}
                  </List>
                </Card>
              </Grid>
            </Grid>
          </Box>
        )}

        {/* Refresh Button */}
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Button
            variant="contained"
            onClick={handleRefresh}
            sx={{
              bgcolor: "#6200ee",
              borderRadius: 2,
              py: 1.5,
              px: 4,
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": { bgcolor: "#3700b3" },
            }}
          >
            Refresh Analysis
          </Button>
        </Box>
      </motion.div>

      {/* Enhanced Career Detail Modal */}
      <CareerDetailModal
        open={showAdviceModal}
        career={selectedCareer}
        onClose={() => setShowAdviceModal(false)}
        analysis={detailedAnalysis}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
      />
    </Container>
  );
};

// Career Card Component
const CareerCard = ({ career, onSelect, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
  >
    <Card
      sx={{
        p: 2,
        cursor: "pointer",
        transition: "all 0.3s",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderLeft: `4px solid ${
          enhancedInterestCategories[career.category]?.color || "#6200ee"
        }`,
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 6,
          bgcolor: "#f8f9fa",
        },
      }}
      onClick={() => onSelect(career)}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
          <Avatar
            sx={{
              bgcolor:
                enhancedInterestCategories[career.category]?.color || "#6200ee",
              width: 40,
              height: 40,
            }}
          >
            {career.icon}
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", lineHeight: 1.2 }}
            >
              {career.career}
            </Typography>
            <Chip
              label={
                career.analysisSource === "subjects"
                  ? "CBC Subjects"
                  : "Interests"
              }
              size="small"
              color={
                career.analysisSource === "subjects" ? "primary" : "secondary"
              }
              sx={{ mt: 0.5 }}
            />
          </Box>
        </Box>
        <Chip
          label={`${career.confidenceScore}%`}
          color={
            career.confidenceScore >= 80
              ? "success"
              : career.confidenceScore >= 60
              ? "warning"
              : "error"
          }
          size="small"
        />
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1, flex: 1 }}
      >
        {career.description}
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}>
        {career.skills.slice(0, 3).map((skill, i) => (
          <Chip key={i} label={skill} size="small" variant="outlined" />
        ))}
        {career.skills.length > 3 && (
          <Chip
            label={`+${career.skills.length - 3}`}
            size="small"
            variant="outlined"
          />
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {career.pathway} • {career.demand}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <AttachMoney
            fontSize="small"
            color={career.salary === "Very High" ? "success" : "primary"}
          />
          <Typography variant="caption" color="text.secondary">
            {career.salary}
          </Typography>
        </Box>
      </Box>
    </Card>
  </motion.div>
);

// Career Detail Modal Component
const CareerDetailModal = ({ open, career, onClose, analysis }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar
          sx={{
            bgcolor:
              enhancedInterestCategories[career?.category]?.color || "#6200ee",
            width: 50,
            height: 50,
          }}
        >
          {career?.icon}
        </Avatar>
        <Box>
          <Typography variant="h5" fontWeight="bold">
            {career?.career}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {career?.description}
          </Typography>
        </Box>
      </Box>
    </DialogTitle>
    <DialogContent>
      {career && (
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                📊 Match Analysis
              </Typography>
              <Card sx={{ p: 2, mb: 2 }}>
                <Box sx={{ mb: 2 }}>
                  <Typography>
                    Overall Confidence:{" "}
                    <strong>{career.confidenceScore}%</strong>
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={career.confidenceScore}
                    sx={{ height: 8, borderRadius: 4, mt: 1 }}
                    color={
                      career.confidenceScore >= 80
                        ? "success"
                        : career.confidenceScore >= 60
                        ? "warning"
                        : "error"
                    }
                  />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">
                    Academic Fit: {career.academicScore}%
                  </Typography>
                  <Typography variant="body2">
                    Interest Match: {career.interestScore}%
                  </Typography>
                  <Typography variant="body2">
                    Skill Alignment: {career.skillScore}%
                  </Typography>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                🎓 Education Pathway
              </Typography>
              <Card sx={{ p: 2 }}>
                <Typography>
                  <strong>{career.education}</strong>
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  Pathway: {career.pathway}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 2, fontWeight: "bold" }}
                >
                  Growth Outlook: {career.growth}
                </Typography>
              </Card>
            </Grid>

            {/* Kenyan Institutions */}
            {career.kenyan_institutions && (
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  🏫 Recommended Kenyan Institutions
                </Typography>
                <Card sx={{ p: 2 }}>
                  <List dense>
                    {career.kenyan_institutions.map((inst, idx) => (
                      <ListItem key={idx}>
                        <ListItemIcon>
                          <School color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={inst} />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
            )}

            {/* Skills */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                💪 Required Skills
              </Typography>
              <Card sx={{ p: 2 }}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {career.skills.map((skill, index) => (
                    <Chip
                      key={index}
                      label={skill}
                      color="primary"
                      variant="outlined"
                    />
                  ))}
                </Box>
              </Card>
            </Grid>

            {/* Career Outlook */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                💼 Career Outlook
              </Typography>
              <Card sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography>Demand:</Typography>
                  <Typography
                    fontWeight="bold"
                    color={
                      career.demand === "Very High"
                        ? "success"
                        : career.demand === "High"
                        ? "primary"
                        : "text.secondary"
                    }
                  >
                    {career.demand}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography>Salary Potential:</Typography>
                  <Typography
                    fontWeight="bold"
                    color={
                      career.salary === "Very High"
                        ? "success"
                        : career.salary === "High"
                        ? "primary"
                        : "text.secondary"
                    }
                  >
                    {career.salary}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography>Growth:</Typography>
                  <Typography fontWeight="bold" color="primary">
                    {career.growth}
                  </Typography>
                </Box>
              </Card>
            </Grid>

            {/* Match Reasons */}
            {career.reasons && (
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  🎯 Why This Career Matches
                </Typography>
                <Card sx={{ p: 2 }}>
                  <List dense>
                    {career.reasons.map((reason, index) => (
                      <ListItem key={index}>
                        <ListItemIcon>
                          <TrendingUp color="success" />
                        </ListItemIcon>
                        <ListItemText primary={reason} />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default EnhancedCareerInsights;
